window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]:not(.no-scroll)').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]').not('.video iframe');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.update = this.updateSelectors();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      var selectors_select = $(".current_option");

      $.each(selectors_select, function(ind, item) {

        if ($(item).attr("name") == "size") {

          $.each(currentOptions[0], function(key, value) {
            if (key == "value") {
              value = value.substring(0, value.length - 1);
              $(item).text(value);
            }
          });



        }
        //else if ($(item).attr("name") == "length") {

        //   $.each(currentOptions[1], function(key, value) {
        //     console.log("1 option");
        //     console.log("key/value", key+'/'+value);
        //     if (key == "value") {
        //       if ($(item).attr("data-length") == "true") {
        //         var value_length = value.split('/');
        //         $(item).text(value_length[1] + " " + value_length[0]);
        //       } else {
        //         $(item).text(value);
        //       }

        //     }
        //   });
        // }
      });

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      this.update = this.updateSelectors();

      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },


    // Update selectors when variant changes

    updateSelectors: function() {

      var $option0Select = $('.SingleOptionSelector-0', this.$container); // Fit
      var option0Index = $option0Select.data('index');

      var $option1Select = $('.SingleOptionSelector-1', this.$container); // Size
      var $option1Options = $option1Select.find('option');
      var option1Index = $option1Select.data('index');

      var option0Value = $option0Select.val();

      var option0ToCheck = {
        index: option0Index,
        value: option0Value,
      };

      for (var j = 0; j < $option1Options.length; j++) {

        var $option1 = $($option1Options[j]);
        var option1Value = $option1.val();

        var option1ToCheck = {
          index: option1Index,
          value: option1Value,
        };

        var selectedValues = [
          option0ToCheck,
          option1ToCheck
        ];

        var variant = this._checkOptionsAvaliable(selectedValues);

        var defaultValue = $option1.data('defaultValue');
        if (!defaultValue) {
          defaultValue = $option1.html();
          $option1.attr('data-default-value', defaultValue);
        }

        if (!variant || !variant.available) {
          $option1.attr('disabled', 'disabled');
          $option1.html(defaultValue + '- out of stock');
        } else {
          $option1.removeAttr('disabled');
          $option1.html(defaultValue);
        }

      }

    },

    _checkOptionsAvaliable: function(selectedValues) {
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    }

  });


  return Variants;
})();


/*================ Global ================*/
/*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {
  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function(qs) {
    qs = qs || document.location.search;

    if (!qs) {
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  updateQueryStringParameter: function(key, value, url) {
    if (!url) url = window.location.href;

    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null)
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
      else
        return url;
    }
  },

  getYoutubeId: function(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  },

  getProductJSON: function(handle, callback) {
    return $.get('/products/' + handle + '?view=json', null, callback, 'text');
  },

  getPromotions: function(handle, type) {

    var promotions = {};
    promotions.all = JSON.parse($('#promotions').html());

    if (!type) {
      return promotions.all;
    }

    promotions.filtered = [];

    for (var i = promotions.all.length - 1; i >= 0; i--) {
      var thisPromotion = promotions.all[i];
      if (thisPromotion[type][0] === true || !handle && thisPromotion[type] || handle && thisPromotion[type].indexOf(handle) > -1) {
        promotions.filtered.push(thisPromotion);
      }
    }

    return promotions.filtered;

  },

  // Returns content of template placed into snippets/js-tempales.liquid
  getTemplate: function(template) {
    return $('[data-template-for="' + template + '"]').html();
  },

  flash: function(elements, color, duration) {
    var opacity = 100;
    var color = color || '255, 255, 136';
    var duration = duration || 2000;
    var interval = setInterval(function() {
      opacity -= 2.5;
      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }
      $(elements).css({background: "rgba("+color+", "+opacity/100+")"});
    }, duration/40);
  },

  // Gets the rendered size of an image using object-fit
  getRenderedImgSize: function(contains, cWidth, cHeight, width, height, pos){
    var oRatio = width / height,
    cRatio = cWidth / cHeight;
    return function() {
      if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
        this.width = cWidth;
        this.height = cWidth / oRatio;
      } else {
        this.width = cHeight * oRatio;
        this.height = cHeight;
      }
      this.left = (cWidth - this.width)*(pos/100);
      this.right = this.width + this.left;
      return this;
    }.call({});
  },

  // Returns size info for an image rendered with object-fit
  getImgSizeInfo: function(img) {
    var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
    return theme.utils.getRenderedImgSize(true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      parseInt(pos[0]));
  },
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {

  if (isMobile.any) {
    theme.pageSwipeObject = new Hammer.Manager(document.getElementById('PageContainer'), {
      touchAction: 'auto',
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_HORIZONTAL
        }]
      ]
    });

    theme.pageSwipeObject.on('swiperight', function(evt) {
      if ($('body').hasClass('js-drawer-open-right')) {
        var $drawer = $('.drawer.drawer--right');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--left');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
      var startPosition = final_x - delta_x;
      if (startPosition >= 0 && startPosition <= 25) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });

    theme.pageSwipeObject.on('swipeleft', function(evt) {
      if ($('body').hasClass('js-drawer-open-left')) {
        var $drawer = $('.drawer.drawer--left');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--right');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.center.x || 0;
      var startPosition = final_x + -delta_x;
      var windowWidthOffset = $(window).width() - 25;
      if (startPosition >= windowWidthOffset) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });
  }

  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContent')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }


    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    // this.nodes.$page.on('touchmove.drawer', function() {
    //   return false;
    // });

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/*============================================================================
  Modal modules
==============================================================================*/
theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $(id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    // eslint-disable-next-line shopify/jquery-dollar-sign-reference
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal.addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', $.proxy(function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');
  };

  return Modal;
})();

(function() {
  var selectors = {
    tabHandles: '.tabs-menu a'
  };

  var classes = {
    qtySelector: 'js-qty-select'
  };

  var $tabHandles = $(selectors.tabHandles);

  if (!$tabHandles.length) {
    return;
  }

  $(selectors.tabHandles).click(function(e) {
    e.preventDefault();
    var $this = $(this);
    $this.parent().addClass("current");
    $this.parent().siblings().removeClass("current");
    var tab = $this.attr("href");
    $(".tab-content").not(tab).css("display", "none");
    $(tab).fadeIn();
  });
})();

/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.QuantitySelectors = (function() {
  var selectors = {
    qtyInputs: 'input[type="number"]',
    excludeInputs: '.js-qty-select input[type="number"]',
    qtySelector: '.js-qty-select',
    qtyButtonAdd: '.js-qty-select-add',
    qtyButtonSubtract: '.js-qty-select-sub',
  };

  var classes = {
    qtySelector: 'js-qty-select',
    qtyButtonAdd: 'js-qty-select-add',
    qtyButtonSubtract: 'js-qty-select-sub',
  };

  var $qtyInputs = $(selectors.qtyInputs).not(selectors.excludeInputs);

  if ($qtyInputs.length) {
    $qtyInputs.each( function(){
      var $el = $(this);
      init($el);
    });
  }

  $(document).on('click.qtySelector', selectors.qtySelector + ' button', function(evt) {
    evt.preventDefault();
    var $button = $(this);
    var $input = $button.siblings(selectors.qtyInputs);
    var oldValue = $input.val();
    var maxQty = parseInt($input.prop('max'));
    var minQty = parseInt($input.prop('min'));
    var newValue = minQty;

    if ($button.hasClass(classes.qtyButtonAdd)) {
      newValue = parseFloat(oldValue) + 1;
      if (maxQty && newValue >= maxQty) {
        $button.prop('disabled', true);
      }
    } else {
      if (oldValue > minQty) {
        newValue = parseFloat(oldValue) - 1;
        if (maxQty && newValue < maxQty) {
          $button.siblings(selectors.qtyButtonAdd).prop('disabled', false);
        }
      }
    }

    $input.val(newValue);
    $input.trigger('update.qtySelector');
  });

  function init($el) {
    if (!$el.length) {
      return false;
    }

    var $wrapper = $el.wrap( '<div class="' + classes.qtySelector + '"></div>' ).parent();
    var value = parseInt($el.val());
    var maxQty = parseInt($el.prop('max'));

    $wrapper.prepend('<button class="' + classes.qtyButtonSubtract + '">-</button>');

    if (maxQty == 1 && value == 1) {
      $wrapper.append('<button class="' + classes.qtyButtonAdd + '" disabled>+</button>');
    } else {
      $wrapper.append('<button class="' + classes.qtyButtonAdd + '">+</button>');
    }
  }

  return {
    init: init
  };
})();

(function() {
  var classes = {
    notificationHidden: 'notification-message--hidden'
  };

  var queryParams = theme.utils.getQueryParams();

  if (queryParams === undefined || queryParams.status === undefined) {
    return;
  }

  $('[data-notification="' + queryParams.status + '"]').removeClass(classes.notificationHidden);

})();

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function(currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function() {
    return jQuery.cookie(this.name);
  },
  destroy: function() {
    jQuery.cookie(this.name, null, this.configuration);
  }
};

Currency.moneyFormats = {
  "USD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} USD"
  },
  "EUR":{
    "money_format":"&euro;{{amount}}",
    "money_with_currency_format":"&euro;{{amount}} EUR"
  },
  "GBP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} GBP"
  },
  "CAD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} CAD"
  },
  "ALL":{
    "money_format":"Lek {{amount}}",
    "money_with_currency_format":"Lek {{amount}} ALL"
  },
  "DZD":{
    "money_format":"DA {{amount}}",
    "money_with_currency_format":"DA {{amount}} DZD"
  },
  "AOA":{
    "money_format":"Kz{{amount}}",
    "money_with_currency_format":"Kz{{amount}} AOA"
  },
  "ARS":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} ARS"
  },
  "AMD":{
    "money_format":"{{amount}} AMD",
    "money_with_currency_format":"{{amount}} AMD"
  },
  "AWG":{
    "money_format":"Afl{{amount}}",
    "money_with_currency_format":"Afl{{amount}} AWG"
  },
  "AUD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} AUD"
  },
  "BBD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} Bds"
  },
  "AZN":{
    "money_format":"m.{{amount}}",
    "money_with_currency_format":"m.{{amount}} AZN"
  },
  "BDT":{
    "money_format":"Tk {{amount}}",
    "money_with_currency_format":"Tk {{amount}} BDT"
  },
  "BSD":{
    "money_format":"BS${{amount}}",
    "money_with_currency_format":"BS${{amount}} BSD"
  },
  "BHD":{
    "money_format":"{{amount}}0 BD",
    "money_with_currency_format":"{{amount}}0 BHD"
  },
  "BYR":{
    "money_format":"Br {{amount}}",
    "money_with_currency_format":"Br {{amount}} BYR"
  },
  "BZD":{
    "money_format":"BZ${{amount}}",
    "money_with_currency_format":"BZ${{amount}} BZD"
  },
  "BTN":{
    "money_format":"Nu {{amount}}",
    "money_with_currency_format":"Nu {{amount}} BTN"
  },
  "BAM":{
    "money_format":"KM {{amount_with_comma_separator}}",
    "money_with_currency_format":"KM {{amount_with_comma_separator}} BAM"
  },
  "BRL":{
    "money_format":"R$ {{amount_with_comma_separator}}",
    "money_with_currency_format":"R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB":{
    "money_format":"Bs{{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP":{
    "money_format":"P{{amount}}",
    "money_with_currency_format":"P{{amount}} BWP"
  },
  "BND":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} BND"
  },
  "BGN":{
    "money_format":"{{amount}} лв",
    "money_with_currency_format":"{{amount}} лв BGN"
  },
  "MMK":{
    "money_format":"K{{amount}}",
    "money_with_currency_format":"K{{amount}} MMK"
  },
  "KHR":{
    "money_format":"KHR{{amount}}",
    "money_with_currency_format":"KHR{{amount}}"
  },
  "KYD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} KYD"
  },
  "XAF":{
    "money_format":"FCFA{{amount}}",
    "money_with_currency_format":"FCFA{{amount}} XAF"
  },
  "CLP":{
    "money_format":"${{amount_no_decimals}}",
    "money_with_currency_format":"${{amount_no_decimals}} CLP"
  },
  "CNY":{
    "money_format":"&#165;{{amount}}",
    "money_with_currency_format":"&#165;{{amount}} CNY"
  },
  "COP":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} COP"
  },
  "CRC":{
    "money_format":"&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format":"&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK":{
    "money_format":"{{amount_with_comma_separator}} kn",
    "money_with_currency_format":"{{amount_with_comma_separator}} kn HRK"
  },
  "CZK":{
    "money_format":"{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format":"{{amount_with_comma_separator}} K&#269;"
  },
  "DKK":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"kr.{{amount_with_comma_separator}}"
  },
  "DOP":{
    "money_format":"RD$ {{amount}}",
    "money_with_currency_format":"RD$ {{amount}}"
  },
  "XCD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"EC${{amount}}"
  },
  "EGP":{
    "money_format":"LE {{amount}}",
    "money_with_currency_format":"LE {{amount}} EGP"
  },
  "ETB":{
    "money_format":"Br{{amount}}",
    "money_with_currency_format":"Br{{amount}} ETB"
  },
  "XPF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"FJ${{amount}}"
  },
  "GMD":{
    "money_format":"D {{amount}}",
    "money_with_currency_format":"D {{amount}} GMD"
  },
  "GHS":{
    "money_format":"GH&#8373;{{amount}}",
    "money_with_currency_format":"GH&#8373;{{amount}}"
  },
  "GTQ":{
    "money_format":"Q{{amount}}",
    "money_with_currency_format":"{{amount}} GTQ"
  },
  "GYD":{
    "money_format":"G${{amount}}",
    "money_with_currency_format":"${{amount}} GYD"
  },
  "GEL":{
    "money_format":"{{amount}} GEL",
    "money_with_currency_format":"{{amount}} GEL"
  },
  "HNL":{
    "money_format":"L {{amount}}",
    "money_with_currency_format":"L {{amount}} HNL"
  },
  "HKD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"HK${{amount}}"
  },
  "HUF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr ISK"
  },
  "INR":{
    "money_format":"Rs. {{amount}}",
    "money_with_currency_format":"Rs. {{amount}}"
  },
  "IDR":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"Rp {{amount_with_comma_separator}}"
  },
  "ILS":{
    "money_format":"{{amount}} NIS",
    "money_with_currency_format":"{{amount}} NIS"
  },
  "JMD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} JMD"
  },
  "JPY":{
    "money_format":"&#165;{{amount_no_decimals}}",
    "money_with_currency_format":"&#165;{{amount_no_decimals}} JPY"
  },
  "JEP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} JEP"
  },
  "JOD":{
    "money_format":"{{amount}}0 JD",
    "money_with_currency_format":"{{amount}}0 JOD"
  },
  "KZT":{
    "money_format":"{{amount}} KZT",
    "money_with_currency_format":"{{amount}} KZT"
  },
  "KES":{
    "money_format":"KSh{{amount}}",
    "money_with_currency_format":"KSh{{amount}}"
  },
  "KWD":{
    "money_format":"{{amount}}0 KD",
    "money_with_currency_format":"{{amount}}0 KWD"
  },
  "KGS":{
    "money_format":"лв{{amount}}",
    "money_with_currency_format":"лв{{amount}}"
  },
  "LVL":{
    "money_format":"Ls {{amount}}",
    "money_with_currency_format":"Ls {{amount}} LVL"
  },
  "LBP":{
    "money_format":"L&pound;{{amount}}",
    "money_with_currency_format":"L&pound;{{amount}} LBP"
  },
  "LTL":{
    "money_format":"{{amount}} Lt",
    "money_with_currency_format":"{{amount}} Lt"
  },
  "MGA":{
    "money_format":"Ar {{amount}}",
    "money_with_currency_format":"Ar {{amount}} MGA"
  },
  "MKD":{
    "money_format":"ден {{amount}}",
    "money_with_currency_format":"ден {{amount}} MKD"
  },
  "MOP":{
    "money_format":"MOP${{amount}}",
    "money_with_currency_format":"MOP${{amount}}"
  },
  "MVR":{
    "money_format":"Rf{{amount}}",
    "money_with_currency_format":"Rf{{amount}} MRf"
  },
  "MXN":{
    "money_format":"$ {{amount}}",
    "money_with_currency_format":"$ {{amount}} MXN"
  },
  "MYR":{
    "money_format":"RM{{amount}} MYR",
    "money_with_currency_format":"RM{{amount}} MYR"
  },
  "MUR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} MUR"
  },
  "MDL":{
    "money_format":"{{amount}} MDL",
    "money_with_currency_format":"{{amount}} MDL"
  },
  "MAD":{
    "money_format":"{{amount}} dh",
    "money_with_currency_format":"Dh {{amount}} MAD"
  },
  "MNT":{
    "money_format":"{{amount_no_decimals}} &#8366",
    "money_with_currency_format":"{{amount_no_decimals}} MNT"
  },
  "MZN":{
    "money_format":"{{amount}} Mt",
    "money_with_currency_format":"Mt {{amount}} MZN"
  },
  "NAD":{
    "money_format":"N${{amount}}",
    "money_with_currency_format":"N${{amount}} NAD"
  },
  "NPR":{
    "money_format":"Rs{{amount}}",
    "money_with_currency_format":"Rs{{amount}} NPR"
  },
  "ANG":{
    "money_format":"&fnof;{{amount}}",
    "money_with_currency_format":"{{amount}} NA&fnof;"
  },
  "NZD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} NZD"
  },
  "NIO":{
    "money_format":"C${{amount}}",
    "money_with_currency_format":"C${{amount}} NIO"
  },
  "NGN":{
    "money_format":"&#8358;{{amount}}",
    "money_with_currency_format":"&#8358;{{amount}} NGN"
  },
  "NOK":{
    "money_format":"kr {{amount_with_comma_separator}}",
    "money_with_currency_format":"kr {{amount_with_comma_separator}} NOK"
  },
  "OMR":{
    "money_format":"{{amount_with_comma_separator}} OMR",
    "money_with_currency_format":"{{amount_with_comma_separator}} OMR"
  },
  "PKR":{
    "money_format":"Rs.{{amount}}",
    "money_with_currency_format":"Rs.{{amount}} PKR"
  },
  "PGK":{
    "money_format":"K {{amount}}",
    "money_with_currency_format":"K {{amount}} PGK"
  },
  "PYG":{
    "money_format":"Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN":{
    "money_format":"S/. {{amount}}",
    "money_with_currency_format":"S/. {{amount}} PEN"
  },
  "PHP":{
    "money_format":"&#8369;{{amount}}",
    "money_with_currency_format":"&#8369;{{amount}} PHP"
  },
  "PLN":{
    "money_format":"{{amount_with_comma_separator}} zl",
    "money_with_currency_format":"{{amount_with_comma_separator}} zl PLN"
  },
  "QAR":{
    "money_format":"QAR {{amount_with_comma_separator}}",
    "money_with_currency_format":"QAR {{amount_with_comma_separator}}"
  },
  "RON":{
    "money_format":"{{amount_with_comma_separator}} lei",
    "money_with_currency_format":"{{amount_with_comma_separator}} lei RON"
  },
  "RUB":{
    "money_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF":{
    "money_format":"{{amount_no_decimals}} RF",
    "money_with_currency_format":"{{amount_no_decimals}} RWF"
  },
  "WST":{
    "money_format":"WS$ {{amount}}",
    "money_with_currency_format":"WS$ {{amount}} WST"
  },
  "SAR":{
    "money_format":"{{amount}} SR",
    "money_with_currency_format":"{{amount}} SAR"
  },
  "STD":{
    "money_format":"Db {{amount}}",
    "money_with_currency_format":"Db {{amount}} STD"
  },
  "RSD":{
    "money_format":"{{amount}} RSD",
    "money_with_currency_format":"{{amount}} RSD"
  },
  "SCR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} SCR"
  },
  "SGD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} SGD"
  },
  "SYP":{
    "money_format":"S&pound;{{amount}}",
    "money_with_currency_format":"S&pound;{{amount}} SYP"
  },
  "ZAR":{
    "money_format":"R {{amount}}",
    "money_with_currency_format":"R {{amount}} ZAR"
  },
  "KRW":{
    "money_format":"&#8361;{{amount_no_decimals}}",
    "money_with_currency_format":"&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} LKR"
  },
  "SEK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr SEK"
  },
  "CHF":{
    "money_format":"SFr. {{amount}}",
    "money_with_currency_format":"SFr. {{amount}} CHF"
  },
  "TWD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TWD"
  },
  "THB":{
    "money_format":"{{amount}} &#xe3f;",
    "money_with_currency_format":"{{amount}} &#xe3f; THB"
  },
  "TZS":{
    "money_format":"{{amount}} TZS",
    "money_with_currency_format":"{{amount}} TZS"
  },
  "TTD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TTD"
  },
  "TND":{
    "money_format":"{{amount}}",
    "money_with_currency_format":"{{amount}} DT"
  },
  "TRY":{
    "money_format":"{{amount}}TL",
    "money_with_currency_format":"{{amount}}TL"
  },
  "UGX":{
    "money_format":"Ush {{amount_no_decimals}}",
    "money_with_currency_format":"Ush {{amount_no_decimals}} UGX"
  },
  "UAH":{
    "money_format":"₴{{amount}}",
    "money_with_currency_format":"₴{{amount}} UAH"
  },
  "AED":{
    "money_format":"Dhs. {{amount}}",
    "money_with_currency_format":"Dhs. {{amount}} AED"
  },
  "UYU":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} UYU"
  },
  "VUV":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}}VT"
  },
  "VEF":{
    "money_format":"Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT":{
    "money_format":"{{amount_no_decimals}} BTC",
    "money_with_currency_format":"{{amount_no_decimals}} BTC"
  },
  "XOF":{
    "money_format":"CFA{{amount}}",
    "money_with_currency_format":"CFA{{amount}} XOF"
  },
  "ZMW":{
    "money_format":"K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};

Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function(oldCurrency, newCurrency, selector, format) {
  if (newCurrency === undefined) {
    return;
  }

  $(selector || '.money').each(function() {
    // If the amount has already been converted, we leave it alone.
    if ($(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if ($(this).attr('data-currency-'+newCurrency)) {
      $(this).html($(this).attr('data-currency-'+newCurrency));
    }
    else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';

      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10)*100, oldCurrency, newCurrency);
      }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10)/10, oldCurrency, newCurrency);
      }
      else {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      $(this).html(newFormattedAmount);
      $(this).attr('data-currency-'+newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    $(this).attr('data-currency', newCurrency);
  });
  this.currentFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};

/*============================================================================
  Quantity DropDown view
==============================================================================*/
window.theme = window.theme || {};

theme.QuantityDropDown = (function() {
  var selectors = {
    qtyInputs: 'input[type="number"]',
    excludeInputs: '#cart input[type="number"]',
    parentSelector: '.cart__qty',
    dropdownQty: 'qty-dropdown'
  };

  var $qtyInputs = $(selectors.qtyInputs).not(selectors.excludeInputs);

  if ($qtyInputs.length) {
    $qtyInputs.each( function(){
      var $el = $(this);
      init($el);
    });
  }

  function init($el) {
    if (!$el.length) {
      return false;
    }

    // variables input
    var value = parseInt($el.val());
    var minQty = parseInt($el.prop('min'));
    var maxQty = parseInt($el.prop('max'));

    // after qty input add new selector tag with values

    $el.parents(selectors.parentSelector).append( '<select class="qty-dropdown"></select>' );

    for(var i = minQty; i <= maxQty; i++){
        var selected = '';
        if (i == value) {
          selected = 'selected';
        }

        var $i = $el.parents(selectors.parentSelector).find('.qty-dropdown').append('<option ' + selected + '>'+ [i] +'</option>');

    }

    $el.parents(selectors.parentSelector).find('.qty-dropdown').selectize({
        onChange: function(value){

          // updated value in qty input for updated Cart order list
          $el.val(value);

          var line_number = $(this.$input).parent().data('itemIndex');
          CartJS.updateItem(line_number, value);

        }
      });

    // // added plugin selectize
    // $('.qty-dropdown').selectize({
    //     onChange: function(value){

    //       // updated value in qty input for updated Cart order list
    //       $el.val(value);
    //     }
    // });

    //   // if `Out of stock`
    // if (maxQty < minQty){
    //     //alert('We only have ' + maxQty + ' of this item in stock');
    //     $('.qty-dropdown').addClass('disable');
    // }
  }

  return {
    init: init
  };
})();

/*============================================================================
  Form Post Submission Summary
==============================================================================*/
window.theme = window.theme || {};

theme.FormPostSummary = (function() {
  var selectors = {
    form: '[data-form-post-summary]',
  };

  function init() {
    $forms = $(selectors.form);
    for (var i = $forms.length - 1; i >= 0; i--) {
      _bindSubmitEvent($forms[i]);
    }
  }

  function _bindSubmitEvent($form) {

    $($form).one('submit',function(e){

      e.preventDefault();
      var formData = $(this).serialize();
      var id = $(this).attr('id');
      if ($(this).attr('data-datalayer-push') == 'true' &&
          $(this).attr('data-submit-event') &&
          $(this).find('#ContactFormStore').length) {
        let formInterestItemsChecked = $(this).find('input[id^=ContactFormInterested]:checked');
        let formInterestItemsArray = [];
        let formInterestItems = '';
        if (formInterestItemsChecked.length) {
          formInterestItemsChecked.each( function(){
            formInterestItemsArray.push($(this).attr('data-name'));
          });
          formInterestItems = formInterestItemsArray.join(", ");
        }
        window.dataLayer.push({
          'event': $(this).attr('data-submit-event'),
          'store': $(this).find('#ContactFormStore').val().replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g, " "),
          'items':  formInterestItems
        });
      }
      sessionStorage.setItem(id, formData);
      $(this).submit();

    });
  }

  function bindSubmitEvent($form) {
    return _bindSubmitEvent($form);
  }

  function _autofill($form) {

    var id = $($form).attr('id');
    var formData = sessionStorage.getItem(id);
    // sessionStorage.clear(id);
    if (formData) {
      $.each(formData.split('&'), function (index, elem) {
         var field = elem.split('=');
         var name = decodeURIComponent(field[0]);
         var value = decodeURIComponent(field[1]);
         $("[name='" + name + "']").val(value);
      });
      $($form).attr('data-form-post-summary-autofilled', true);
    }

  }

  function _getData($form) {

    var id = $($form).attr('id');
    var formData = sessionStorage.getItem(id);
    // sessionStorage.clear(id);
    var formDataObj = {};
    if (formData) {
      $.each(formData.split('&'), function (index, elem) {
         var field = elem.split('=');
         var name = decodeURIComponent(field[0]);
         var value = decodeURIComponent(field[1]);
         formDataObj[name] = value;
      });
      return formDataObj;
    }
    return false;

  }

  function autofill($form) {
    return _autofill($form);
  }

  function getData($form) {
    return _getData($form);
  }

  init();

  return {
    autofill: autofill,
    bindSubmitEvent: bindSubmitEvent,
    getData: getData
  };
})();

/*============================================================================
  Wishlist
  For Wishlist King App
==============================================================================*/
window.theme = window.theme || {};

theme.Wishlist = (function() {

  var selectors = {
    addToWishlist: '.add-to-wishlist',
  };

  var cache = {
    buttons: [],
    isInit: false
  };

  // Keep a reference to "add to wishlist" buttons
  function _cacheButtons() {
    cache.buttons = document.querySelectorAll(selectors.addToWishlist);
  }

  // Set button initial state
  function _setInitialState(el) {
    var productId,
        product;

    productId = el.dataset.productId;
    product = Appmate.wk.getProduct(productId);

    if (product) {
      el.dataset.inWishlist = true;
    }

  }

  // Bind event
  function _bind(el) {
    el.addEventListener('click', _toggleProduct);
  }

  // Unbind event
  function _unbind(el) {
    el.removeEventListener('click', _toggleProduct);
  }

  // Add or remove product from wishlist
  function _toggleProduct() {

    var el,
        productId,
        oldState,
        newState;

    el = event.currentTarget;
    productId = el.dataset.productId;

    oldState = el.dataset.inWishlist || false;
    newState = !(oldState == 'true');

    el.dataset.inWishlist = newState;

    NProgress.start();

    console.info('start');

    if (!productId) {
      console.error(new Error('No product id'));
      return;
    }

    Appmate.wk.toggleProduct(productId)
    .then(function(data){

      console.info('complete');
      // Update all elements with same product-id
      _.forEach(cache.buttons, function(elem, i) {
        if (elem.dataset.productId == productId) {
          elem.dataset.inWishlist = newState;
        }
      });

      NProgress.done();

    })
    .catch(function(err) {

      console.info('error');
      el.dataset.inWishlist = oldState;
      console.error(err);
      NProgress.done();

    });

  }

  // Initialise and prepare buttons
  function init() {

    if (typeof Appmate === 'undefined' || cache.isInit) {
      return;
    }

    if(!Appmate || !Appmate.wk || !Appmate.wk.version) { // version isn't defined until Appmate is ready to run
      return;
    }

    cache.isInit = true;
    _prepare();

  }

  // set initial state and bind
  function _prepare() {

    _cacheButtons();

    if (!cache.buttons.length) {
      return;
    }

    _.forEach(cache.buttons, function(el, i) {
      _bind(el);
      _setInitialState(el);
    })

  }

  // Clear events and reinitialise
  function update() {

    if (typeof Appmate === 'undefined' || !cache.isInit) {
      return;
    }

    _.forEach(cache.buttons, function(el, i) {
      _unbind(el);
    });

    _prepare();

  }

  return {
    init: init,
    update: update
  };

})();


/*================ Modules ================*/
window.theme = window.theme || {};

theme.cache = {
  products: []
},

theme.campaigns = (function() {

  function DiscountCampaign(deal, selector, counter, requirement, id, url) {
    this.deal = deal;
    this.selector = selector;
    this.counter = counter;
    this.requirement = requirement;
    this.id = id;
    this.url = url;

    var self = this;

    this.getApplicableProducts = function(cart, currentProduct) {
      var self = this;
      var applicableItems = [];
      if(currentProduct) {
        var cartItemsWithProductID = _.filter(cart.items, function(item) {
          return item.product_id == currentProduct.id;
        })
        if(!cartItemsWithProductID.length) {
          applicableItems = _.filter([currentProduct], function(item) {
            return self.selector.match(item, self.id, true);
          });
        } else {
          applicableItems = _.filter(cartItemsWithProductID, function(item) {
            return self.selector.match(item, self.id);
          });
        }
      } else {
        applicableItems = _.filter(cart.items, function(item) {
          return self.selector.match(item, self.id);
        });
      }
      if(!applicableItems.length) {
      }

      return applicableItems;
    };

    this.buildCartMessage = function(cart, messageMethod, currentProduct) {
      console.log("buildCartMessage running ...")
      function buildMessage() {
        var lineItems = self.getApplicableProducts(cart, currentProduct);
        var count = self.counter.returnCount(lineItems);
        var requirementMet = self.requirement.met(count);
        // Prioritise higher value dsicounts until they are met
        // var campaignIndex =  _.findIndex(theme.campaigns, {'id': self.id});
        // var priority = theme.campaigns.length - campaignIndex;

        // Prioritise lower value discounts until they are met
        var priority = _.findIndex(theme.campaigns, {'id': self.id});
        if (!requirementMet && lineItems.length > 0) {
          countForMessage = self.requirement.message(count);
          messageMethod(countForMessage, self.id, false, priority, self.url, self.requirement.min, count);
        }
      }

      var dealIfExistsInCart = self.deal.checkIfDealExists(cart.items);
      if (!dealIfExistsInCart) {
        self.selector.getProducts(buildMessage);
      }

    };
  }

  function QuantityCounter() {

    this.returnCount = function(lineItems) {
      var count = 0;
      _.each(lineItems, function(lineItem) {
        count += lineItem.quantity;
      });
      return count;
    };
  }

  function SuitCounter(tags, price) {
    this.trouserTag = tags[0];
    this.jacketTag = tags[1];
    this.suitTag = tags[2];
    this.price = price;

    this.returnCount = function(lineItems) {
      var self = this;

      var count = 0;
      var trousers = [];
      var jackets = [];

      _.each(lineItems, function(lineItem) {

        var productHandle = lineItem.handle;
        var product = _.find(window.theme.cache.products, {handle: productHandle});
        var i = lineItem.quantity;

        if (product.tags.indexOf(self.trouserTag) > -1) {
          while (i > 0) {
            // trousers.push(lineItem.price);
            count =+ lineItem.quantity * 0.5;
            i =- 1;
          }
        }

        if (product.tags.indexOf(self.jacketTag) > -1) {
          while (i > 0) {
            // jackets.push(lineItem.price);
            count =+ lineItem.quantity * 0.5;
            i =- 1;
          }
        }

        if (product.tags.indexOf(self.suitTag) > -1) {
          if (lineItem.price > self.price) {
            count =+ lineItem.quantity;
          }
        }

      });

      // _.each(jackets, function(jacket){
      //   _.each(trousers, function(trouser, index) {

      //     var combinedPrice = jacket + trouser;
      //     if (combinedPrice > self.price) {
      //       count =+ 1;
      //       trousers.splice(index, 1);
      //     }

      //   });
      // });

      return count;
    };
  }

  function PriceAndTagsSelector(condition, price, tags, count) {
    this.condition = condition;
    this.price = price;
    this.tags = tags;
    this.requestComplete = false;

    this.getProducts = function(callback) {
      var self = this;

      if (!self.requestComplete) {

        var requestsComplete = 0;
        var requestsTodo = self.tags.length;

        _.each(tags, function(tag){

          $.ajax({
            url: '/collections/all/' + tag + '?view=json'
          }).done(function(data) {
            window.theme.cache.products = window.theme.cache.products.concat(JSON.parse(data));

            requestsComplete += 1;

            if (requestsTodo == requestsComplete) {
              self.requestComplete = true;

              if (typeof callback == "function") {
                callback();
              }

            }
          });

        });

      } else {
        if (typeof callback == "function") {
          callback();
        }
      }
    };

    this.match = function(lineItem, campaignID, isCurrentProduct) {
      var self = this;

      var productHandle = lineItem.handle;
      var product = isCurrentProduct ? lineItem :  _.find(window.theme.cache.products, {handle: productHandle});
      var match = false;
      if (product) {
         var containsTag = product.tags.some(function (x) {
          return self.tags.some(function (y) {
            return y === x;
          });
        });
         if (!containsTag) {
           match = false;
           return match;
         }
        // if (product.tags.indexOf('sale') == -1 && !(product.compare_at_price_max_cents && product.compare_at_price_max_cents > product.price_cents)) {
        //   switch(this.condition) {
        //     case 'greater_than':
        //       if (lineItem.original_price > this.price) {
        //         match = true;
        //       }
        //       break;
        //     case 'less_than':
        //       if (lineItem.original_price < this.price) {
        //         match = true;
        //       }
        //       break;
        //   }

        // }
        // todo: old flow for existing line item
        var originalPrice = lineItem.original_price || lineItem.price;
        switch(this.condition) {
          case 'greater_than':
            if (originalPrice > this.price) {
              match = true;
            }
            break;
          case 'less_than':
            if (originalPrice < this.price) {
              match = true;
            }
            break;
        }

        // new flow for current product


        // Do not include products in a bundle
        if (lineItem.properties && lineItem.properties._discount_bundle == true) {
          match = (match && _checkCampaignIsHigherPriority(lineItem, campaignID));
        }

        return match;
      }
    };
  }

  function TagsSelector(tags) {
    this.tags = tags;
    this.requestComplete = false;

    this.getProducts = function(callback) {
      var self = this;

      if (!self.requestComplete) {

        var requestsComplete = 0;
        var requestsTodo = self.tags.length;

        _.each(tags, function(tag){

          $.ajax({
            url: '/collections/all/' + tag + '?view=json'
          }).done(function(data) {
            window.theme.cache.products = window.theme.cache.products.concat(JSON.parse(data));

            requestsComplete += 1;

            if (requestsTodo == requestsComplete) {
              self.requestComplete = true;

              if (typeof callback == "function") {
                callback();
              }

            }
          });

        });

      } else {
        if (typeof callback == "function") {
          callback();
        }
      }
    };

    this.match = function(lineItem, campaignID) {
      var self = this;

      var productHandle = lineItem.handle;
      var product = _.find(window.theme.cache.products, {handle: productHandle});
      var match = false;

      if (product) {
        if (product.tags.indexOf('sale') == -1 && !(product.compare_at_price_max_cents && product.compare_at_price_max_cents > product.price_cents) && !lineItem?.discounts?.length) {
          _.each(tags, function(tag){
            if (product.tags.indexOf(tag) > -1) {
              match = true;
              return false; // Break _.each loop
            }
          });
        }

        // Do not include products in a bundle
        if (lineItem.properties && lineItem.properties._discount_bundle == true) {
          match = (match && _checkCampaignIsHigherPriority(lineItem, campaignID));
        }

        return match;
      }
    };
  }

  function MinProductsMessage(min, message, savings) {
    this.min = min;
    this._message = message;
    this.savings = savings;

    this.met = function(count) {
      return count >= min;
    };

    this.message = function(count, savings) {
      var remaining = this.min - count;

      if (remaining == 0 || count == 0) {
        return;
      }

      var message = this._message;

      message = message.replace('{count}', remaining);
      message = message.replace('{savings}', this.savings);

      if (remaining == 1) {
        message = message.replace(new RegExp('{s}', 'g'), '');
      } else {
        message = message.replace(new RegExp('{s}', 'g'), 's');
      }

      return message;
    };

  }

  function SavingsDeal(savings) {
    this.savings = savings;

    this.checkIfDealExists = function(lineItems) {
      var self = this;

      var dealFound = false;

      _.each(lineItems, function(lineItem) {

          _.each(lineItem.discounts, function(discount) {

            if (discount.amount == self.savings) {
              dealFound = true;
              return false; // edit _.each loop
            }
          });
      });

      return dealFound;
    };
  }

  function _checkCampaignIsHigherPriority (lineItem, campaignID) {

    if (lineItem.properties && lineItem.properties._discount_bundle == true && lineItem.properties._discount_id) {

      // Current campaign (current match)
      var campaignIndex = _.findIndex(theme.campaigns, {'id': campaignID});

      // Found campaign (What is applied to the lineitem)
      var foundCampaignID = lineItem.properties._discount_id;
      var foundCampaignIndex = _.findIndex(theme.campaigns, {'id': foundCampaignID});

      if (foundCampaignIndex == -1) {
        return true;
      }

      // Reject if campaign applied is a higher priority than this campaign
      if (campaignIndex <= campaignIndex) {
         return false;
      }

    }

    return true;
  }

  // List higher priority campaigns to display last
  var campaigns = [

    // Purchase 2x Chinos or jeans + 2x shirts and save $120
    // new DiscountCampaign (
    //   new SavingsDeal(7000),
    //   new PriceAndTagsSelector('greater_than', 10000, ["bundle:ch+sh-pants","bundle:ch+sh-shirt"]),
    //   new QuantityCounter(),
    //   new MinProductsMessage(4, 'Buy 2 Chinos or Jeans + 2 Shirts, Save $120', '$120'),
    //   '2ch+2sh',
    //   '/collections/shirts-chinos', 'Add {count} more item(s) to complete the bundle!'
    // ),

    // // Buy 4 save $100
    // new DiscountCampaign (
    //   new SavingsDeal(10000),
    //   new PriceAndTagSelector('greater_than', 10000, "bundle:promo-one"),
    //   new QuantityCounter(),
    //   new MinProductsMessage(4, 'Add {count} more shirt{s}, trouser{s} or jacket{s} to your cart and save {savings}', '$100'),
    //   'buy-4-items-save-100'
    // ),

    // Buy 3 items, save $70
    new DiscountCampaign (
      new SavingsDeal(7000),
      new PriceAndTagsSelector('greater_than', 0, ["bundle:promo-one"]),
      new QuantityCounter(),
      new MinProductsMessage(3, 'Buy 3 Items, Save $70', '$70'),
      'buy-3-items-save-70',
      '/collections/buy-3-items-save-70'
    ),

      // Buy 3 socks, save $20
      new DiscountCampaign (
        new SavingsDeal(2000),
        new PriceAndTagsSelector('greater_than', 0, ["bundle:sock"]),
        new QuantityCounter(),
        new MinProductsMessage(3, 'Buy 3 socks, Save $20', '$20'),
        'buy-3-items-save-20',
        '/collections/socks'
    ),


      //Buy Blazer, pants & shirt, Save $120
      new DiscountCampaign (
      new SavingsDeal(12000),
      new PriceAndTagsSelector('greater_than', 0, ["bundle:blazerpack-blazer","bundle:blazerpack-shirt","bundle:blazerpack-pants"]),
      new QuantityCounter(),
      new MinProductsMessage(3, 'Buy Blazer, Pants & Shirt, Save $120', '$120'),
      'blazerpack',
      '/collections/buy-the-look'
    ),

    //Buy 2 shorts, save $50

    new DiscountCampaign (
      new SavingsDeal(5000),
      new PriceAndTagsSelector('greater_than', 0, ["bundle:shorts"]),
      new QuantityCounter(),
      new MinProductsMessage(2, 'Buy 2, save $50', '$50'),
      'buy-2-items-save-50',
      '/collections/buy-2-items-save-50'
    ),

    // Polos $99 when you buy 2 or more.

    new DiscountCampaign (
        new SavingsDeal(9900),
        new PriceAndTagsSelector('greater_than', 0, ["bundle:polo"]),
        new QuantityCounter(),
        new MinProductsMessage(2, 'Polos, $99 each when you buy 2 or more', '$99'),
        'buy-2-items-save-99-next',
        '/collections/polos-tees'
    )



    // Purchase 1x Chinos or jeans + 1x shirts and save $50
    // new DiscountCampaign (
    //   new SavingsDeal(7000),
    //   new PriceAndTagsSelector('greater_than', 10000, ["bundle:ch+sh-pants","bundle:ch+sh-shirt"]),
    //   new QuantityCounter(),
    //   new MinProductsMessage(2, 'Buy 1 Chinos or Jeans + 1 Shirt, Save $50', '$50'),
    //   '1ch+1sh',
    //   '/collections/shirts-chinos'
    // ),

    // // Buy 2 save $40
    // new DiscountCampaign (
    //   new SavingsDeal(4000),
    //   new PriceAndTagSelector('greater_than', 10000, "bundle:promo-one"),
    //   new QuantityCounter(),
    //   new MinProductsMessage(2, 'Add {count} more shirt{s}, trouser{s} or jacket{s} to your cart and save {savings}', '$40'),
    //   'buy-2-items-save-40'
    // )
    //

    // Buy Blazer + Shirt + Pants (includes chinos, jeans tailored trousers) = save $150
    // new DiscountCampaign (
    //   new SavingsDeal(15000),
    //   new PriceAndTagsSelector('greater_than', 0, ["bundle:blazerpack-blazer","bundle:blazerpack-shirt","bundle:blazerpack-pants"]),
    //   new QuantityCounter(),
    //   new MinProductsMessage(3, 'Buy Blazer + Shirt + Pants, Save $150', '$150'),
    //   'blazerpack',
    //   ''
    // ),

    // Buy 2 suits, save $200
    // new DiscountCampaign (
    //   new SavingsDeal(20000),
    //   new TagsSelector(['bundle:promo-two-trouser','bundle:promo-two-jacket','bundle:promo-two-suit']),
    //   new SuitCounter(['bundle:promo-two-trouser','bundle:promo-two-jacket','bundle:promo-two-suit'], 59999),
    //   // new MinProductsMessage(2, 'Add {count} more suit{s} and save {savings}', '$200'),
    //   new MinProductsMessage(2, 'Buy 2 Suits, Save $200', '$200'),
    //   'buy-2-suits-save-200',
    //   '/collections/suits'
    // ),

  ];

  return campaigns;

})();

theme.CartMessages = (function() {

  function CartMessages() {
    var self = this;
    this._bind();
  }

  CartMessages.prototype = $.extend({}, CartMessages.prototype, {

    messages: [

    ],

    _bind: function() {
      var self = this;

      $(document).on('cart.ready', function(event, cart) {
        self._clearMessages();
        self._findPotentialDiscounts(cart);
      });

      $(document).on('cart.requestComplete', function(event, cart) {
        self._clearMessages();
        self._findPotentialDiscounts(cart);
      });
    },

    _newMessage: function(body, id, persistent, priority, url) {

      if (!body) {
        console.error('Message requires a body');
        return;
      }

      priority = priority || 0;

      var message = {
        body: body,
        id: id,
        priority: priority,
        url: url
      };

      if (typeof persistent == "boolean") {
        message.persistent = persistent;
      }

      /*
        When multiple items are added to cart the deal with the
        lowest value that is applicable should be displayed in
        the cart promo block.
      */

      if (this.messages.length && this.messages[0].priority >= priority) {
        return;
      }

      this._clearMessages();

      var messageIndex = _.findIndex(this.messages, {'id': id});

      if (messageIndex == -1) {
        this.messages.push(message);
      } else {
        this.messages[messageIndex] = message;
      };


    },

    _clearMessages: function(force) {

      if (typeof force != "undefined" && force == true) {
        this.messages = [];
      } else {
        this.messages = _.filter(this.messages, function(n) {
          return n.persistent;
        });
      }

    },

    _findPotentialDiscounts: function(cart) {

      var newMesage = this._newMessage.bind(this);
      var campaigns = window.theme.campaigns;

      _.each(campaigns, function(campaign, index) {
        campaign.buildCartMessage(cart, newMesage);
      });

    }

  });

  return CartMessages;

})();

theme.cartMessages = new theme.CartMessages();

window.theme = window.theme || {};

// theme.AjaxCart = (function() {
//   var selectors = {
//     addToCartBtn: '[type="submit"]',
//     addToCartForm: 'form[action="/cart/add"]',
//     cartCount: '.site-header__cart',
//     cartToggle: '.cart__toggle',
//     cartDrawer: '.cart-drawer',
//     cartDrawerOpen: '.cart-drawer--open'
//   };

//   var settings = {
//     // 'aboveForm' for top of add to cart form,
//     // 'belowForm' for below the add to cart form,
//     // 'nextButton' for next to add to cart button and
//     // 'afterBody' for after the main body content (used for fixed notifications).
//     feedbackPosition: 'afterBody'
//   };

//   var options = {
//     requestBodyClass: 'cart-loading',
//     moneyFormat: window.shop.moneyFormat,
//     moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
//     weightUnit: 'kg', // g, kg, oz, lb
//     weightPrecision: 0,
//     tinybindModels: {
//       'customer': window.shop.customer,
//       'messages': window.theme.cartMessages
//     }
//   };

//   var cache = {
//     previousCartItems: [],
//     updatedItems: []
//   };

//   function init() {
//     if (!$(selectors.cartDrawer).length) {
//       return;
//     }

//     tinybind.formatters.and = function(value1, value2) {
//       return value1 && value2;
//     };

//     tinybind.formatters.andnot = function(value1, value2) {
//       return value1 && !value2;
//     };

//     tinybind.formatters.replace = function(value, search, replace) {
//       return value.replace(search, replace);
//     };

//     tinybind.formatters.handle = function(string) {
//       return theme.utils.handleize(string);
//     };

//     tinybind.formatters.startsWith = function(value, prefix) {
//       return value.indexOf(prefix) === 0;
//     };

//     tinybind.formatters.endsWith = function(value, suffix) {
//       return value.indexOf(suffix, value.length - suffix.length) !== -1;
//     };

//     tinybind.formatters.log = function(value) {
//       console.log(value);
//       return value;
//     };

//     tinybind.formatters.tel_link = function(value) {
//       return 'tel:' + value.replace(/\ /g, '');
//     };

//     tinybind.formatters.img = function(value) {

//       if (!value) {
//         return;
//       }

//       var maxWidth,
//           maxHeight,
//           imgTemplateURL,
//           imgString;

//       imgTemplateURL = slate.Image.getSizedImageUrl(value.src, '{width}x');

//       maxWidth = value.width + 'px';
//       maxHeight = value.height + 'px';

//       imgString = '<img loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" style="max-width: ' + maxWidth + '; max-height: ' + maxHeight + ';" data-sizes="auto" data-src="' + imgTemplateURL + '"/>'

//       return imgString;

//     };

//     tinybind.binders.selected = function(el, value) {
//       if (value) {
//         el.selected = 'selected';
//       }
//     };

//     tinybind.formatters.size = function(a) {
//       return _.size(a);
//     };

//     tinybind.formatters.length = tinybind.formatters.size;

//     tinybind.binders['scroll-to'] = function(el, value) {
//       if (!value) {
//         return;
//       }

//       setTimeout(function(){

//         var parentEl = el.parentElement, overflowStyle;
//         var i = 3;
//         try {
//           while(i--) {
//             overflowStyle =  window.getComputedStyle(parentEl, null).getPropertyValue('overflow');
//             if (overflowStyle == 'auto' || overflowStyle == 'scroll') {
//               $(parentEl).scrollTo(el, {
//                 duration: 500,
//                 interrupt: !isMobile.apple.device,
//                 offset: -20
//               });
//               return;
//             }
//             parentEl = parentEl.parentElement;
//           }
//         } catch(e) {}
//       }, 500)

//     };

//     tinybind.formatters.variantOptions = function(value) {

//       var isFit = false;
//       var options = '';
//       var option1 = value[0];
//       var option2 = value[1];

//       switch(option1) {
//         case 'R':
//           isFit = true;
//           option1 = 'Regular';
//           break;
//         case 'S':
//           isFit = true;
//           option1 = 'Short';
//           break;
//         case 'T':
//           isFit = true;
//           option1 = 'Tall';
//           break;
//         }

//         if (isFit) {
//           options = 'Fit: ' + option1;
//         } else {
//           options = option1;
//         }

//         if (value[1]) {
//           options = options + ' / ';

//           if (typeof parseInt(option2) == 'number') {
//             options = options + 'Size: ' + option2;
//           } else {
//             options = options + option2;
//           }

//         }

//       return options;
//     };

//     $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function(){
//       var $this = $(this);
//       var progressElementSelector = $this.data('progress-element');
//       var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;

//       if (!$this.is('.disabled')) {
//         if ($progressElement.length) {
//           $progressElement.addClass('cart-loader loading');
//         }

//         if ($this.is('[data-opens-cart-drawer]')) {
//           $('body').addClass('cart-loading--opens-drawer');
//         }
//       } else {
//         evt.preventDefault();
//         evt.stopPropagation();

//         $progressElement.addClass('error');
//         window.setTimeout(function(){
//           $progressElement.removeClass('error');
//         }, 1500);

//         var highlightElements = $this.data('enable-requirements');
//         if (highlightElements) {
//           theme.utils.flash(highlightElements);
//         }
//       }
//     });

//     initDrawer();

//     // Override CartJS error handling
//     // Uses extra code from https://github.com/discolabs/cartjs/issues/68#issuecomment-261418409
//     CartJS.errorHandling = {
//       cartError: function(error) {
//         $('.cart-loader.loading').removeClass('loading');
//         showFeedback('error', error.description);
//       }
//     };

//     CartJS.init(window.shop.cart, options);

//     $('.cart-drawer__submit').click(function(){
//       $(document.body).addClass('checkout-activated');
//     });

//     $(document).on('cart.requestStarted', function(event, cart) {
//       cache.previousCartItems = cart.items;

//       if ('NProgress' in window) {
//         NProgress.start();
//       }
//     });

//     $(document).on('cart.requestComplete', function(event, cart) {
//       if ('NProgress' in window) {
//         NProgress.done();
//       }

//       $('.cart-loader.loading').removeClass('loading');

//       cache.updatedItems = cart.updatedLineItems;

//       shop.cart = cart;

//       if (theme.Favicon !== undefined) {
//         if (cart.item_count > 0) {
//           theme.Favicon.set(cart.item_count);
//         } else {
//           theme.Favicon.reset();
//         }
//       }

//       var opensDrawer = $('body').is('.cart-loading--opens-drawer');

//       if (opensDrawer !== undefined && opensDrawer) {
//         if ((theme.cartQueue === undefined || theme.cartQueue.length == 0) && theme.cartQueueProcessing == false) {
//           if (!theme.CartDrawer.drawerIsOpen) {
//             $('body').removeClass('cart-loading--opens-drawer');
//             theme.CartDrawer.open();
//           }
//         }
//       }

//       if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1) {
//         window.setTimeout(function(){
//           theme.CartDrawer.close();
//         }, 2500);
//       }
//     });
//   }

//   function initDrawer() {
//     $('#PageContent').addClass('drawer-page-content');
//     $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

//     theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
//       onDrawerOpen: cartDrawerOpen
//     });
//   }

//   function cartDrawerOpen() {
//     // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
//   }

//   function cartDrawerClose() {
//     // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
//   }

//   function showFeedback(status, response, $addToCartForm) {
//     $('.ajax-cart-feedback').remove();
//     var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';

//     if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
//       switch (settings.feedbackPosition) {
//         case 'aboveForm':
//           $addToCartForm.before(feedback);
//           break;
//         case 'belowForm':
//           $addToCartForm.after(feedback);
//           break;
//         case 'afterBody':
//           $(document.body).append(feedback);
//           break;
//         case 'nextButton':
//         default:
//           $addToCartForm.find(selectors.addToCartBtn).after(feedback);
//           break;
//       }
//     } else {
//       iziToast.show({
//         message: response,
//         color: 'red',
//         position: 'bottomCenter'
//       });
//     }

//     var $feedbackElement = $('.ajax-cart-feedback');

//     $feedbackElement.offset(); // redraw
//     $feedbackElement.addClass('active');
//     window.setTimeout(function(){
//       $feedbackElement.removeClass('active');
//     }, 6500);
//   };

//   return {
//     init: init
//   };
// })();

// theme.AjaxCart.init();

// theme.cartQueue = [];
// theme.cartQueueProcessing = false;
// theme.processCartQueue = function() {
//   // If there's something in the queue, process it
//   if (theme.cartQueue.length) {
//     theme.cartQueueProcessing = true;
//     var request = theme.cartQueue.shift();
//     var requestType = request.type || 'add';

//     if (requestType == 'add') {
//       CartJS.addItem(request.variant_id, request.quantity, request.properties, {
//         "success": function(data, textStatus, jqXHR) {
//           theme.processCartQueue();
//         }
//       });
//     } else if (requestType == 'update') {
//       CartJS.updateItem(line_number, quantity, properties = {}, options = {})
//     } else {
//       // CartJS.removeItem(line_number, options = {})
//     }


//     ShopifyAPI.addItem(request.variant_id, request.quantity, request.properties, ShopifyAPI.processQueue, requestType);
//   }
//   else {
//     theme.cartQueueProcessing = false;
//   }
// };

window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '.site-nav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link, .site-nav__grandchild-link, .site-nav__childlist-footer .btn',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavChildLinkWithChildren: '.site-nav__child-link--parent',
  };

  var config = {
    hoverClass: 'site-nav--hover',
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    submenuVisibleOnHover: true,
    firstParentClickNavigates: true, // Overridden for mobile devices
    secondParentClickClosesSubmenu: false, // Relies on previous option being disabled for non-mobile devices
  };

  var cache = {
    isMobile: isMobile.any
  };

  function init() {
    cacheSelectors();

    if (config.submenuVisibleOnHover && cache.isMobile == false) {
      cache.$parents.on('mouseenter.siteNav', function(evt) {
        var $el = $(this);
        showDropdown($el);
      });

      cache.$parents.on('mouseleave.siteNav', function(evt) {
        var $el = $(this);
        hideDropdown($el);
      });
    }

    if (cache.$nav.is('[data-disable-parent-navigation]')) {
      // Override standard click events
      cache.$childLinksWithChildren.on('click.siteNav', function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      });
      config.firstParentClickNavigates = false;
      config.secondParentClickClosesSubmenu = true;
    }

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (config.firstParentClickNavigates && cache.isMobile == false) {
        return;
      }

      if (config.secondParentClickClosesSubmenu || !config.secondParentClickClosesSubmenu && !$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      if (config.secondParentClickClosesSubmenu && $el.hasClass(config.activeClass)) {
        hideDropdown($el);
        return;
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = _.assignIn({}, cache, {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $childLinksWithChildren: $(selectors.siteNavChildLinkWithChildren),
    });
  }

  function showDropdown($el) {
    $el.addClass(config.hoverClass);
    var dropdownActivationDelay = cache.isMobile ? 0 : 150;

    setTimeout(function() {
      if ($el.hasClass(config.hoverClass) || cache.isMobile) {
        $el.addClass(config.activeClass);

        // close open dropdowns
        if (cache.$activeDropdown.length) {
          hideDropdown(cache.$activeDropdown);
        }

        cache.$activeDropdown = $el;

        // set expanded on open dropdown
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

        $(window).on('keyup.siteNav', function(evt) {
          if (evt.keyCode === 27) {
            hideDropdown($el);
          }
        });

        $(selectors.body).on('click.siteNav', function() {
          hideDropdown($el);
        });
      } else {
        hideDropdown($el);
      }
    }, dropdownActivationDelay);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);
    $el.removeClass(config.hoverClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 767px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContent'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var headerHeight = cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$pageContainer.addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, 0, 0)',
      'padding-top': headerHeight + 'px'
    });

    cache.$pageContainer.css({
      overflow: 'hidden',
      height: cache.$mobileNavContainer.outerHeight() + 'px'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
        .find('.' + classes.navLinkWrapper + ':first')
        .find('.' + classes.navLink),
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$pageContainer.removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(-100%, 0, 0)'
    });

    cache.$pageContainer.css({
      overflow: 'auto',
      height: 'auto'
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .prepareTransition()
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu[0].scrollHeight;
    if (!target) {
      translateMenuHeight = $targetMenu.outerHeight();
    }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    var newContainerHeight = translateMenuHeight + cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;
    cache.$mobileNavContainer
      .css('height', newContainerHeight + 'px')
      .removeClass(classes.thirdNavShowing)
      .addClass('is-transitioning')
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        if ($elementToFocus.length > 1) {
          slate.a11y.trapFocus({
            $container: $targetMenu,
            $elementToFocus: $elementToFocus,
            namespace: 'subNavFocus'
          });
        } else {
          slate.a11y.trapFocus({
            $container: cache.$sectionHeader,
            $elementToFocus: cache.$mobileNav
              .find('.' + classes.navLinkWrapper + ':first')
              .find('.' + classes.navLink),
            namespace: 'navFocus'
          });
        }

        cache.$mobileNavContainer.off('.subnavToggle');
        cache.$mobileNavContainer.removeClass('is-transitioning');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      overflow: 'hidden',
      height: newContainerHeight + 'px'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.js-search-toggle',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    pageContent: '#PageContent'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
    mobileSearchIsOpen: 'js-search--is-open'
  };

  var searchIsOpen = false;

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    $(selectors.searchSubmit).on('click', function(evt) {
      searchIsOpen = false;
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });

    $(selectors.siteHeaderSearchToggle).on('click', activateSearch);

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus', activateSearch);
    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('blur', deactivateSearch);
  }

  function activateSearch(evt) {
    if (evt.type != 'focus') {
      searchFocus($(selectors.searchInput));
    }
    searchIsOpen = true;

    $(selectors.searchHeader).addClass(classes.focus);
    $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
  }

  function deactivateSearch() {
    searchIsOpen = false;

    $(selectors.searchHeader).removeClass(classes.focus);
    $(selectors.pageContent).removeClass(classes.mobileSearchIsOpen);
  }

  function toggleSearch() {
    if (searchIsOpen) {

    } else {
      searchFocus($(selectors.searchInput));
      searchIsOpen = true;

      $(selectors.searchHeader).addClass(classes.focus);
      $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.ClearSlideshow = class ClearSlideshow {

  constructor(el,options) {

    this.el = el;
    this.options = options || {};

    this.init();

  }

  init() {
    this.$slideshow = $(this.el);

    if (!this.$slideshow.length) {
      return null;
    }

    this.$slideshow.slick(this.options);
    this.sliderActive = true;
  }
}


theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
  // #TODO: Make these more global
  var config = {
    mediaQuerySmall: 'screen and (max-width: 600px)',
    mediaQueryMedium: 'screen and (min-width: 601px) and (max-width: 991px)',
    mediaQueryLargeUp: 'screen and (min-width: 992px)'
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    dots: false,
    draggable: true,
    fade: false,
    infinite: true,
    rows: 1,
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true,
    touchThreshold: 20,
    centerMode: false,
    centerPadding: '40px',
  };

  function slideshow(el) {
    this.$slideshow = $(el);

    if (!this.$slideshow.length) {
      return;
    }

    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper) || this.parent();
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.sliderActive = false;
    var elementOptions = this.$slideshow.data();

    defaults.prevArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__prev';
    defaults.nextArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__next';

    this.settings = {};
    this.settings.all = {
      fade: elementOptions.fade ,
      draggable: elementOptions.draggable,
      arrows: elementOptions.arrows,
      autoplay: elementOptions.autoplay,
      autoplaySpeed: elementOptions.speed,
      dots: elementOptions.dots,
      infinite: elementOptions.infinite,
      slidesPerRow: elementOptions.perRow,
      slidesToScroll: elementOptions.slidesScroll,
      slidesToShow: elementOptions.slidesShow,
      rows: elementOptions.rows,
      centerMode: elementOptions.centerMode,
      centerPadding: elementOptions.centerPadding,
      focusOnSelect: elementOptions.focusOnSelect,
    };
    this.settings.desktop = {
      arrows: elementOptions.arrowsDesktop,
      autoplay: elementOptions.autoplayDesktop,
      autoplaySpeed: elementOptions.speedDesktop,
      dots: elementOptions.dotsDesktop,
      infinite: elementOptions.infiniteDesktop,
      slidesPerRow: elementOptions.perRowDesktop,
      slidesToScroll: elementOptions.slidesScrollDesktop,
      slidesToShow: elementOptions.slidesShowDesktop,
      rows: elementOptions.rowsDesktop,
      centerMode: elementOptions.centerModeDesktop,
      centerPadding: elementOptions.centerPaddingDesktop,
      focusOnSelect: elementOptions.focusOnSelectDesktop,
    };
    this.settings.tablet = {
      arrows: elementOptions.arrowsTablet,
      autoplay: elementOptions.autoplayTablet,
      autoplaySpeed: elementOptions.speedTablet,
      dots: elementOptions.dotsTablet,
      infinite: elementOptions.infiniteTablet,
      slidesPerRow: elementOptions.perRowTablet,
      slidesToScroll: elementOptions.slidesScrollTablet,
      slidesToShow: elementOptions.slidesShowTablet ,
      rows: elementOptions.rowsTablet,
      centerMode: elementOptions.centerModeTablet,
      centerPadding: elementOptions.centerPaddingTablet,
      focusOnSelect: elementOptions.focusOnSelectTablet,
    };
    this.settings.mobile = {
      arrows: elementOptions.arrowsMobile,
      autoplay: elementOptions.autoplayMobile,
      autoplaySpeed: elementOptions.speedMobile,
      dots: elementOptions.dotsMobile,
      infinite: elementOptions.infiniteMobile,
      slidesPerRow: elementOptions.perRowMobile,
      slidesToScroll: elementOptions.slidesScrollMobile,
      slidesToShow: elementOptions.slidesShowMobile,
      rows: elementOptions.rowsMobile,
      centerMode: elementOptions.centerModeMobile,
      centerPadding: elementOptions.centerPaddingMobile,
      focusOnSelect: elementOptions.focusOnSelectMobile,
    };

    _.defaults(this.settings.desktop, this.settings.all);
    _.defaults(this.settings.desktop, defaults);

    _.defaults(this.settings.tablet, this.settings.all);
    _.defaults(this.settings.tablet, defaults);

    _.defaults(this.settings.mobile, this.settings.all);
    _.defaults(this.settings.mobile, defaults);


    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    // this.$slideshow.slick(this.settings);

    var self = this;

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        if (!elementOptions.disableMobile) {
          initSlider(self.$slideshow, self.settings.mobile);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function() {
        if (!elementOptions.disableTablet) {
          initSlider(self.$slideshow, self.settings.tablet);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function() {
        if (!elementOptions.disableDesktop) {
          initSlider(self.$slideshow, self.settings.desktop);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }

      sliderObj.slick(args);
      self.sliderActive = true;
    }

    function destroySlider(sliderObj) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }
    }

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (isMobile.any) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

/**
* Module to show Recently Viewed Products
*
* Copyright (c) 2014 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/

window.theme = window.theme || {};

theme.RecentlyViewed = (function() {

  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function(recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function() {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;
    },
    destroy: function() {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function() {
    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try { config.onComplete() } catch (error) {}
    }
  };

  var moveAlong = function() {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function(product) {
          template.tmpl(product).appendTo(wrapper);
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function() {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    } else {
      finalize();
    }

  };

  return {

    resizeImage: function(src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
      } else {
        return null;
      }
    },

    showRecentlyViewed: function(params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = jQuery('#' + config.templateId);
      wrapper = jQuery('#' + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template.length && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }

    },

    getConfig: function() {
      return config;
    },

    clearList: function() {
      cookie.destroy();
    },

    recordRecentlyViewed: function(params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);

      }

    }

  };

})();

/*
// Remove back to top
(function() {
  var selectors = {
    backButton: '.back-to-top',
  };

  var classes = {
    visible: 'back-to-top--visible',
    fade: 'back-to-top--fade',
  };

  var config = {
    showAfter: 300,
    dimAfter: 1200,
    scrollDuration: 700,
  };

  $backButton = $(selectors.backButton);

  if (!$backButton.length) {
    return;
  }

  $(window).scroll(function(){
    ( $(this).scrollTop() > config.showAfter ) ? $backButton.addClass(classes.visible) : $backButton.removeClass(classes.visible + ' ' + classes.fade);
    if( $(this).scrollTop() > config.dimAfter ) {
      $backButton.addClass(classes.fade);
    }
  });

  $backButton.on('click', function(evt){
    evt.preventDefault();
    $('body,html').animate({scrollTop: 0}, config.scrollDuration);
  });
})();
// Remove back to top
 */

/*============================================================================
  Favicon cart counter
==============================================================================*/
window.theme = window.theme || {};

theme.Favicon = (function() {

  if (window.Favico === undefined) {
    return;
  }

  var icon = new Favico({
    bgColor: '#0cbdc9',
    textColor: '#fff',
    fontFamily: 'sans-serif', // Arial, Verdana, Times New Roman, serif, sans-serif, ...
    fontStyle: 'bold', // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    type: 'circle', // circle, rectangle
    position: 'down', // up, down, left, upleft
    animation: 'none', // slide, fade, pop, popFade, none
    elementId: false, // Image element ID if there is need to attach badge to regular image
    element: false, // DOM element where to change "href" attribute (useful in case of multiple link icon elements)
    dataUrl: false, // Method that will be called for each animation from with data URI parameter
  });

  if (window.shop.cart !== undefined && window.shop.cart.item_count > 0) {
    set(window.shop.cart.item_count);
  }

  function set(value) {
    icon.badge(value);
  }

  function reset() {
    icon.reset();
  }

  return {
    set: set,
    reset: reset
  };
})();

/*
 * Adapted from Currency tools by Caroline Schnapp
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

window.theme = window.theme || {};

theme.CurrencySelectors = (function() {

  function init() {
    Currency.format = shop.currencyFormat;

    var shopCurrency = shop.currency;

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format = shop.moneyWithCurrencyFormat;
    Currency.moneyFormats[shopCurrency].money_format = shop.moneyFormat;

    /* Default currency */
    var defaultCurrency = shop.defaultCurrency;

    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read();

    /* Fix for customer account pages */
    $('.money .money').each(function() {
      $(this).parents('.money').removeClass('money');
    });

    /* Saving the current price */
    $('.money').each(function() {
      $(this).attr('data-currency-' + shop.currency, $(this).html());
    });

    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      }
      else {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if ($('[name=currencies]').length && $('[name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    }
    else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }

    $('[name=currencies]').val(Currency.currentCurrency).change(function() {
      var newCurrency = $(this).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      $('.selected-currency').text(Currency.currentCurrency);
    });

    var original_selectCallback = window.selectCallback;
    var selectCallback = function(variant, selector) {
      original_selectCallback(variant, selector);
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    };

    $(document).on('cart.requestComplete', function(event, cart) {
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    });

    $('.selected-currency').text(Currency.currentCurrency);
    $('.currency-picker__wrapper').removeClass('loading');
  }

  return {
    init: init,
  };
})();

theme.videoPlayers = theme.videoPlayers || {};

(function() {
  var selectors = {
    lightboxTriggers: '.video-lightbox__trigger, .rte a[href*="youtube.com"], .rte a[href*="youtu.be"]',
    placeholderImages: '.video-lightbox__trigger img.placeholder, .video-lightbox__trigger .placeholder-svg',
  };

  $(selectors.lightboxTriggers).yu2fvl({
    minPaddingX: 60, // the space you want on *top and bottom when centering the video (value is divided by 2)
    minPaddingY: 60, // the space you want on *left and right when centering the video (value is divided by 2)
    ratio: 16/9, // choose the ration you want for your video
    cssClass: "video-lightbox", // set a namespace / global css class
    overlayCssClass: "__overlay", // give a suffix css class for the overlay
    iframeCssClass: "__iframe", // give a suffix css class for the iframe
    closeCssClass: "__close", // give a suffix css class for the close button
    // #TODO: Handle the SVG close button a little more nicely
    closeText: "<svg viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(381 231)\"><path d=\"M-370.7-174.7l-2.3-2.3 46-46 2.3 2.3-46 46\"/><path d=\"M-327-174.7l-46-46 2.3-2.3 46 46-2.3 2.3\"/></g></svg>", // give some text for the close button
    vid: false, // set directly a youtube video id (though using an anchor is cool for SEO !)
    open: false // Open the lightbox immediately from JavaScript. Requires vid to be set to work properly.
  });

  var frameScript = document.createElement('script');
  frameScript.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(frameScript, firstScriptTag);

  $(selectors.lightboxTriggers).on('click', function(evt){
    var videoID = $(this).data('video-id') || $(this).parent().data('video-id') || false;
    if (!videoID) {
      return;
    }

    var $iframe = $('.video-lightbox__iframe[src*=' + $(this).data('video-id') + ']')
    if (!$iframe.length) {
      return;
    }

    if (theme.videoPlayers[videoID] == undefined) {
      $iframe.attr('id','lightbox-video-' + videoID);
      theme.videoPlayers[videoID] = new YT.Player('lightbox-video-' + videoID, {
        events: {
          'onStateChange': onPlayerStateChange
        }
      });
    }
  });

  function onPlayerStateChange(evt) {
    var player = evt.target;
    if (player.getPlayerState !== undefined && player.getPlayerState() == 0) {
      player.seekTo(0);
      var videoID = evt.target.getVideoData().video_id;
      $('#lightbox-video-' + videoID + ' ~ .video-lightbox__close').trigger('click');
    }
  }

  var $placeholders = $(selectors.placeholderImages);

  if (!$placeholders.length) {
    return;
  }

  $placeholders.each(function(){
    var $el = $(this);
    var $trigger = $el.parents('.video-lightbox__trigger');
    var videoID = $el.data('video-id') || $trigger.data('video-id') || theme.utils.getYoutubeId($trigger.href);

    if (!videoID) {
      return;
    }

    var image = new Image();
    image.src = 'https://i.ytimg.com/vi/' + videoID + '/maxresdefault.jpg';
    image.onload = function() {
      if (image.naturalWidth !== undefined && image.naturalWidth < 200 && image.src.indexOf('hqdefault') !== -1) {
        image.src = image.src.replace('sddefault', 'hqdefault').replace('maxresdefault', 'sddefault');
        return;
      }

      if ($el.hasClass('placeholder-svg')) {
        $el.parent('.video-lightbox__placeholder').replaceWith(image);
      } else {
        $el.attr('src', image.src);
      }
    }
  });

})();

var main = function() {

  $('.icon-menu').click(function() {
    $('.menu').toggleClass('toggle');
    $('body').toggleClass('menu-active');
  });


  $('.header__dropdown-background').click(function() {
    $('.menu').removeClass('toggle');
    $('.header-mobile__aside').removeClass('header-mobile__aside--active');
    $('body').removeClass('menu-aside-active');
    $('body').removeClass('menu-active');
  });
};

$(document).ready(main);

// navigation for Desktop
var bpMobile = 990;

if($(window).width() > bpMobile){


  // dropdown link
  $( "*[data-menu*='dropdown-']" ).each(function () {

    // old event click
    $(this).on('mouseover',function(e) {

        // click active menu
        if($(this).hasClass('header-menu__link--red-line')){

            $(this).removeClass('header-menu__link--red-line');
            $("*[data-dropdown]").removeClass('toggle');
            $('.header__dropdown-background').removeClass('show-bckg');

        } else {
            //add active
            // $( ".header-menu__item']" ).removeClass('header-menu__link--red-line');
            // $(this).addClass('header-menu__link--red-line');

            // find data number
            var dropdownData = $(this).data("menu");
            var dropdown = $("*[data-dropdown*='" + dropdownData +"']");

            // add class dropdown menu
            $("*[data-dropdown]").removeClass('toggle', function () {
                $( "*[data-menu*='dropdown-']" ).removeClass('header-menu__link--red-line');
            });
            dropdown.addClass('toggle');
            $('.header__dropdown-background').addClass('show-bckg');

            dropdown.on('mouseleave', function(e){
              dropdown.removeClass('toggle');
              $('.header__dropdown-background').removeClass('show-bckg');
            });
        }
    });

    // $(this).on('mouseleave',function(e){
    //   var dropdownData = $(this).data("menu");
    //   var dropdown = $("*[data-dropdown*='" + dropdownData +"']");
    //   dropdown.removeClass('toggle')
    //   $('.header__dropdown-background').removeClass('show-bckg');
    // });
  });

  $('.header-menu__link:not([href="#"])').each(function(){
      $(this).on('mouseenter', function(){
        $('.header__dropdown').each(function(){
          if($(this).hasClass('toggle')){
            $(this).removeClass('toggle')
            $('.header__dropdown-background').removeClass('show-bckg');
          }
        });
      });
  });


  // for sub category menu
    $( ".header-dropdown__item" ).each(function () {
        var li = $(this);

        // check if item has sub menu and add class="parent"
        li.find('ul').each(function(){
           $(this).parent().addClass('parent');
        });

        // if parent - toggle click
        if(li.hasClass('parent')){
            var parentLi = $(this);

            parentLi.find('.header-dropdown__link').on('click', function(){
                parentLi.children('ul').toggleClass('toggle');
          })
        }
    });

    // remove class if click in any place in the site
    $(document).mouseup(function (e) {
        var dropdown = $("*[data-dropdown*='dropdown-']");

        if ( $( ".header-menu__item" ).has(e.target).length === 0 && $(".header__dropdown").has(e.target).length === 0){
            dropdown.removeClass('toggle');
            $('.header__dropdown-background').removeClass('show-bckg');

            $( "*[data-menu*='dropdown-']" ).removeClass('header-menu__link--red-line');
        }
    });

} else {

  // added js for mobile menu

  $( "*[data-mobile-menu*='dropdown-']" ).each(function () {
    $(this).on('click',function() {


      var childLink = $(this).children().first().attr('href');
      if (childLink != '#') {
        return;
      }

      // find data number
      var dropdownData = $(this).data("mobileMenu");
//                console.log(dropdownData);

      // add class dropdown menu
      $("*[data-dropdown-mobile*='" + dropdownData +"']").addClass('toggle');
      $('.header-mobile__aside').addClass('header-mobile__aside--active');
      $('body').addClass('menu-aside-active');
      $('.header-mobile__nav-container').animate({ scrollTop: 0 }, "fast");
      $("*[data-dropdown-mobile*='" + dropdownData +"'] .mobile-menu-slider").slick('resize');
    });
  });

  // remove class if click on title in sub menu
  $( '.header-mobile__item-title').each(function () {

    $(this).on('click',function() {
      // remove class dropdown menu
      $(".header-mobile__dropdown").removeClass('toggle');
      $('.header-mobile__aside').removeClass('header-mobile__aside--active');
      $('body').removeClass('menu-aside-active');
    });
  });


  // for sub category menu
  $( ".header-mobile-dropdown__item" ).each(function () {
    var li = $(this);
    li.click(function() {
      li.children('ul').toggleClass('toggle');
      li.find('.header-mobile-dropdown__link i').toggleClass('links-hide');
    });
  });
}



      // var childLink = $(this).children().first().attr('href');
      // console.info(childLink);
/*============================================================================
  TAB GROUPS
==============================================================================*/
window.theme = window.theme || {};

theme.TabsGroup = (function() {

  var selectors = {
    container: '.tabs-group',
    nav: '.tabs-group__nav',
    navItem: '.tabs-group__nav-item',
    tab: '.tabs-group__tab'
  };

  var defaults = {
    activeTab: 1,
    tabsActiveClass: 'tabs-group--active'
  };

  var cache = {};

  function TabsGroup(el) {
    this.$tabsGroup = $(el);
    if (!this.$tabsGroup.length) {
      return;
    }

    this.$navContainer  = this.$tabsGroup.find(selectors.nav);
    this.$navItems      = this.$tabsGroup.find(selectors.navItem);
    this.$tabs          = this.$tabsGroup.find(selectors.tab);

    // Set initial nav states
    for (var i =  this.$navItems.length - 1; i >= 0; i--) {
      var $tab = this.$navItems[i];
      var target = $($tab).data('target');
      if (target == defaults.activeTab) {
        this.activeTab = target;
        $($tab).attr('data-active', 'true');
      } else {
        $($tab).attr('data-active', 'false');
      }
    }

    // Set initial tab states
    for (var j =  this.$tabs.length - 1; j >= 0; j--) {
      var $tab = this.$tabs[j];
      var tabId = $($tab).data('tab');
      if (tabId == this.activeTab) {
        $($tab).attr('data-active', 'true');
      } else {
        $($tab).attr('data-active', 'false');
      }
    }

    var self = this;

    // Bind nav click events
    $(this.$navItems).on('click',function() {
      var target = $(this).data('target');
      _goTo(target);
    });

    function _goTo(target) {
      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      var $target = self.$tabsGroup.find('[data-tab=' + target + ']');
      $($target).attr('data-active', 'true');

      var $targetNav = self.$tabsGroup.find('[data-target=' + target + ']');
      $($targetNav).attr('data-active', 'true');

      self.activeTab = target;
    }

    this.goToTab = function(target) {
      _goTo(target);
    };

    $(this.$tabsGroup).addClass(defaults.tabsActiveClass);
  }

  return TabsGroup;
})();
/*============================================================================
  PRODUCT FEATURED POINTS
==============================================================================*/
window.theme = window.theme || {};
window.theme.productFeaturedPointsData = window.theme.productFeaturedPointsData || {};

theme.ProductFeaturedPoints = (function() {

  var selectors = {
    data:     '#product-featured-points-data',
    point:    '.featured-points__point',
    navArrow: '.featured-points__nav-arrow'
  };

  var defaults = {
    activeClass:        'points-initialized',
    pointsActiveClass:  'points-active'
  };

  function ProductFeaturedPoints(el) {
    this.$el = $(el);

    if (!this.$el.length) {
      return;
    }

    this.data = {
      points:       [],
      active_point: []
    };

    var productData               = $(this.$el).data('points-metafields');
    var productFeaturedPointsData = JSON.parse($(selectors.data).html());
    var productAttributes         = Object.keys(productData);
    var productImageSource        = $(this.$el).data('points-image-src');

    this.data.image = productImageSource || false;

    if (!this.data.image) {
      console.error('No product image has been set');
      return;
    }

    for (var i = productAttributes.length - 1; i >= 0; i--) {

      var attributeGroup      = productAttributes[i];
      var attributeGroupData  = productFeaturedPointsData[attributeGroup];
      var attribute           = productData[attributeGroup];

      if (attributeGroup && attributeGroupData && attribute) {

        var attributeDescription  = attributeGroupData.attributes[attribute];
        var point                 = attributeGroupData;

        point.subtitle  = attribute;
        point.paragraph = attributeDescription;

        delete point.attributes;

        this.data.points.push(point);

      }

    }

    if (!this.data.points) {
      console.error('No data exists');
      return;
    }

    for (var j = this.data.points.length - 1; j >= 0; j--) {
      this.data.points[j].id = j;
    }

    //Bind TinyBind
    tinybind.bind($(this.$el), {data: this.data});
    this.data.active_point = this.data.points[0];

    this.$points    = this.$el.find(selectors.point);
    this.$navArrows = this.$el.find(selectors.navArrow);

    var self = this;

    function _changeActivePoint(pointIndex) {
      $(self.$el).removeClass('points-active');
      self.data.active_point = self.data.points[pointIndex];

      setTimeout(function(){
        $(self.$el).addClass('points-active');
      }, 1);
    }

    // Bind click events
    $(this.$points).on('click',function(){
      var pointIndex = $(this).data('point');
     _changeActivePoint(pointIndex);
    });

    $(this.$navArrows).on('click',function(){
      var active =  self.data.active_point.id;
      var pointsCount =   self.data.points.length;
      var newActive;
      if ($(this).data('nav') == 'next') {
        if (active + 1 == pointsCount) {
          newActive = 0;
        } else {
          newActive = active + 1;
        }
      } else if ($(this).data('nav') == 'prev') {
        if (active == 0) {
          newActive = pointsCount - 1;
        } else {
          newActive = active - 1;
        }
      }
      _changeActivePoint(newActive);
    });

    $(this.$el).addClass(defaults.activeClass);
    $(this.$el).addClass(defaults.pointsActiveClass);
  }

  return ProductFeaturedPoints;
})();
/*============================================================================
  SEARCH MODAL
==============================================================================*/
window.theme = window.theme || {};

theme.SearchModal = (function() {

  var selectors = {
    trigger: '[data-search-modal]',
    modal: '.search-modal',
    searchBox: '[type="search"]'
  };

  var defaults = {

  };

  function init() {

    if (!$(selectors.trigger).length) {
      return;
    }

    $(selectors.trigger).on('click', function(e) {
      e.preventDefault();

      if ($(this).data('search-modal') == 'open') {
        $('body').addClass('search-modal-open');
        $(selectors.modal).find(selectors.searchBox).focus();
        // if (isMobile.any) {
        //   $('body').removeClass('search-modal-open');
        //   $('body').addClass('search-modal-mobile-open');
        // }
      } else {
        $('body').removeClass('search-modal-open');
      }

      return false;
    });
  };

  init();

  return;
})();
var bpMobile = 990;

if($(window).width() > bpMobile) {
// open modal on click
  // $('.header #customer_register_link').on('click', function () {
  //   $('#account-wrap').toggleClass('account-wrapper--flex').removeClass('account-wrapper--large');
  //   $('.account-block').toggleClass('account-wrapper--flex');
  //   $('#btn-create').parent().removeClass('account-hide');
  //   $('.create-account-wrapper').removeClass('account-wrapper--flex');
  // });
//click outside modal
  var container = $('#account-wrap');
  $(document).mouseup(function (e) {
    if (container.has(e.target).length === 0 && $(".header-sidebar").has(e.target).length === 0) {
      container.removeClass('account-wrapper--flex');
      container.parent().removeClass('account-wrapper--flex');
      $('#btn-create').parent().removeClass('account-hide');
      $('.create-account-wrapper').removeClass('account-wrapper--flex');
      $('#account-wrap').removeClass('account-wrapper--large');
    }
  });
  //create button
  $('#btn-create').on('click', function () {
    $('#btn-create').parent().addClass('account-hide');
    $('.create-account-wrapper').addClass('account-wrapper--flex');
    $('#account-wrap').addClass('account-wrapper--large');
  });
  //back to log in
  $('.create-account-block #btn-log-in').on('click', function () {
    $('#btn-create').parent().removeClass('account-hide');
    $('.create-account-wrapper').removeClass('account-wrapper--flex');
    $('#account-wrap').removeClass('account-wrapper--large');
  });
} else {
  // open modal on click mobile
  $('.customer_register-link--mobile').on('click', function () {
    $('#account-wrap').toggleClass('account-wrapper--flex').removeClass('account-wrapper--large');
    $('.account-block').toggleClass('account-wrapper--flex');
    $('#btn-create').parent().removeClass('account-hide');
    $('.create-account-wrapper').removeClass('account-wrapper--flex');
  });
  //click outside modal
  $('.account-block .account-wrapper .icon-close').on('click', function () {
    $('.account-block').removeClass('account-wrapper--flex');
    $('#account-wrap').removeClass('account-wrapper--flex');
  });
  //create button
  $('#btn-create').on('click', function () {
    $('#btn-create').parent().addClass('account-hide');
    $('.create-account-wrapper').addClass('account-wrapper--flex');
    $('#account-wrap').addClass('account-wrapper--large');
  });
  //back to log in
  $('.create-account-block #btn-log-in').on('click', function () {
    $('#btn-create').parent().removeClass('account-hide');
    $('.create-account-wrapper').removeClass('account-wrapper--flex');
    $('#account-wrap').removeClass('account-wrapper--large');
  });
}
window.theme = window.theme || {};

theme.Video = (function() {

  var selectors = {
    videoContainer: '.video',
  };

  var sources = {
    vimeo: 'https://player.vimeo.com/api/player.js',
    youtube: 'https://www.youtube.com/iframe_api'
  };

  var methods = {
    vimeo: function(elem) {
      var player = new Vimeo.Player(elem);
      player.play();
    },
    youtube: function(elem) {
      var player = new YT.Player(elem, {
       events: {
        'onReady': onPlayerReady
        }
      });

      function onPlayerReady(event) {
        event.target.playVideo();
      }
    }
  };

  var cache = {
    videoTypes: [],
    videoTypesLoaded: []
  };

  function init() {
    if (!$(selectors.videoContainer).length) {
      return;
    }

    _loadPlayerAPIs();
  };

  function _loadPlayerAPIs() {
    var videoTypes = [];

    for (i = 0; i < $(selectors.videoContainer).length; i++) {
      var $videoContainer = $(selectors.videoContainer)[i],
          videoType       = $($videoContainer).attr('data-video-type');
      if (cache.videoTypes.indexOf(videoType) === -1) {
        cache.videoTypes.push(videoType);
      }
    }

    for (i = 0; i < cache.videoTypes.length; i++) {
      var videoType = cache.videoTypes[i];
      _includePlayer(videoType);
    }
  }

  function _includePlayer(type) {
    var source = sources[type];

    if (source == undefined ) {
      console.error('Video type ' + type + ' is not supported');
      return;
    }

    if ($('script[src="' + source + '"]').length) {
      cache.videoTypesLoaded.push(type);
      if (_checkAdditionalSources()) {
        _bindEventListeners();
      }
      return;
    }

    loadJS(source, function() {
      cache.videoTypesLoaded.push(type);

      if (_checkAdditionalSources()) {
        _bindEventListeners();
      }
    });
  }

  function _checkAdditionalSources() {
    for (i = 0; i < cache.videoTypes.length; i++) {
      var type = cache.videoTypes[i];
      if (cache.videoTypesLoaded.indexOf(type) === -1) {
        return false;
      }
    }
    return true;
  }

  function _bindEventListeners() {
    $(selectors.videoContainer).on('click',_revealVideo);
  }

  function _revealVideo() {
    var videoType = $(this).attr('data-video-type'),
        videoId   = $(this).attr('data-video-id');

    methods[videoType]($(this).find('iframe')[0]);

    $(this).attr('data-video-visible','true');
  }

  return {
    init: init
  };

})();

theme.Video.init();
window.theme = window.theme || {};

theme.HireForm = (function() {

  var cache = {};

  function runCache() {

    var data = JSON.parse($('#book-an-appointment-settings').html());
    if (data) {
      cache.settings = data;
    }

    var locationData = JSON.parse($('#store-locations').html());
    if (locationData) {
      cache.settings = cache.settings || {};
      cache.settings.locations = locationData;
    }

    // Sort locations by type
    _.map(cache.settings.locations, function(value, key) {
      cache.settings.locations[key] = _.groupBy(cache.settings.locations[key], 'type');
    });

  }

  function HireForm(el) {
    var $form = $(el);

    if (!cache.length) {
      runCache();
    }

    tinybind.bind($form, { data: cache.settings });

    var $dateSelect = $($form).find('input[name="contact[Date]"]');

    var flatpickrOptions = {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        minDate: "today",
        defaultDate: "today"
    };

    theme.FormPostSummary.autofill($form);

    theme.FormPostSummary.getData($form);

    $($dateSelect).flatpickr(flatpickrOptions);

  }

  return HireForm;
})();

// theme.LocationFilter(function() {

//   var selectors = {
//     locationContent: '.stores__location'
//   };

//   function

// })();


/*================ Sections ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.collections = (function() {

  var selectors = {
    filterBar: '.collection__filters-and-sort',
    filter: '.js-filter',
    desktopPlaceholder: '.js-filter-placeholder-desktop',
    mobilePlaceholder: '.js-filter-placeholder-mobile',
    drawer: '.filters-drawer',
    filterButtonMobile: '.filters-and-sort__filters-button',
    drawerCloseButton: '.filters-drawer__back-button'
  };

  var config = {
    mediaQuerySmall: 'screen and (max-width: 991px)',
    mediaQueryMediumAndUp: 'screen and (min-width: 992px)',
  };

  function init() {

    if (!$(selectors.filterBar).length || isMSIE) {
      return;
    }

    $(selectors.filterBar).stickybits();

    positionFilters();

    $(selectors.filterButtonMobile).on('click.filter-menu',function() {
      openDrawer();
    });

    $(selectors.drawerCloseButton).on('click.filter-menu',function() {
      closeDrawer();
    });

  }

  function positionFilters() {

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        $(selectors.mobilePlaceholder).html($(selectors.filter).detach());
      }
    });

    enquire.register(config.mediaQueryMediumAndUp, {
      match: function() {
        $(selectors.desktopPlaceholder).html($(selectors.filter).detach());
        closeDrawer();

      }
    });

  }

  function openDrawer() {
    $(selectors.drawer).addClass('active');
    $('body').addClass('filters-drawer-open');
  }

  function closeDrawer() {
    $(selectors.drawer).removeClass('active');
    $('body').removeClass('filters-drawer-open');
  }

  return {
    init: init,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };

})();

theme.collections.init();
window.theme = window.theme || {};

theme.ProductFilterAndSearch = (function() {

  var selectors = {
    collection: '.collection',
    collectionTitle: '[data-collection-title]',
    collectionDescription: '[data-collection-description]',
    collectionGrid: '.collection-grid',
    collectionGridRow: '.collection-grid .row',
    pageHeader: '.page-header',
    defaultPagination: '.js-default-pagination',
    promotions: '#promotions',
    filterTitle: '.bc-sf-filter-block-title h3',
    filterOptionMenuItem: '.bc-sf-filter-option-block',
    filtersDesktop: '.js-filter',
    filteredProductsContainer: '#bc-sf-filter-products',
    collectionVendorsData: '#collection-vendors-data',
    productGridItem: '.product-grid-item'
  };

  var options = {
    displayCollectionDescription: true,
    animateHeaderHeight: false
  };

  var cache = {
    headerHeightCurrent: 0,
    headerHeightNew: 0,
    promotion: false,
    sort: false,
    $vendorSections: {},
    vendorProducts: {},
    vendorData: {}
  };

  function init() {

    window.bcsffilter = new BCSfFilter();
    window.bcSfFilterSettings = {
      general: {
        limit: getProductsPerPageCount()
      }
    };
    window.bcsffilter.init();
    window.bcsffilter.initFilter();
    // window.bcsffilter.initSearchBox();

  }

  function buildCollectionpage(data, eventType) {

    var $collection = $(selectors.collection);

    if (!$collection.length) {
      return;
    }

    theme.Wishlist.update();

    cache.sort = bcsffilter.queryParams.sort;

    _removeDefaultPagination();

    if (data.total_product > getProductsPerRowCount()) {
      _injectPromotion();
    }
    let filter_title = $('.bc-sf-filter-block-title h3 span:contains("Price ($ )")');
    if(filter_title.length>0){
      filter_title.text('Price');
    }
    _buildVendorSort();
    _bindEvents();
    _showSelectedOptions();
  }

  function _bindEvents() {

    $(selectors.filterTitle).off('.filter-reveal');
    $(selectors.filterTitle).on('click.filter-reveal', function(){
      var $parent = $(this).parents('.bc-sf-filter-option-block');
      var parentIsActive = $parent.hasClass('active');
      $(selectors.filterOptionMenuItem).removeClass('active');
      if (!parentIsActive) {
        var target = $(this).parents('.bc-sf-filter-option-block').data('id');
        $(selectors.filterOptionMenuItem + '[data-id="' + target + '"]').addClass('active');
        $('#bc-sf-filter-tree').attr("data-active-selector",`${target}`);
      }else{
        $('#bc-sf-filter-tree').attr("data-active-selector","");
      }

      return false;
    });

  }

  function _showSelectedOptions() {

    let str = window.location.search;
    let res = str.replace('?_=pf&pf_t_', '').replace('?_=pf&pf_p_', '').split("&pf_");
    $('.filter-selected-option').remove();
    $('.bc-sf-filter-option-block .bc-sf-filter-block-title').append( `<span class="filter-selected-option"></span>` );
    $('.filter-selected-option').append('(all)')

      for(let i=0; i<res.length; i++){
        let clean_str = res[i].replace('t_', '').replace('p_', '');
        let filter = clean_str.toLowerCase().split("=")[0];
        let option = clean_str.toLowerCase().split("=")[1]?.replace(`${filter}-`, '').replace(`%20`, ' ').replace(`%3a`, '-');
        let title_filter = $(`.bc-sf-filter-option-block-${filter}`);
        let title_filter_title= $(title_filter.find('.bc-sf-filter-block-title .filter-selected-option'));
        let text_select=title_filter_title.text();
        if(text_select == '(all)'){
          title_filter_title.text(`(${option})`);
        }else if(text_select.length > 0){

          title_filter_title.text(`${text_select.replace( ')', '')}, ${option})`);
        }

      }

      let active_option = $('#bc-sf-filter-tree').attr("data-active-selector");
      $(`[data-id="${active_option}"]`).addClass('active');
      console.log(active_option);


  }

  function _buildVendorSort() {

    if (cache.sort == 'vendor') {
      $('.collection-sort__input').append('<option value="vendor" selected>' + window.theme.strings.sortVendor + '</option>');
    } else {
      $('.collection-sort__input').append('<option value="vendor">' + window.theme.strings.sortVendor + '</option>');
      return;
    }

    // Append vendor page stuff
    if ($(selectors.collectionVendorsData).length) {
      cache.vendors = JSON.parse($('#collection-vendors-data').html());
    }

    if (!cache.vendors) {
      return;
    }

    $(selectors.filteredProductsContainer).html('');

    var i = 0;
    prepareVendorSection(i);

    function prepareVendorSection(i) {
      if (i >= cache.vendors.length) {
        return;
      }

      var vendor = cache.vendors[i].handle;

      cache.$vendorSections[i] = $('<div class="collection__vendor loading" data-iteration="' + i + '" data-loaded="false" data-vendor="' + vendor + '">Loading</div>');
      $(selectors.filteredProductsContainer).append(cache.$vendorSections[i]);

      if (cache.vendorProducts[i]) {
        renderVendorSection(i);
      } else {
       bindWaypoint(cache.$vendorSections[i]);
      }
    }

    function bindWaypoint(el) {

      $(el).waypoint({
        handler: function(direction) {

          this.destroy();

          var vendor = $(this.element).data('vendor');
          var i = parseInt($(this.element).data('iteration'));

          var urlSeperator = '/';
          if (window.location.pathname.split('/').length - 1 > 2) {
            urlSeperator = '+';
          }

          $.ajax({
            url: window.location.pathname + urlSeperator + vendor + '?view=vendor'
          }).done(function(data) {
            cache.vendorProducts[i] = data;
            renderVendorSection(i);
          });
        },
        offset: 'bottom-in-view'
      });

    }

    function renderVendorSection(i) {

      $productgridItems = $(selectors.productGridItem, cache.vendorProducts[i]);

      if ($productgridItems.length) {
        var $collectionDetailsTemplate = $(theme.utils.getTemplate('collection-vendor-masthead'));
        $(cache.$vendorSections[i]).html(cache.vendorProducts[i]).prepend($collectionDetailsTemplate);
        tinybind.bind($($collectionDetailsTemplate), { vendor: cache.vendors[i]});
        $(cache.$vendorSections[i]).attr('data-loaded', 'true').removeClass('loading');
      } else {
        $(cache.$vendorSections[i]).remove();
      }

     // Prepare next section
     i++;
     prepareVendorSection(i);
   }

  }

  function _removeDefaultPagination() {
    if ($(selectors.defaultPagination).length) {
      $(selectors.defaultPagination).remove();
    }
  }

  function _injectPromotion() {

    if (!cache.promotion) {
      return;
    }

    var promotion = cache.promotion;
    var promotionTemplate = theme.utils.getTemplate('collection-promo');

    var $elem = $(promotionTemplate).appendTo($(selectors.collectionGridRow));
    tinybind.bind($elem, { promotion: promotion });

    var promoWidth = getPromotionWidth();

    if (promoWidth != false && promoWidth != 1) {
      var productsPerRow = getProductsPerRowCount();
      var newClass = 'col-lg-6';
      if (productsPerRow == 3) {
        newClass = 'col-lg-8';
      } else if (productsPerRow == 4) {
        newClass = 'col-lg-3';
      }
      $elem.addClass(newClass);
    }

    $(selectors.collectionGrid).attr('data-promotion', 'true');
    $(selectors.collectionGrid).attr('data-promotion-size', promoWidth);

    // var $productGridItems = $(selectors.collectionGridRow + ' > div:not(.collection-promo)');

    // for (i = 0; i < $productGridItems.length; i++) {
    //   if ((i + 1) < gridPosition) {
    //     $($productGridItems[i]).css('order', '0');
    //   } else {
    //     $($productGridItems[i]).css('order', '2');
    //   }
    // }


  }

  function getMaxProductsPerPageCount() {
    var rows = 8;
    return getProductsPerRowCount() * rows;
  }

  function getProductsPerRowCount() {
    return $(selectors.collectionGrid).data('products-per-row');
  }

  function getProductsPerPageCount() {
    var maxPerPage = getMaxProductsPerPageCount();
    var perRowCount = getProductsPerRowCount();
    var removeCount = perRowCount * getPromotionWidth();
    var totalProducts = maxPerPage - Math.ceil(removeCount);
    return totalProducts;
  }

  function _getPromotion() {

    if (cache.promotion) {
      return cache.promotion;
    }

    var handle = bcSfFilterMainConfig.general.collection_handle;
    var promotions = theme.utils.getPromotions(handle, 'collections');

    if (!promotions.length) {
      return false; // No promotion
    }

    // Decide which promotion to use - random
    var promotionIndex = Math.floor((Math.random() * promotions.length));
    var promotion = promotions[promotionIndex];

    cache.promotion = promotion;

    return promotion;
  }

  function getPromotionWidth() {

    var promotion = _getPromotion();

    if (!promotion) {
      return false;
    }

    return 0.5; // Half width

  }

  return {
    init: init,
    buildCollectionpage: buildCollectionpage
  };

})();

theme.ProductFilterAndSearch.init();
theme.HeaderSection = (function() {

  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.NewHeaderSection = (function() {

  function NewHeaderSection(container) {

    this.container = container;

    this.updatePromoBar();

  }

  NewHeaderSection.prototype = _.extend(NewHeaderSection.prototype, {
    updatePromoBar: function() {

      if (document.querySelector('.promo-banner')) {
        console.info('Show promo bar');
        document.body.classList.add('promo-banner-shown');
      } else {
        console.info('Hide promo bar')
        document.body.classList.remove('promo-banner-shown');
      }

    }
  })

  return NewHeaderSection;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

theme.ProductCheckStockPopup = (function() {

  function ProductCheckStockPopup(activeProductHandle, activeVariantId) {

    this.productHandle = activeProductHandle;
    this.initialVariantId = activeVariantId;

    this.data = {};

    this.methods = {
      selectVariant: this._selectVariant.bind(this),
      selectRegion: this._selectRegion.bind(this),
      addVariantToCart: this._addVariantToCart.bind(this),
    };

    this.data.tasksInQueue = 0;

    this._openPopup();
    this._bindView();
    this._buildStockLevels();
    this._fetchProductData();
    this._fetchStoresData();

    this._checkIsReady();

  }

  ProductCheckStockPopup.prototype = _.extend({}, ProductCheckStockPopup.prototype, {

    _addVariantToCart: function() {

      console.info('Add to cart');

      var self = this;

      var id = this.data.activeVariant.id;

      this.addToCartButton = event.currentTarget;

      function onCartSuccess(data) {
        self.data.cartLoading = false;

        self._closePopup();
      }

      function onCartError(data) {
        self.data.cartLoading = false;
        self._closePopup();

        iziToast.show({
          message: data.responseJSON.description,
          color: 'red',
          position: 'bottomCenter'
        });
      }

      self.data.cartLoading = true;

      $('body').addClass('cart-loading--opens-drawer');

      CartJS.addItem(id, 1, {}, {
        "success": onCartSuccess,
        "error": onCartError,
      });

    },

    _closePopup: function() {

      this.modal.close();

    },

    _openPopup: function() {

      var modaloptions,
          $modalContent,
          template;

      function createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
      }

      template = theme.utils.getTemplate('check-stock-popup');

      this.$modalContent = $(template);

      // We have to define all options becuase Stamped breaks the defaults
      modaloptions = {
        namespace:      'od-modal',        /* Name of the events and css class prefix */
        targetAttr:     'data-featherlight',   /* Attribute of the triggered element that contains the selector to the lightbox content */
        variant:        'check-stock-popup',                  /* Class that will be added to change look of the lightbox */
        resetCss:       false,                 /* Reset all css */
        background:     null,                  /* Custom DOM for the background, wrapper and the closebutton */
        openTrigger:    'click',               /* Event that triggers the lightbox */
        closeTrigger:   'click',               /* Event that triggers the closing of the lightbox */
        filter:         null,                  /* Selector to filter events. Think $(...).on('click', filter, eventHandler) */
        root:           'body',                /* A selector specifying where to append featherlights */
        openSpeed:      250,                   /* Duration of opening animation */
        closeSpeed:     250,                   /* Duration of closing animation */
        closeOnClick:   'background',          /* Close lightbox on click ('background', 'anywhere', or false) */
        closeOnEsc:     true,                  /* Close lightbox when pressing esc */
        closeIcon:      '&#10005;',            /* Close icon */
        loading:        '',                    /* Content to show while initial content is loading */
        persist:        false,                 /* If set, the content will persist and will be shown again when opened again. 'shared' is a special value when binding multiple elements for them to share the same content */
        otherClose:     null,                  /* Selector for alternate close buttons (e.g. "a.close") */
        beforeOpen:     $.noop,                /* Called before open. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
        beforeContent:  $.noop,                /* Called when content is about to be presented. `this` is the featherlight instance. Gets event as parameter */
        beforeClose:    $.noop,                /* Called before close. can return false to prevent closing of lightbox. `this` is the featherlight instance. Gets event as parameter  */
        afterOpen:      $.noop,                /* Called after open. `this` is the featherlight instance. Gets event as parameter  */
        afterContent:   $.noop,                /* Called after content is ready and has been set. Gets event as parameter, this contains all data */
        afterClose:     $.noop,                /* Called after close. `this` is the featherlight instance. Gets event as parameter  */
        onKeyUp:        $.noop,                /* Called on key up for the frontmost featherlight */
        onResize:       $.noop,                /* Called after new content and when a window is resized */
        type:           null,                  /* Specify content type. If unset, it will check for the targetAttrs value. */
        contentFilters: ['jquery', 'image', 'html', 'ajax', 'text'] /* List of content filters to use to determine the content */
      };

      this.modal = $.featherlight(this.$modalContent, modaloptions);

    },

    _bindView: function() {

      this.view = tinybind.bind(this.modal.$content[0], {
        data: this.data,
        methods: this.methods,
      });

    },

    _formatProductData: function() {

      var self = this;

      function Variant(data) {
        _.extend(this, data);
      }

      this.data.variants = [];

      _.each(this.data.product.variants, function(data, index) {

        var variant;

        variant = new Variant(data);

        self.data.variants.push(variant);
        self.data.product.variants[index] = variant;

        if (variant.id == self.initialVariantId) {
          self._setActiveVariant(variant);
        }

      });
    },

    _fetchVariantsInventoryData: function() {

      var self = this;

      var url;

      url = '/products/' + this.productHandle + '?view=variants-inventory';

      this.data.tasksInQueue += 1;

      function success(data) {

        var inventoryData, i, variant;

        inventoryData = JSON.parse(data);

        i = self.data.variants.length;

        while(i--) {

          variant = self.data.variants[i];
          variantInventoryData = _.find(inventoryData.variants, { 'id': variant.id });

          if (variantInventoryData) {

            variant.inventory_quantity = variantInventoryData.inventory_quantity;

            if (variant.inventory_quantity == 0) {
              variant.stockLevel = _.find(self.data.stockLevels, {'title': 'out'});
            } else {
              variant.stockLevel = _.find(self.data.stockLevels, {'title': 'in'});
            }

          }

        }

        self.data.tasksInQueue -= 1;

        self._checkIsReady();

      }

      $.get(url, null, success, 'text');

    },

    _fetchProductData: function() {

      var self = this;

      var url;

      url = '/products/' + this.productHandle;

      this.data.tasksInQueue += 1;

      function success(data) {
        self.data.product = data.product;

        self._formatProductData();
        self._fetchVariantsInventoryData();

        self.data.tasksInQueue -= 1;
      }

      $.getJSON(url, success);

    },

    _buildStockLevels: function() {

      var self = this;

      var stockLevels = [
        {
          title: 'in',
          color: '#cdebd6',
          message: 'In stock'
        },
        {
          title: 'out',
          color: '#ffb3b2',
          message: 'Sold out'
        }
      ];

      function StockLevel(data) {
        _.extend(this, data);
      }

      self.data.stockLevels = [];

      _.each(stockLevels, function(stockLevel) {
        self.data.stockLevels.push(new StockLevel(stockLevel));
      });

    },

    _fetchStoresData: function() {

      var self = this;

      var url;

      url = '/pages/new-zealand?view=stores-json';

      this.data.tasksInQueue += 1;

      self.data.stores = [];

      function success(data) {

        var stores;

        stores = JSON.parse(data);

        function Store(data) {
          _.extend(this, data);
          this.id = parseInt(this.id);
        }

        _.each(stores, function(data) {

          var store;

          if (!data.id) {
            return;
          }

          store = new Store(data);
          self.data.stores.push(store);

        });

        self.data.tasksInQueue -= 1;
        self._formatRegionData();
        self._checkIsReady();

      }

      $.get(url, success);

    },

    _formatRegionData: function() {

      var self = this;

      function Region(data) {
        _.extend(this, data);
      }

      self.data.regions = [];

      _.each(this.data.stores, function(store) {

        var regionTitle,
            existingRegion,
            region;

        regionTitle = store.address_island || store.address_state;

        existingRegion = _.find(self.data.regions, { 'title': regionTitle });

        if (!existingRegion) {

          region = new Region({
            title: regionTitle
          });

          self.data.regions.push(region);

        } else {

          region = existingRegion;

        }

        store.region = region;

      });

      self.data.regions = _.orderBy(self.data.regions, ['title']);
      self._setActiveRegion(self.data.regions[0]);

    },

    _selectRegion: function() {

      var regionTitle,
          region;

      regionTitle = event.currentTarget.value;
      region = _.find(this.data.regions, { 'title': regionTitle });

      this._setActiveRegion(region);

    },

    _setActiveRegion: function(region) {

      if ( this.data.activeRegion) {
       this.data.activeRegion.active = false;
      }

      if (region == 'none') {

        this.data.activeRegion = null;

      } else {

        this.data.activeRegion = region;
        this.data.activeRegion.active = true;

      }

    },

    _selectVariant: function() {

      var variantId,
          variant;

      variantId = event.currentTarget.value;
      variant = _.find(this.data.variants, { 'id': parseInt(variantId) });

      this._setActiveVariant(variant);

    },

    _setActiveVariant: function(variant) {

      if (this.data.activeVariant) {
        this.data.activeVariant.active = false;
      }

      this.data.activeVariant = variant;
      this.data.activeVariant.active = true;

      this._fetchStockLevels();

    },

    _checkIsReady: function() {

      console.info(this.data);

      if (this.data.tasksInQueue == 0) {

        this.data.isReady = true;
        this._fetchStockLevels();

      } else {

        this.data.isReady = false;

      }

    },

    _fetchStockLevels: function() {

      var self = this;

      var activeVariant,
          url,
          store,
          inventoryItemID;

      activeVariant = this.data.activeVariant;

      this.data.loadingStock = true;

      function success(data) {

        self.data.currentVariantInventory = data;

        _.each(self.data.stores, function(store) {

          var inventoryItem;

          inventoryItem = _.find(self.data.currentVariantInventory, { 'locationId': store.id });

          if (!inventoryItem) {
            store.activeVariantQuantity = 0;
          } else {
            store.activeVariantQuantity = inventoryItem.quantity;
          }

          if (store.activeVariantQuantity == 0) {
            store.stockLevel = _.find(self.data.stockLevels, {'title': 'out'});
          } else {
            store.stockLevel = _.find(self.data.stockLevels, {'title': 'in'});
          }

        });

        self.data.loadingStock = false;

        console.info(self.data);

      }

      url = 'https://static.overdose.digital/rembrandt/get_inventory_levels.php';
      store = shop.currentStore.toUpperCase();
      // inventoryItemID = activeVariant.inventory_item_id;
      inventoryVariantID = activeVariant.id;

      $.getJSON(url, {
          variant_id: inventoryVariantID,
          store: store
      }, success);

    }

  });

  return ProductCheckStockPopup;

})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '.product-single__price',
    paymentProviders: '.product-single__payment-provider-info',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productSku: '[data-product-variant-sku]',
    productPrice: '[data-product-price]',
    productImageWrap: '[data-product-images-wrap]',
    productImageContainer: '[data-product-images]',
    productImages: '[data-product-image]',
    productActiveImage: '[data-product-active-image]',
    productThumbContainer: '[data-product-thumbnails]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productQtyWrapper: '.product-form__item--quantity',
    productDetailsSticky: '.product-single__details--sticky',
    productHireFormSticky: '.product-hire-form--sticky',
    combinedVariantSelect: '[data-combined-option-selector]',
    specificationTabs: '.specificaitons__tabs',
    featuredPoints: '.product-featured-points',
    hireForm: '#book-an-appointment',
    sizeData: '#size-guide',
    sizeGuideContainer: '[data-size-guide-container]',
    productOffer: '.product-single__offer',
    openCheckStockButton: '.open-check-stock'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/styles/settings/variables.scss.liquid // $grid-breakpoints
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      enableHistoryState: this.$container.data('enable-history-state') || false,
      sectionId: sectionId,
      sliderActive: false,
      bpSmall: false,
      zoomEnabled: false
    };
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    if ($(selectors.productFeaturedImage, this.$container).length) {
      this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
    }
    this.settings.zoomEnabled = true;
    // this.settings.zoomEnabled = $(selectors.productFeaturedImage).hasClass('js-zoom-enabled');

    // slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initBreakpoints();
    this.initImageSlider();
    this.initGallery();
    this.initSticky();
    // this.initCombinedSelect();
    this.initTabs(this.$container);
    this.initFeaturedPoints(this.$container);
    this.initHireForm();
    // this.sizeGuide();
    // this.initSizeAssuranceModal();
    this.initSizeAssuranceModal();
    var self = this;

    for (var i = $(selectors.productOffer).length - 1; i >= 0; i--) {
      var $productOffer = $(selectors.productOffer)[i];
      this.initVariants($productOffer);
      // this.initSingleOptionsSelects($productOffer);
    }

    var readMoreLink = '<button aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more <svg class="icon icon-fa-caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg></button>';

    if ($('.product-single__description').innerHeight() >= 500) {
      $('.product-single__description').readmore({
        speed: 75,
        collapsedHeight: 420,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function(trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        }
      });
    }

    if ($('.product-single__specifications').innerHeight() >= 480) {
      $('.product-single__specifications').readmore({
        speed: 75,
        collapsedHeight: 400,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function(trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        }
      });
    }

    $(selectors.openCheckStockButton).on('click', function () {

      var productId,
          productHandle,
          variantSelect,
          currentVariantId;

      productId = event.currentTarget.dataset.productId;
      productHandle = event.currentTarget.dataset.productHandle;
      variantSelect = document.getElementsByClassName('ProductSelect-' + productId)[0];
      currentVariantId = variantSelect.value;

      if (!currentVariantId) {
        console.error(new Error('Error retrieving variant ID'));
        return;
      }

      new theme.ProductCheckStockPopup(productHandle, parseInt(currentVariantId));

    })
  }

  // mark unavailable variant after load
  // (function(){
  //   $(window).on('load', function() {
  //     var product = theme.current.product;
  //     var variants_available__counter = 0;
  //     var child_products = theme.current.child_products;


  //     if(child_products) {
  //       child_products.forEach(function(item_product) {

  //         if ($('.single-option--length').length) {
  //           $('.single-option--length').each(function () {
  //             var self_length = $(this);
  //             var self_lengthVal = self_length.val();

  //             if (self_length.is(':checked')) {
  //               $('.single-option--size').each(function () {
  //                 var self_size = $(this);
  //                 var self_sizeVal = self_size.val();

  //                 for (let i = 0; i < item_product.variants.length; i++) {
  //                   const element = item_product.variants[i];
  //                   if (element.option1 == self_sizeVal && element.option2 == self_lengthVal) {
  //                     if (element.available) {
  //                       variants_available__counter++;
  //                     } else {
  //                       self_size.attr('disabled', 'true');
  //                     }
  //                   }
  //                 }
  //               });
  //             } else {
  //               $('.single-option--size').each(function () {
  //                 var self_size = $(this);
  //                 var self_sizeVal = self_size.val();

  //                 for (let i = 0; i < item_product.variants.length; i++) {
  //                   const element = item_product.variants[i];
  //                   if (element.option1 == self_sizeVal && element.option2 == self_lengthVal) {
  //                     if (element.available) {
  //                       variants_available__counter++;
  //                     }
  //                   }
  //                 }
  //               });
  //             }

  //             if (variants_available__counter == 0) {
  //               self_length.attr('disabled', 'true');
  //             }
  //             variants_available__counter = 0;
  //           });
  //         } else {
  //           $('.single-option--size').each(function () {
  //             var self_size = $(this);
  //             var self_sizeVal = self_size.val();

  //             for (let i = 0; i < item_product.variants.length; i++) {
  //               const element = item_product.variants[i];
  //               if (element.option1 == self_sizeVal) {
  //                 if (element.available) {
  //                   variants_available__counter++;
  //                 } else {
  //                   self_size.attr('disabled', 'true');
  //                 }
  //               }
  //             }
  //           });
  //         }
  //       });
  //     } else {
  //       if ($('.single-option--length').length) {
  //         $('.single-option--length').each(function () {
  //           var self_length = $(this);
  //           var self_lengthVal = self_length.val();

  //           if (self_length.is(':checked')) {
  //             $('.single-option--size').each(function () {
  //               var self_size = $(this);
  //               var self_sizeVal = self_size.val();

  //               for (let i = 0; i < product.variants.length; i++) {
  //                 const element = product.variants[i];
  //                 if (element.option1 == self_sizeVal && element.option2 == self_lengthVal) {
  //                   if (element.available) {
  //                     variants_available__counter++;
  //                   } else {
  //                     self_size.attr('disabled', 'true');
  //                   }
  //                 }
  //               }
  //             });
  //           } else {
  //             $('.single-option--size').each(function () {
  //               var self_size = $(this);
  //               var self_sizeVal = self_size.val();

  //               for (let i = 0; i < product.variants.length; i++) {
  //                 const element = product.variants[i];
  //                 if (element.option1 == self_sizeVal && element.option2 == self_lengthVal) {
  //                   if (element.available) {
  //                     variants_available__counter++;
  //                   }
  //                 }
  //               }
  //             });
  //           }

  //           if (variants_available__counter == 0) {
  //             self_length.attr('disabled', 'true');
  //           }
  //           variants_available__counter = 0;
  //         });
  //       } else {
  //         $('.single-option--size').each(function () {
  //           var self_size = $(this);
  //           var self_sizeVal = self_size.val();

  //           for (let i = 0; i < product.variants.length; i++) {
  //             const element = product.variants[i];
  //             if (element.option1 == self_sizeVal) {
  //               if (element.available) {
  //                 variants_available__counter++;
  //               } else {
  //                 self_size.attr('disabled', 'true');
  //               }
  //             }
  //           }
  //         });
  //       }
  //     }


  //   });
  // }());

  (function(){
    $(window).on('load', function() {
      if($('.template-product').length > 0) {

      var product = theme.current.product;
      var variants_available__counter = 0;
      var child_products = theme.current.child_products;
      var length_block = $('.length_options__block');
      var length_block_counter = 0;

        if(child_products) {
          child_products.forEach(function(item_product) {
            if (length_block.length > 0) {
                if (length_block_counter < length_block.length) {
                self_length_block = length_block[length_block_counter];

            if (item_product.handle.includes("jacket") || item_product.handle.includes("blazer") || item_product.handle.includes("suit") || item_product.tags.includes("length-option")) {

              var length_option_block__input = $(self_length_block).find('.single-option--length');
              if (length_option_block__input.length > 0) {
                length_option_block__input.each(function () {
                  var self_length = $(this);

                  var size_option_elem;
                  if (self_length.attr("data-length-type") == "short") {
                    size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
                  } else if (self_length.attr("data-length-type") == "regular") {
                    size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
                  } else if (self_length.attr("data-length-type") == "tall") {
                    size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
                  }

                  if (size_option_elem.length != 0) {
                    $(size_option_elem).each(function() {
                      var self_size = $(this);
                      var self_size_val = $(this).val();

                      for (let i = 0; i < item_product.variants.length; i++) {
                        const element = item_product.variants[i];
                        if (element.option1 == self_size_val) {
                          if (element.available) {
                            variants_available__counter++;
                          } else {
                            self_size.attr('disabled', 'true');
                          }
                        }
                      }
                    });
                  } else {
                    variants_available__counter = 0;
                  }

                  if (variants_available__counter == 0) {
                    self_length.attr('disabled', 'true');
                  } else {
                    self_length.attr('data-length-available', 'true');
                  }

                  variants_available__counter = 0;

                });

                var available_sizes = [];

                var available_length = $(self_length_block).find('.single-option--length[data-length-available=true]');
                var all_size_option = $('.single-option--length[data-length-available=true]').closest(self_length_block).parent().parent().parent().parent().next().find(".single-option--size");

                all_size_option.removeAttr('checked');

                var checked_length;

                available_length.each(function(){
                  var self_available_length = $(this);

                  if (self_available_length.attr('data-length-type') == 'short') {
                    checked_length = self_available_length;
                    checked_length.click();
                    return false;
                  }
                });

                if (checked_length === undefined) {
                  checked_length = $(available_length[0]);
                  checked_length.click();
                }

                var length_value = checked_length.val().split('/');
                var current_length_format = length_value[0] + ' ' + length_value[1];

                var current_length_selector = $('.current_option[name="length"]');
                current_length_selector.text(current_length_format);

                if (checked_length.attr('data-length-type') == "short") {
                  var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
                  size_option_elem.each(function() {
                    var self_size_item = $(this);
                    var size_wrapper = self_size_item.closest('.size_option__wrapper');
                    size_wrapper.css('display', 'block');

                    if (!self_size_item.attr('disabled')) {
                      available_sizes.push(self_size_item);
                    }
                  });
                  } else if (checked_length.attr("data-length-type") == "regular") {
                    var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
                    size_option_elem.each(function() {
                      var self_size_item = $(this);
                      var size_wrapper = self_size_item.closest('.size_option__wrapper');
                      size_wrapper.css('display', 'block');

                      if (!self_size_item.attr('disabled')) {
                        available_sizes.push(self_size_item);
                      }
                    });
                  } else if (checked_length.attr("data-length-type") == "tall") {
                    var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
                    size_option_elem.each(function() {
                      var self_size_item = $(this);
                      var size_wrapper = self_size_item.closest('.size_option__wrapper');
                      size_wrapper.css('display', 'block');

                      if (!self_size_item.attr('disabled')) {
                        available_sizes.push(self_size_item);
                      }
                    });
                  }

                  if(available_sizes.length>0){
                    available_sizes[0].click();
                  }

                  length_block_counter++;
                  }
                }
              }
            } else {

              var option_size_elem = $(".single-option--size[data-product-id="+item_product.id+"]");

              option_size_elem.each(function() {
                var self_only_size__option = $(this);
                var size_option__value = self_only_size__option.val();
                var size_wrapper = self_only_size__option.closest('.size_option__wrapper');

                for (let i = 0; i < item_product.variants.length; i++) {
                  const element = item_product.variants[i];
                  if (element.option1 == size_option__value) {
                    if (element.available) {
                      variants_available__counter++;
                      size_wrapper.css('display', 'block');
                    } else {
                      self_only_size__option.attr('disabled', 'true');
                      size_wrapper.css('display', 'block');
                    }
                  }
                }
              });
            }
          });
        } else {

          if (product.handle.includes("jacket") || product.handle.includes("blazer") || product.handle.includes("suit") || product.tags.includes("length-option")) {

            if ($('.single-option--length').length) {
              $('.single-option--length').each(function () {
                var self_length = $(this);
               // Loops through sizing options

               let allOptions = [];
               let sizeOptions = $('.variants_container .single-option--size').toArray()
               for (var i = 0; i < sizeOptions.length; i++) {
                 let element = sizeOptions[i]
                 if(element.value.length >= 2){
                   let itemLength = element.value.slice(-1).toLowerCase();
                   if (element.value == 'xs' || element.value == 's'){
                     itemLength = 'r'
                   }
                   allOptions.push({value: element.value, element: element, pantLength: itemLength})
                  // console.log("here all options: " , allOptions)
                 }
               }

               var size_option_elem;
               if (self_length.attr("data-length-type") == "short") {
                //  size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
                  size_option_elem = allOptions.filter((item)=> item.pantLength == 's' )

               } else if (self_length.attr("data-length-type") == "regular") {
                 // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
                 size_option_elem = allOptions.filter((item)=> item.pantLength == 'r');
               } else if (self_length.attr("data-length-type") == "tall") {
                 // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
                  size_option_elem = allOptions.filter((item)=> item.pantLength == 't');
               }

               if (size_option_elem) {
                 $(size_option_elem).each(function(i, ele) {
                   var self_size = $(this);
                  //  var self_size_val = $(this)[i].element.value;


                   //Loops through Product Variants
                   for (let i = 0; i < product.variants.length; i++) {
                   const element = product.variants[i];
                       if (element.available) {
                         variants_available__counter++;
                       } else {
                         self_size.attr('disabled', 'true');
                       }
                   }
                 });
               } else {
                 variants_available__counter = 0;
               }

               if (variants_available__counter == 0) {
                 self_length.attr('disabled', 'true');
               } else {
                 self_length.attr('data-length-available', 'true');
               }

               variants_available__counter = 0;

             });

              var available_sizes = [];

              var available_length = $('.single-option--length[data-length-available=true]');
              var all_size_option = $('.single-option--length[data-length-available=true]').parent().parent().parent().parent().next().find(".single-option--size");

              all_size_option.removeAttr('checked');

              var checked_length;

              available_length.each(function(){
                var self_available_length = $(this);

                if (self_available_length.attr('data-length-type') == 'regular') {
                  checked_length = self_available_length;
                  checked_length.click();
                  return false;
                }
              });

                if (checked_length === undefined) {
                  checked_length = $(available_length[0]);
                  checked_length.click();
                }

                var length_value = checked_length.val().split('/');
                var current_length_format = length_value[0] + ' ' + length_value[1];

                var current_length_selector = $('.current_option[name="length"]');
                current_length_selector.text(current_length_format);

                if (checked_length.attr("data-length-type") == 'short') {
                  var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
                  size_option_elem.each(function() {
                    var self_size_item = $(this);
                    var size_wrapper = self_size_item.closest('.size_option__wrapper');
                    size_wrapper.css('display', 'block');

                    if (!self_size_item.attr('disabled')) {
                      available_sizes.push(self_size_item);
                    }
                  });
                  } else if (checked_length.attr("data-length-type") == "regular") {
                    var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
                    size_option_elem.each(function() {
                      var self_size_item = $(this);
                      var size_wrapper = self_size_item.closest('.size_option__wrapper');
                      size_wrapper.css('display', 'block');

                      if (!self_size_item.attr('disabled')) {
                        available_sizes.push(self_size_item);
                      }
                    });
                  } else if (checked_length.attr("data-length-type") == "tall") {
                    var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
                    size_option_elem.each(function() {
                      var self_size_item = $(this);
                      var size_wrapper = self_size_item.closest('.size_option__wrapper');
                      size_wrapper.css('display', 'block');

                      if (!self_size_item.attr('disabled')) {
                        available_sizes.push(self_size_item);
                      }
                    });
                  }

                  if(available_sizes.length>0){
                    available_sizes[0].click();
                  }
            }
          } else {

            var option_size_elem = $(".single-option--size[data-product-id="+product.id+"]");

            option_size_elem.each(function() {
              var self_only_size__option = $(this);
              var size_option__value = self_only_size__option.val();
              var size_wrapper = self_only_size__option.closest('.size_option__wrapper');

              for (let i = 0; i < product.variants.length; i++) {
                const element = product.variants[i];
                if (element.option1 == size_option__value) {
                  if (element.available) {
                    variants_available__counter++;
                    size_wrapper.css('display', 'block');
                  } else {
                    /* self_only_size__option.attr('disabled', 'true'); */
                    size_wrapper.css('display', 'block');
                  }
                }
              }
            });
          }
        }
      }

    });
  }());

  (function(){
    $(window).on('load', function() {
      $('.single-option--length').on('change', function() {
        var self = $(this);

        var size_wrapper = self.parent().parent().parent().parent().next().find('.size_option__wrapper');

        var length_value = self.val().split('/');
        var current_length_format = length_value[0] + ' ' + length_value[1];
        var current_length_selector = $('.current_option[name="length"]');
        current_length_selector.text(current_length_format);

        var available_sizes = [];
        var all_size_option = $('.single-option--length[data-length-available=true]').parent().parent().parent().parent().next().find(".single-option--size");
        all_size_option.removeAttr('checked');

        size_wrapper.css('display', 'none');

        // if (self.attr('data-length-type') == 'short') {

        //   var size_option_elem = self.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");

        // } else if (self.attr('data-length-type') == 'regular') {

        //   var size_option_elem = self.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");

        // } else if (self.attr('data-length-type') == 'tall') {

        //   var size_option_elem = self.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");

        // }

        let allOptions = [];
        let sizeOptions = $('.variants_container .single-option--size').toArray()
        for (var i = 0; i < sizeOptions.length; i++) {
          let element = sizeOptions[i]
          if(element.value.length >= 2){
            let itemLength = element.value.slice(-1).toLowerCase();
            if (element.value == 'xs' || element.value == 's'){
              itemLength = 'r'
            }
            allOptions.push({value: element.value, element: element, pantLength: itemLength})
          }
        }

        var self_length = self;
        var size_option_elem;
        if (self_length.attr("data-length-type") == "short") {
         //  size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
           size_option_elem = allOptions.filter((item)=> item.pantLength == 's' )

        } else if (self_length.attr("data-length-type") == "regular") {
          // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
          size_option_elem = allOptions.filter((item)=> item.pantLength == 'r');
        } else if (self_length.attr("data-length-type") == "tall") {
          // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
           size_option_elem = allOptions.filter((item)=> item.pantLength == 't');
        }

        console.log(size_option_elem)

        $(size_option_elem).each(function() {
          var self_size_item = $(this.element);
          var size_wrapper = self_size_item.closest('.size_option__wrapper');
          size_wrapper.css('display', 'block');

          if (!self_size_item.attr('disabled')) {
            available_sizes.push(self_size_item);
          }
        });

        if(available_sizes.length>0){
          available_sizes[0].click();
        }
      });
    });
  }());
  // (function(){
  //   $(window).on('load', function() {
  //     $('.single-option--length').on('change', function() {

  //       var product = theme.current.product;
  //       var self_length = $(this);
  //       var self_lengthVal = self_length.val();

  //       $('.single-option--size').each(function () {
  //         var self_size = $(this);
  //         var self_sizeVal = self_size.val();

  //         for (let i = 0; i < product.variants.length; i++) {
  //           const element = product.variants[i];
  //           if (element.option1 == self_sizeVal && element.option2 == self_lengthVal) {
  //             if (element.available) {
  //               if(self_size.attr('disabled', 'true')) {
  //                 self_size.removeAttr('disabled');
  //               }
  //             } else {
  //               self_size.attr('disabled', 'true');
  //             }
  //           }
  //         }
  //       });
  //     });
  //   });
  // }());

  Product.prototype = $.extend({}, Product.prototype, {

    initSizeAssuranceModal: function() {
      var sizeAssuranceModal = new theme.Modals('#SizeAssuranceModal', 'size-assurance-modal', {});

      $('.guarant_learn_more').on('click', function(){
        sizeAssuranceModal.open();
      });

      $('.size-assurance-modal__close').on('click', function(){
        sizeAssuranceModal.close();
      });

    },
    /**
     * Uses enquire.js to handle breakpoint related actions
     */
    initBreakpoints: function() {
      // var self = this;

      // enquire.register(this.settings.mediaQuerySmall, {
      //   match: function() {
      //     self.settings.bpSmall = true;
      //   },
      //   unmatch: function() {
      //       self.settings.bpSmall = false;
      //   }
      // });

      // enquire.register(this.settings.mediaQueryMediumUp, {
      //   match: function() {

      //   }
      // });
    },

    /**
     * Creates linked sliders for product main and thumb images
     */
    initImageSlider: function() {

      var config = {
        mediaQueryLargeUp: 'screen and (min-width: 992px)'
      };

      var thumbOptions = {
        slidesToShow: 5,
        swipeToSlide: true,
        infinite: true,
        asNavFor: selectors.productImageContainer,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      var mainOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        arrows: false,
        infinite: true,
        focusOnSelect: true,
        fade: true,
        adaptiveHeight: false,
        prevArrow: selectors.productImageContainer + ' ~ .product-single__images__prev',
        nextArrow: selectors.productImageContainer + ' ~ .product-single__images__next',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              // arrows: true,
              fade: false,
              dots: true,
              swipe: true,
              adaptiveHeight: true,
            }
          }
        ]
      };

      $activeProductImage = $(selectors.productActiveImage).first();
      if ($activeProductImage.length > 0) {
        var firstSlide = $activeProductImage.index() || 0;
        mainOptions.initialSlide = firstSlide;
      }

      if ($(selectors.productImageWrap, this.$container).is('[data-vertical]')) {
        thumbOptions = $.extend({}, thumbOptions, {
          vertical: true,
          verticalSwiping: true,
        });
      }
      
      if ($(selectors.productThumbContainer) && $(selectors.productThumbContainer).hasClass('slick-initialized')) {
        $(selectors.productThumbContainer).slick('unslick');
      }
      
      if ($(selectors.productImageContainer) && $(selectors.productImageContainer).hasClass('slick-initialized')) {
        $(selectors.productImageContainer).slick('unslick');
      }

      if (this.productSingleObject.images.length > 1) {
        $(selectors.productThumbContainer).slick(thumbOptions);
      }

      $(selectors.productImageContainer).slick(mainOptions);

      this.settings.sliderActive = true;

      enquire.register(config.mediaQueryLargeUp, {
        match: function() {
          $(selectors.productImageContainer).slick('slickGoTo', 0);
        }
      });

    },

    initSticky: function() {
      if ($(selectors.productDetailsSticky).length) {
        $(selectors.productDetailsSticky).stickybits({stickyBitStickyOffset: 75});
      }
      if ($(selectors.productHireFormSticky).length) {
        $(selectors.productHireFormSticky).stickybits({stickyBitStickyOffset: 125});
      }
    },

    initHireForm: function() {

      var $form = $(selectors.hireForm);

      if (!$form.length) {
        return;
      }

      var hireform = new theme.HireForm($form);
    },


    sizeGuide: function() {

      var sizeData = JSON.parse($(selectors.sizeData).html());

      if (!sizeData) {
        return;
      }

      for (var i = $(selectors.sizeGuideContainer).length - 1; i >= 0; i--) {
        var $container = $(selectors.sizeGuideContainer)[i];
        var type = $($container).data('size-type');
        var url = sizeData[type] || false;
        if (url) {
          $($container).removeClass('hidden');
          var $btn = $($container).find('.btn');
          $($btn).attr('data-featherlight', url);
          $($btn).featherlight();
        }
      }

    },

    initTabs: function(container) {
      var $tabs = $(container).find(selectors.specificationTabs);
      if (!$tabs.length) {
        return;
      }
      this.tabs = {};
      for (var i = $tabs.length - 1; i >= 0; i--) {
        var $tabGroup   = $($tabs)[i];
        var tabGroupId = $($tabGroup).attr('id');

        this.tabs[tabGroupId] = new theme.TabsGroup($tabGroup);
      }

      var self = this;
      $('a[data-tabstarget]').on('click', function (){
        var tabGroupId      = $(this).data('tabsgroup');
        var tabGroupTarget  = $(this).data('tabstarget');
        var tabGroup        = self.tabs[tabGroupId];
        tabGroup.goToTab(tabGroupTarget);
      });
    },

    initFeaturedPoints: function(container) {
      var $featuredPoints = $(container).find(selectors.featuredPoints);
      if (!$featuredPoints.length) {
        return;
      }
      this.featuredPoints = {};
      for (var i = $featuredPoints.length - 1; i >= 0; i--) {
        this.featuredPoints[i] = new theme.ProductFeaturedPoints($($featuredPoints)[i]);
      }
    },

    initSingleOptionsSelects: function() {

      // var $productOffer = $(this);

      // console.info($productOffer);

      // var $selects = $(selectors.singleOptionSelector, $productOffer);

      // var config = {
      //   searchEnabled: false,
      //   callbackOnCreateTemplates: function (template) {
      //     var classNames = this.config.classNames;
      //     return {
      //       choice: function choice(data) {
      //         if (!data.customProperties) {
      //           return template(
      //           '<div class="' + classNames.item + ' ' + classNames.itemChoice + ' ' + (data.disabled ? classNames.itemDisabled : classNames.itemSelectable) + '" data-choice ' + (data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable') + ' data-id="' + data.id + '" data-value="' + data.value + '" ' + (data.groupId > 0 ? 'role="treeitem"' : 'role="option"') + '>' +
      //               '<span>' + data.label + '</span>' +
      //           '</div>');
      //         }
      //         return template(
      //           '<div class="' + classNames.item + ' ' + classNames.itemChoice + ' ' + (data.disabled ? classNames.itemDisabled : classNames.itemSelectable) + '" data-choice ' + (data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable') + ' data-id="' + data.id + '" data-value="' + data.value + '" ' + (data.groupId > 0 ? 'role="treeitem"' : 'role="option"') + '>' +
      //               '<span class="item__color">' + data.customProperties.color + '</span>' +
      //               '<span class="item__size">' + data.customProperties.size + '</span>' +
      //           '</div>');
      //       }
      //     };
      //   }
      // };

      // window.selects = window.selects || {};

      // $.each($selects, function(index, select) {
      //   // var id = $(select).attr('id');

      //   // if (window.selects[id]) {
      //   //   window.selects[id].destroy();
      //   // } else {
      //   //   window.selects[id] = new Choices(select, config);
      //   //   console.info(window.selects[id]);
      //   // }

      // });

    },

    initCombinedSelect: function() {

      var $select = $(selectors.combinedVariantSelect);
      if (!$select.length) {
        return;
      }

      var selects = {};

      var config = {
        searchEnabled: false,
        callbackOnCreateTemplates: function (template) {
          var classNames = this.config.classNames;
          return {
            choice: function choice(data) {
              if (!data.customProperties) {
                return template(
                '<div class="' + classNames.item + ' ' + classNames.itemChoice + ' ' + (data.disabled ? classNames.itemDisabled : classNames.itemSelectable) + '" data-choice ' + (data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable') + ' data-id="' + data.id + '" data-value="' + data.value + '" ' + (data.groupId > 0 ? 'role="treeitem"' : 'role="option"') + '>' +
                    '<span>' + data.label + '</span>' +
                '</div>');
              }
              return template(
                '<div class="' + classNames.item + ' ' + classNames.itemChoice + ' ' + (data.disabled ? classNames.itemDisabled : classNames.itemSelectable) + '" data-choice ' + (data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable') + ' data-id="' + data.id + '" data-value="' + data.value + '" ' + (data.groupId > 0 ? 'role="treeitem"' : 'role="option"') + '>' +
                    '<span class="item__color">' + data.customProperties.color + '</span>' +
                    '<span class="item__size">' + data.customProperties.size + '</span>' +
                '</div>');
            }
          };
        }
      };

      for (var i = $(selectors.combinedVariantSelect).length - 1; i >= 0; i--) {
        var $select = $(selectors.combinedVariantSelect)[i];
        var selectOpions = JSON.parse($($select).attr('data-options'));
        selects[i] = new Choices($($select)[0], config);
        selects[i].setChoices(selectOpions, 'value', 'label', true);
      }


    },
    /**
     * Sets up product image lightbox with Photoswipe.js
     */
    initGallery: function() {
      var self = this;

      if (self.settings.zoomEnabled) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = $('[data-pswp-items]').data('pswp-items');

        $('.zoom-js').click(function(e){
          e.preventDefault();

          options = {
            index: $(this).data('index'),
            barsSize: {top:0,bottom:0},
            captionEl: false,
            fullscreenEl: false,
            shareEl: false,
            bgOpacity: 0.96,
            tapToClose: true,
            tapToToggleControls: false,
            history: false,
            getThumbBoundsFn: function(index) {
              var activeThumbIndex = $(window).width() > 992 ? 1 : 0;
              var $activeThumbnails = $('.zoom-js[data-index="' + index + '"]');
              var thumbnail = $activeThumbnails.eq(Math.min(activeThumbIndex, ($activeThumbnails.length - 1))).find('img')[0];
              var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect(),
              thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
              return {x: rect.left + thumbInfo.left, y: rect.top + pageYScroll, w: thumbInfo.width};
            }
          };

          if (pswpElement.classList.contains('pswp--open')) {
            return;
          }
          
          var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);

          var realViewportWidth,
              useLargeImages = false,
              firstResize = true,
              imageSrcWillChange;

          // gettingData event fires each time PhotoSwipe retrieves image source & size
          gallery.listen('gettingData', function(index, item) {

            realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

            // Set image source & size based on real viewport width
            if( useLargeImages ) {
              item.src = item.originalImage.src;
              item.w = item.originalImage.w;
              item.h = item.originalImage.h;
              item.msrc = item.originalImage.msrc;
            } else {
              if (realViewportWidth > 1024) {
                item.w = 1600;
              } else if (realViewportWidth > 768) {
                item.w = 1024;
              } else if (realViewportWidth > 640) {
                item.w = 768;
              } else if (realViewportWidth > 480) {
                item.w = 640;
              } else {
                item.w = 480;
              }
              item.w = Math.min(item.w, item[index].originalWidth);
              item.h = Math.round(item.w / item[index].ratio);

              var itemSrcTemplate = decodeURI(item[index].src);
              item.src = itemSrcTemplate.replace('{width}', item.w);
              // item.msrc = itemSrcTemplate.replace('{width}', 180);

              var $imageElem = $(selectors.productImageContainer + ' [data-slick-index="' + index + '"]:not(.slick-cloned) img');
              item.msrc = $imageElem.prop('currentSrc') || $imageElem.attr('src') || item[index].msrc;
            }

            // It doesn't really matter what will you do here,
            // as long as item.src, item.w and item.h have valid values.
            //
            // Just avoid http requests in this listener, as it fires quite often

          });

          gallery.listen('close', function() {
            console.info('Close');
            if (self.settings.sliderActive && $(window).width() < 992) {
              console.info('Close with slider');
              $(selectors.productImageContainer).slick('slickGoTo', this.getCurrentIndex());
            }
          });

          gallery.init();

        });
      }
    },

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function($productOffer) {

      var product = JSON.parse($('[data-offer-json]', $productOffer).html());

      var options = {
        $container: $($productOffer),
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: $($productOffer).find(selectors.singleOptionSelector),
        originalSelectorId: $($productOffer).find(selectors.originalSelectorId),
        product: product
      };

      var variants = new slate.Variants(options);

      $($productOffer).on('variantChange' + this.namespace, this.updateAddToCartState.bind($productOffer));
      // $($productOffer).on('variantChange' + this.namespace, this.initSingleOptionsSelects.bind($productOffer));
      // $($productOffer).on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      $($productOffer).on('variantPriceChange' + this.namespace, this.updateProductPrices.bind($productOffer));
      // $($productOffer).on('variantSKUChange' + this.namespace, this.updateSKU.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this).removeClass('hide');
        $(selectors.paymentProviders, this).removeClass('hide');
      } else {
        $(selectors.addToCart, this).prop('disabled', true);
        $(selectors.addToCartText, this).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this).addClass('hide');
        $(selectors.paymentProviders, this).addClass('hide');
        return;
      }

      if (variant.available) {
        var quantityAvailable = Math.max(variant.inventory_quantity, 0);
        quantityAvailable = quantityAvailable > 0 ? quantityAvailable : 999;
        $(selectors.productQtyWrapper + ' input', this).prop('max', quantityAvailable);
        $(selectors.productQtyWrapper + ' input', this).prop('min', 1);
        $(selectors.addToCart, this).prop('disabled', false);
        $(selectors.addToCartText, this).html(theme.strings.addToCart);
      } else {
        $(selectors.productQtyWrapper + ' input', this).prop('max', 0);
        $(selectors.productQtyWrapper + ' input', this).prop('min', 0);
        $(selectors.addToCart, this).prop('disabled', true);
        $(selectors.addToCartText, this).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;

      var $comparePrice = $(selectors.comparePrice, this);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this);
      var comparePrefixString = $comparePrice.data('prefix-string') || '';
      var compareSuffixString = $comparePrice.data('suffix-string') || '';

      $(selectors.productPrice, this)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(comparePrefixString + slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + compareSuffixString);
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      var $afterpayInstallments = $('#afterpay_instalments', this);
      if ($afterpayInstallments.length) {
        $afterpayInstallments.html(slate.Currency.formatMoney(variant.price/4, theme.moneyFormat));
      }

      var $laybuyInstallments = $('#laybuy_instalments', this);
      if ($laybuyInstallments.length) {
        $laybuyInstallments.html(slate.Currency.formatMoney(variant.price/6, theme.moneyFormat));
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var self = this;
      var variant = evt.variant;

      if (self.settings.sliderActive) {
        var imageIndex = $('[data-image-id="' + variant.featured_image.id + '"]:not(.slick-cloned)').data('slick-index');
        $(selectors.productImageContainer).slick('slickGoTo', imageIndex);
      } else {
        var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
        $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
      }
    },

    /**
     * Updates the DOM with specified Variant SKU
     */
    updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(selectors.productSku, this.$container).html(variant.sku);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.productInfoDrawer = (function() {

  var selectors = {
    openDrawer: '[data-product-info-drawer]',
    parent: '#PageContainer',
    insertAfter: '.shopify-section-group-header-group'
  };

  function init() {

    var $drawer,
        $drawerContent,
        $drawerBack,
        $parent,
        isOpen,
        backButtonTemplate;

    $drawer = $('<div id="productInfoDrawer" class="product-info-drawer"></div>');
    $drawerWrapper = $('<div class="product-info-drawer__wrapper"></div>');
    $drawerContent = $('<div class="product-info-drawer__content"></div>');
    $drawerBack = $('<button class="btn btn--large btn--text product-info-drawer__back"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-back" viewBox="0 0 26 20"><path d="M2.86 10l7.368 7.814a1 1 0 1 1-1.456 1.372l-8-8.485a1 1 0 0 1-.272-.686c0-.285.097-.53.272-.716l8-8.485a1 1 0 0 1 1.456 1.372L2.86 10z"></path><path d="M25 9c.552 0 1 .644 1 1s-.448 1-1 1H2a1 1 0 0 1 0-2h23z"></path></svg>Back to product</button>');
    $drawerOverlay = $('<button class="product-info-drawer__overlay"></button>');

    $drawer.append($drawerWrapper);
    $drawer.append($drawerOverlay);
    $drawerWrapper.append($drawerContent);
    $drawerWrapper.prepend($drawerBack);

    $parent = $(selectors.parent);
    $insertAfter = $(selectors.insertAfter);

    $drawer.insertBefore($insertAfter);

    function open() {
      $drawer.addClass('open');
      $parent.addClass('product-info-drawer-is-open');
      isOpen = true;
      $('html').css('overflow', 'hidden');
    }

    function close() {
      $drawer.removeClass('open');
      $parent.removeClass('product-info-drawer-is-open');
      isOpen = false;
      $('html').css('overflow', '');
    }

    $drawerBack.on('click', function() {
      close();
    });

    $drawerOverlay.on('click', function() {
      close();
    });

    $(selectors.openDrawer).on('click', function() {

      var template = $(this).data().productInfoDrawer;
      var content = theme.utils.getTemplate(template);
      var title = $(this).data().productInfoDrawerTitle;
      $drawerContent.attr('data-template', template);

      $drawerContent.html(content);

      if (title) {
        $drawerContent.prepend('<h2>' + title + '</h2>');
      }

      if (!isOpen) {
        open();
      }

    });

  }

  init();

  return;

})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    slideCount: 0
  };
  var defaults = {
    arrows: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    defaults.prevArrow = '#Quotes-' + sectionId + ' ~ .slideshow__prev';
    defaults.nextArrow = '#Quotes-' + sectionId + ' ~ .slideshow__next';

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.BrandValueSliders = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    slideCount: 0,
    anchorPosition: 'above', // above, below
    anchorElement: '.site-header-lower',
    anchorViewport: 'small' // large, small
  };

  var cache = {
    anchorMarginBottom: 0,
    anchorMarginTop: 0,
    anchorOffset: 0
  }

  var defaults = {
    arrows: false,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    swipeToSlide: true,
    slidesToScroll: 1
  };

  function brandValueSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.brand-values-wrap';
    var slider = this.slider = '#brand-values-' + sectionId;
    var $slider = $(slider, wrapper);
    var $contentContainer = $('#PageContent');
    var $anchorElement = $(config.anchorElement);

    var mobileOptions = $.extend({}, defaults, {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: $slider.data('autoplay-mobile'),
      autoplaySpeed: $slider.data('speed')
    });

    var sliderActive = false;
    var desktopOptions = $.extend({}, defaults, {
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop')
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if ($anchorElement.length) {
      cache.anchorMarginTop = parseInt($anchorElement.css("marginTop").replace('px', ''));
      cache.anchorMarginBottom = parseInt($anchorElement.css("marginBottom").replace('px', ''));
    }

    enquire.register(config.mediaQuerySmall, {
      deferSetup: true,
      match: function() {
        initSlider($slider, mobileOptions);

        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px'
          });

          if (config.anchorViewport == 'small' || config.anchorViewport == 'all') {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'top': cache.anchorOffset + 'px'
                };
                break;
              default:
                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'top': cache.anchorOffset + 'px'
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px'
            };
            var sliderAdjustment = {
              'position': 'static',
              'top': '0px'
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      deferSetup: true,
      match: function() {
        initSlider($slider, desktopOptions);
        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px'
          });

          if (config.anchorViewport == 'large' || config.anchorViewport == 'all') {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'position': 'fixed',
                  'top': cache.anchorOffset + 'px'
                };
                break;
              default:
                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'position': 'fixed',
                  'top': cache.anchorOffset + 'px'
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px'
            };
            var sliderAdjustment = {
              'position': 'static',
              'top': '0px'
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
        $('.brand-values-clone').empty();
      }

      // Clone brand values content to other site areas
      // #TODO: Attach this to the main slider init so it functions as a slider
      sliderObj.clone().addClass('brand-values--cloned').removeAttr('id').removeAttr('style').appendTo('.brand-values-clone');

      sliderObj.slick(args);
      sliderActive = true;

      if ($anchorElement.length) {
        if ($(window).width() < 750) {
          switch (config.anchorPosition) {
            case 'above':
              $anchorElement.css('margin-top', sliderObj.outerHeight() + 'px');
              break;
            default:
              $anchorElement.css('margin-bottom', sliderObj.outerHeight() + 'px');
              break;
          }
        }
      }
    }
  }

  brandValueSliders.prototype = _.assignIn({}, brandValueSliders.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.brand-values__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return brandValueSliders;
})();

window.theme = window.theme || {};

theme.FeaturedCollection = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    slideCount: 0
  };

  var sliderOptions = {
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
  };

  function featuredCollection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.featured-collection-wrap';
    var slider = this.slider = '#featured-collection-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = $.extend({}, sliderOptions, {
      prevArrow: slider + ' ~ .featured-collection__prev',
      nextArrow: slider + ' ~ .featured-collection__next',
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      responsive: [
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: true,
            // dots: true,
            autoplay: $slider.data('autoplay-mobile'),
          }
        },
        {
          breakpoint: 512,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            // dots: true
          }
        }
      ]
    });

    $slider.on('init', this.a11y.bind(this));

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;

      $('input[type="number"]', sliderObj).not('.js-qty-select input[type="number"]').each( function(){
        var $el = $(this);
        theme.QuantitySelectors.init($el);
      });
    }
  }

  featuredCollection.prototype = _.assignIn({}, featuredCollection.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return featuredCollection;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.FeaturedCollections = (function() {
  var selectors = {
    collectionLink: '.featured_colections__header-item',
    selectedCollectionsWrap: '.selected-collections-wrap'
  };

  function FeaturedCollections(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;
    var activeCollectionHandle = $('[data-block-id]', $container).first().data('related-collection');

    var config = {
      mediaQuerySmall: 'screen and (max-width: 991px)',
      mediaQueryMediumAndUp: 'screen and (min-width: 992px)',
    };

    // if($(selectors.selectedCollectionsWrap).length) {

    //   var $narrowContainer = $('.container.narrow');
    //   if($narrowContainer.length) {
    //     var $sliderWidth = $narrowContainer.width() + ((window.innerWidth - $narrowContainer.width()) / 2) + 'px';

    //      $(selectors.selectedCollectionsWrap).css({'min-width': $sliderWidth});
    //   }
    // }

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

     $(selectors.collectionLink + '[data-related-collection=' + activeCollectionHandle + ']', $container).addClass('active');
     let margin_slider = (($('.text-with-button-section .container  ').outerWidth(true) -$('.text-with-button-section .container  ').outerWidth() )/2) ;
 $('.selected-collections-container .slick-track').attr('style',`margin-left: ${margin_slider + 50}px`);
 $('.selected-collections-section .section-header .section-header__title').attr('style',`margin-left: ${margin_slider+80}px`);
    $(slideshow).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var nextCollectionHandle = $('[data-slick-index="' + nextSlide + '"]:not(.slick-cloned) [data-related-collection]', $container).data('related-collection');
      if (nextCollectionHandle != activeCollectionHandle) {
        activeCollectionHandle = nextCollectionHandle;

        $(selectors.collectionLink, $container).removeClass('active');
        $(selectors.collectionLink + '[data-related-collection="' + activeCollectionHandle + '"]', $container).addClass('active');
      }
    });

    $(selectors.collectionLink, $container).on('click', function(evt){
      evt.preventDefault();
      var $this = $(this);

      var relatedCollectionHandle = $this.data('related-collection');
      var $slide = $('.slick-slide[data-slick-index="' + $this.data('first-product') + '"]:not(.slick-cloned)', $container).first();
      var slideIndex = $slide.data('slick-index');
      $(slideshow).slick('slickGoTo', slideIndex);
    });


    enquire.register(config.mediaQueryMedium, {
      match: function() {
        if (!elementOptions.disableMobile) {
          initSlider(self.$slideshow, self.settings.mobile);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });
  }

  return FeaturedCollections;
})();

theme.FeaturedCollections.prototype = _.assignIn({}, theme.FeaturedCollections.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


window.theme = window.theme || {};

theme.FeaturedProducts = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    slideCount: 0
  };

  var sliderOptions = {
    autoplay: false,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true
  };

  function featuredProducts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.featured-product-wrap';
    var slider = this.slider = '#featured-product-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = $.extend({}, sliderOptions, {
      prevArrow: slider + ' ~ .featured-product__prev',
      nextArrow: slider + ' ~ .featured-product__next'
    });

    $slider.on('init', this.a11y.bind(this));

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  featuredProducts.prototype = _.assignIn({}, featuredProducts.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return featuredProducts;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageRows = (function() {

  function ImageRows(container) {
    // var $container = this.$container = $(container);
    // var sectionId = $container.attr('data-section-id');
    // var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    // theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return ImageRows;
})();

theme.ImageRows.prototype = _.assignIn({}, theme.ImageRows.prototype, {
  // onUnload: function() {
  //   delete theme.slideshows[this.slideshow];
  // },

  // onBlockSelect: function(evt) {
  //   var $slideshow = $(this.slideshow);

  //   // Ignore the cloned version
  //   var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
  //   var slideIndex = $slide.data('slick-index');

  //   // Go to selected slide, pause autoplay
  //   $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  // },

  // onBlockDeselect: function() {
  //   // Resume autoplay
  //   $(this.slideshow).slick('slickPlay');
  // }
});

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.HeroPromo = (function() {

  function HeroPromo(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return HeroPromo;
})();

theme.HeroPromo.prototype = _.assignIn({}, theme.HeroPromo.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.hero__nav'
    }).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

// shame code need TODO like product.js

$('.hero__nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '#Slideshow-hero-promo',
    arrows: true,
    dots: true,
    focusOnSelect: true
});


var counterClick = 1;

// click for slick btn left part

$('.hero__nav').find('.slick-active').each(function () {
    $(this).on('click' , function(){
        counterClick = $(this).data('slick-index') + 1;
    });
});

// for click btn

$('.slideshow__next').on('click', function(){

    var btnNext = $(this);

    var $active = $('.hero__nav .slick-current');
    var $next = $active.next('.slick-slide');

    if (!$next.length) {
      $next = $('.hero__nav').find('.slick-slide').first();
    }

    $active.removeClass('slick-current');
    $next.addClass('slick-current');

    btnNext.prop('disabled', true);

    // counterClick++;

    // if(counterClick > 6 || counterClick == 0) {
    //     $('.slick-slide[data-slick-index="5"]').removeClass('slick-current');
    //     $('.slick-slide[data-slick-index="0"]').addClass('slick-current');
    //     counterClick = 1;
    // }

    // some disable , wait in slider response - shame code
    setTimeout(function(){
        btnNext.prop('disabled', false);
    }, 1000);

});

$('.slideshow__prev').on('click', function(){

    var btnPrev = $(this);
    btnPrev.prop('disabled', true);

    var $active = $('.hero__nav .slick-current');
    var $prev = $active.prev('.slick-slide');

    if (!$prev.length) {
      $prev = $('.hero__nav').find('.slick-slide').last();
    }

    $active.removeClass('slick-current');
    $prev.addClass('slick-current');

    // counterClick--;

    // if(counterClick == 0 || counterClick < -6){
    //     $('.slick-slide[data-slick-index="0"]').removeClass('slick-current');
    //     $('.slick-slide[data-slick-index="5"]').addClass('slick-current');
    //     counterClick = -1;
    // }

    // some disable , wait in slider response - shame code
    setTimeout(function(){
        btnPrev.prop('disabled', false);
    }, 1000);
});
window.theme = window.theme || {};

theme.ContentSliders = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 600px)',
    mediaQueryMedium: 'screen and (min-width: 601px) and (max-width: 991px)',
    mediaQueryLargeUp: 'screen and (min-width: 992px)'
  };

  function contentSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.content-slider-wrap';
    var slider = this.slider = '#content-slider-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      infinite: $slider.data('infinite'),
      prevArrow: slider + ' ~ .content-slider__prev',
      nextArrow: slider + ' ~ .content-slider__next',
      arrows: $slider.data('arrows'),
      dots: $slider.data('dots'),
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop'),
      slidesToScroll: $slider.data('slides-scroll-desktop'),
      rows: $slider.data('rows-desktop'),
      slidesPerRow: $slider.data('per-row-desktop')
    };

    var tabletOptions = $.extend({}, options, {
      slidesToShow: $slider.data('slides-show-tablet'),
      slidesToScroll: $slider.data('slides-scroll-tablet'),
      rows: $slider.data('rows-tablet'),
      slidesPerRow: $slider.data('per-row-tablet')
    });

    var mobileOptions = $.extend({}, options, {
      arrows: $slider.data('arrows-mobile'),
      dots: $slider.data('dots-mobile'),
      autoplay: $slider.data('autoplay-mobile'),
      slidesToShow: $slider.data('slides-show-mobile'),
      slidesToScroll: $slider.data('slides-scroll-mobile'),
      rows: $slider.data('rows-mobile'),
      slidesPerRow: $slider.data('per-row-mobile')
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function() {
        initSlider($slider, tabletOptions);
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function() {
        initSlider($slider, options);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }

    $('.slideshow__video', wrapper).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
  }

  contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return contentSliders;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.LatestBlogPosts = (function() {
  function LatestBlogPosts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return LatestBlogPosts;
})();

theme.LatestBlogPosts.prototype = _.assignIn({}, theme.LatestBlogPosts.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

// $(document).ready(function() {
//   var showChar = 100;
//   var ellipsesText = "...";
//   var moreText = "Read more";
//   var lessText = "Read less";


//   $('.info-block__text--mobile p').each(function() {
//     var content = $(this).html();

//     if(content.length > showChar) {

//       var c = content.substr(0, showChar);
//       var h = content.substr(showChar, content.length - showChar);

//       var html = c + '<span class="moreellipses">' + ellipsesText+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="moreLink">' + moreText + '</a></span>';

//       $(this).html(html);
//     }

//   });

//   $(".moreLink").click(function(){
//     if($(this).hasClass("less")) {
//       $(this).removeClass("less");
//       $(this).html(moreText);
//     } else {
//       $(this).addClass("less");
//       $(this).html(lessText);
//     }
//     $(this).parent().prev().toggle();
//     $(this).prev().toggle();
//     return false;
//   });
// });
// product preview


function updateTransformForMobile(index){

    index.each(function(){
        var matrix = $(this).css("transform").replace(/[^0-9\-.,]/g, '').split(',');
        var x = matrix[12] || matrix[4];
        var y = matrix[13] || matrix[5];

        $(this).css({
            'transform' : 'translate(' + x+'%' +','+ y +'%' + ')'
        })
    });
}


$(window).on('load', function(){
    if($(window).width() < 768) {
        updateTransformForMobile($('.product-preview__tooltip'));
    }
});


$('.product-preview__btn').each(function(){

    $(this).on('click', function(){
        $(this).parents('.product-preview__item').toggleClass('active');
    });
});
/*============================================================================
  PRODUCT FEATURED POINTS
==============================================================================*/
window.theme = window.theme || {};

theme.ProductFeaturedPointsEditor = (function() {

  var selectors = {
    featuredPoints: '.product-featured-points',
  };

  function ProductFeaturedPointsEditor(container) {

    var $featuredPoints = $(container).find(selectors.featuredPoints);
    if (!$featuredPoints.length) {
      return;
    }
    var featuredPoints = this.featuredPoints = new theme.ProductFeaturedPoints($featuredPoints);

  }

  ProductFeaturedPointsEditor.prototype = _.assignIn({}, ProductFeaturedPointsEditor.prototype, {

    onUnload: function() {

    },

  });

  return ProductFeaturedPointsEditor;
})();
// $(document).ready(function() {
//   var showChar = 65;
//   var ellipsesText = "...";
//   var moreText = "Read more";
//   var lessText = "Read less";


//   $('.stockist-list__text--mobile p').each(function() {
//     var content = $(this).html();

//     if(content.length > showChar) {

//       var c = content.substr(0, showChar);
//       var h = content.substr(showChar, content.length - showChar);

//       var html = c + '<span class="moreellipses">' + ellipsesText+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="moreLink">' + moreText + '</a></span>';

//       $(this).html(html);
//     }

//   });

//   $(".moreLink").click(function(){
//     if($(this).hasClass("less")) {
//       $(this).removeClass("less");
//       $(this).html(moreText);
//     } else {
//       $(this).addClass("less");
//       $(this).html(lessText);
//     }
//     $(this).parent().prev().toggle();
//     $(this).prev().toggle();
//     return false;
//   });
// });
window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.CtaModule = (function() {

    function CtaModule(container){
        var $container = this.$container = $(container);
        var ctaBlock = $container.find('.cta-module__block');

        if (!ctaBlock.length) {
            return;
        }

        var sectionIdHeightTop = ctaBlock.offset().top;

        if (document.body.classList.contains('promo-banner-shown')) {
          sectionIdHeightTop = sectionIdHeightTop - 60;
        }

        // check scroll height
        $(window).scroll(function () {
            var scrollTop = $(window).scrollTop();

            if(scrollTop > sectionIdHeightTop){
                ctaBlock.addClass('fixed');
            } else {
                ctaBlock.removeClass('fixed');
            }

            // added special class if near promo section
            if(scrollTop < $('.promo-form-section').offset().top - 250){
                ctaBlock.removeClass('hide');
            } else {
                ctaBlock.addClass('hide');
            }

        });

        // for click
        $('.cta-module__btn').click(function () {
            ctaBlock.addClass('hide');

            $('body,html').animate({
                scrollTop: $('.promo-form-section').offset().top - 80
            }, 1000);

        });
    }

    return CtaModule;

})();
window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.StoreLocatorFilter = (function() {

    function StoreLocatorFilter(container) {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');

        var listsItems = $('.store-list__item');

        // button elements
        $('.filter__btn').each(function(){
           var btn = $(this);

           // event click
            btn.on('click', function(){
                var dataValue = $(this).data('filter');

                // remove class
                $('.filter__btn').removeClass('active');
                $(this).addClass('active');
                listsItems.removeClass('visible');
                listsItems.removeClass('hidden');


                // items with data
                listsItems.each(function () {
                    var item = $(this);

                    // check data attribute
                    if(item.data('filter') === dataValue){
                        $(this).addClass('visible');
                    } else {
                        $(this).addClass('hidden');
                    }
                });
           });
        });

        // clear button
        $('.filter__btn--clear').on('click', function () {
            $('.filter__btn').removeClass('active');
            listsItems.removeClass('visible');
            listsItems.removeClass('hidden');
        });

        // filter btn

        if($(window).width() < 768){
            $('.filter > span').on('click', function () {
                $(this).toggleClass('active');
            });
        }
    }

    return StoreLocatorFilter;
})();
window.theme = window.theme || {};

theme.PromoForm = (function() {

  var selectors = {
      hireForm: '#book-an-appointment'
  };

  function PromoForm() {

    var $form = $(selectors.hireForm);

    if (!$form.length) {
      return;
    }

    var hireform = new theme.HireForm($form);

  }

  return PromoForm;
})();
window.theme = window.theme || {};

theme.articleFeatures = (function() {

  var selectors = {
    featuredPointsButton: '.featured-points__button'
  };

  function articleFeatures() {

    $(selectors.featuredPointsButton).on('mouseenter', function() {

      if (isMobile.any) {
        return;
      }
      var cacheWidth = $(this).innerWidth();
      if (!$(this).data('width')) {
        $(this).attr('data-width', cacheWidth);
      }
      var width = $(this).find('span').width() + (cacheWidth * 1.5) ;
      $(this).outerWidth(width + 'px');

    }).on('mouseleave', function(){

      if (isMobile.any) {
        return;
      }
      var width = $(this).data('width');
      $(this).outerWidth(width);

    });

  }

  return articleFeatures;
})();

var calcTable = {
    "knitwear":
        {
            "size": [
                {
                    "name": "XS",
                    "chest": [
                        78,
                        85.9
                    ]
                },
                {
                    "name": "S",
                    "chest": [
                        86,
                        93.9
                    ]
                }, {
                    "name": "M",
                    "chest": [
                        94,
                        99.9
                    ]
                }
                ,
                {
                    "name": "L",
                    "chest": [
                        100,
                        107.9
                    ]
                }
                ,
                {
                    "name": "XL",
                    "chest": [
                        108,
                        119.9
                    ]
                }
                ,
                {
                    "name": "2XL",
                    "chest": [
                        120,
                        127.9
                    ]
                }
                ,
                {
                    "name": "3XL",
                    "chest": [
                        128,
                        135.9
                    ]
                },
                {
                    "name": "4XL",
                    "chest": [
                        136,
                        143.9
                    ]
                },
                {
                    "name": "5XL",
                    "chest": [
                        144,
                        149.9
                    ]
                },
                {
                    "name": "6XL",
                    "chest": [
                        150,
                        158
                    ]
                }
            ]
        },
    "casual_trousers":
        {
            "size": [
                {
                    "name": "30",
                    "waist": [
                        74,
                        77.9
                    ]
                },
                {
                    "name": "32",
                    "waist": [
                        78,
                        81.9
                    ]
                },
                {
                    "name": "33",
                    "waist": [
                        82,
                        85.9
                    ]
                },
                {
                    "name": "34",
                    "waist": [
                        86,
                        89.9
                    ]
                },
                {
                    "name": "35",
                    "waist": [
                        90,
                        93.9
                    ]
                },
                {
                    "name": "36",
                    "waist": [
                        94,
                        97.9
                    ]
                },
                {
                    "name": "37",
                    "waist": [
                        98,
                        101.9
                    ]
                },
                {
                    "name": "38",
                    "waist": [
                        102,
                        105.9
                    ]
                },
                {
                    "name": "40",
                    "waist": [
                        106,
                        109.9
                    ]
                },
                {
                    "name": "42",
                    "waist": [
                        110,
                        113.9
                    ]
                },
                {
                    "name": "44",
                    "waist": [
                        114,
                        117.9
                    ]
                },
                {
                    "name": "46",
                    "waist": [
                        118,
                        121.9
                    ]
                },
                {
                    "name": "48",
                    "waist": [
                        122,
                        125.9
                    ]
                },
                {
                    "name": "50",
                    "waist": [
                        126,
                        129.9
                    ]
                },
                {
                    "name": "52",
                    "waist": [
                        130,
                        133.9
                    ]
                },
                {
                    "name": "54",
                    "waist": [
                        134,
                        137.9
                    ]
                },
                {
                    "name": "56",
                    "waist": [
                        138,
                        142.9
                    ]
                }
            ]
        },
    "shirts_casual":
        {
            "size": [
                {
                    "name": "XS",
                    "neck": [
                        36,
                        36.9
                    ],
                    "chest": [
                        84,
                        87.9
                    ]
                },
                {
                    "name": "S",
                    "neck": [
                        37,
                        38.9
                    ],
                    "chest": [
                        88,
                        95.9
                    ]
                }, {
                    "name": "M",
                    "neck": [
                        39,
                        40.9
                    ],
                    "chest": [
                        96,
                        103.9
                    ]
                }
                ,
                {
                    "name": "L",
                    "neck": [
                        41,
                        42.9
                    ],
                    "chest": [
                        104,
                        111.9
                    ]
                }
                ,
                {
                    "name": "XL",
                    "neck": [
                        43,
                        44.9
                    ],
                    "chest": [
                        112,
                        119.9
                    ]
                }
                ,
                {
                    "name": "2XL",
                    "neck": [
                        45,
                        46.9
                    ],
                    "chest": [
                        120,
                        127.9
                    ]
                }
                ,
                {
                    "name": "3XLR",
                    "neck": [
                        47,
                        48.9
                    ],
                    "chest": [
                        128,
                        135.9
                    ]
                }
                ,
                {
                    "name": "4XLR",
                    "neck": [
                        49,
                        50.9
                    ],
                    "chest": [
                        136,
                        143.9
                    ]
                },
                {
                    "name": "5XLR",
                    "neck": [
                        51,
                        52.9
                    ],
                    "chest": [
                        144,
                        151.9
                    ]
                },
                {
                    "name": "6XLR",
                    "neck": [
                        53,
                        54.9
                    ],
                    "chest": [
                        152,
                        159.9
                    ]
                }
            ]
        },
    "shirts_business":
        {
            "R": {
                "height": [
                    160,
                    192
                ]
            },
            "T": {
                "height": [
                    193,
                    205
                ]
            },
            "alternative": [
                192,
                195
            ],
            "size": {
                "R": [
                    {
                        "name": "36R",
                        "neck": [
                            36,
                            36.9
                        ],
                        "chest": [
                            84,
                            87.9
                        ]
                    },
                    {
                        "name": "37R",
                        "neck": [
                            37,
                            37.9
                        ],
                        "chest": [
                            88,
                            91.9
                        ]
                    },
                    {
                        "name": "38R",
                        "neck": [
                            38,
                            38.9
                        ],
                        "chest": [
                            92,
                            95.9
                        ]
                    },
                    {
                        "name": "39R",
                        "neck": [
                            39,
                            39.9
                        ],
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "40R",
                        "neck": [
                            40,
                            40.9
                        ],
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "41R",
                        "neck": [
                            41,
                            41.9
                        ],
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "42R",
                        "neck": [
                            42,
                            42.9
                        ],
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "43R",
                        "neck": [
                            43,
                            43.9
                        ],
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "44R",
                        "neck": [
                            44,
                            44.9
                        ],
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "45R",
                        "neck": [
                            45,
                            45.9
                        ],
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "46R",
                        "neck": [
                            46,
                            46.9
                        ],
                        "chest": [
                            124,
                            127.9
                        ]
                    },
                    {
                        "name": "47R",
                        "neck": [
                            47,
                            47.9
                        ],
                        "chest": [
                            128,
                            131.9
                        ]
                    },
                    {
                        "name": "48R",
                        "neck": [
                            48,
                            49.5
                        ],
                        "chest": [
                            132,
                            135.9
                        ]
                    },
                    {
                        "name": "50R",
                        "neck": [
                            49.6,
                            50.9
                        ],
                        "chest": [
                            136,
                            143.9
                        ]
                    },
                    {
                        "name": "52R",
                        "neck": [
                            51,
                            52.9
                        ],
                        "chest": [
                            144,
                            151.9
                        ]
                    },
                    {
                        "name": "54R",
                        "neck": [
                            53,
                            53.9
                        ],
                        "chest": [
                            152,
                            159.9
                        ]
                    },
                    {
                        "name": "56R",
                        "neck": [
                            55,
                            56.9
                        ],
                        "chest": [
                            160,
                            167.9
                        ]
                    }
                ],
                "T": [
                    {
                        "name": "40T",
                        "neck": [
                            40,
                            40.9
                        ],
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "41T",
                        "neck": [
                            41,
                            41.9
                        ],
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "42T",
                        "neck": [
                            42,
                            42.9
                        ],
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "43T",
                        "neck": [
                            43,
                            43.9
                        ],
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "44T",
                        "neck": [
                            44,
                            44.9
                        ],
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "45T",
                        "neck": [
                            45,
                            45.9
                        ],
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "46T",
                        "neck": [
                            46,
                            46.9
                        ],
                        "chest": [
                            124,
                            127.9
                        ]
                    },
                    {
                        "name": "47T",
                        "neck": [
                            47,
                            47.9
                        ],
                        "chest": [
                            128,
                            131.9
                        ]
                    },
                    {
                        "name": "48T",
                        "neck": [
                            48,
                            48.9
                        ],
                        "chest": [
                            132,
                            135.9
                        ]
                    }
                ]
            }
        },
    "non_separate_suits":
        {
            "R": {
                "height": [
                    175,
                    189.9
                ]
            },
            "S": {
                "height": [
                    160,
                    174.9
                ]
            },
            "T": {
                "height": [
                    190,
                    205.9
                ]
            },
            "alternative": [
                170,
                199
            ],
            "size": {
                "R": [
                    {
                        "name": "88R",
                        "chest": [
                            88,
                            91.9
                        ]
                    },
                    {
                        "name": "92R",
                        "chest": [
                            92,
                            95.9
                        ]
                    },
                    {
                        "name": "96R",
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "100R",
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "104R",
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "108R",
                        "chest": [
                            108,
                            11.9
                        ]
                    },
                    {
                        "name": "112R",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116R",
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "120R",
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "124R",
                        "chest": [
                            124,
                            127.9
                        ]
                    },
                    {
                        "name": "128R",
                        "chest": [
                            128,
                            131.9
                        ]
                    },
                    {
                        "name": "132R",
                        "chest": [
                            132,
                            135.9
                        ]
                    },
                    {
                        "name": "136R",
                        "chest": [
                            136,
                            139.9
                        ]
                    },
                    {
                        "name": "140R",
                        "chest": [
                            140,
                            143.9
                        ]
                    },
                    {
                        "name": "144R",
                        "chest": [
                            144,
                            149.9
                        ]
                    },
                    {
                        "name": "152R",
                        "chest": [
                            152,
                            155.9
                        ]
                    },
                    {
                        "name": "156R",
                        "chest": [
                            156,
                            160.9
                        ]
                    }
                ],
                "S": [
                    {
                        "name": "88S",
                        "chest": [
                            88,
                            91.9
                        ]
                    },
                    {
                        "name": "92S",
                        "chest": [
                            92,
                            95.9
                        ]
                    },
                    {
                        "name": "96S",
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "100S",
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "104S",
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "108S",
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "112S",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116S",
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "120S",
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "124S",
                        "chest": [
                            124,
                            127.9
                        ]
                    },
                    {
                        "name": "128S",
                        "chest": [
                            128,
                            131.9
                        ]
                    },
                    {
                        "name": "132S",
                        "chest": [
                            132,
                            135.9
                        ]
                    },
                    {
                        "name": "136S",
                        "chest": [
                            136,
                            139.9
                        ]
                    },
                    {
                        "name": "140S",
                        "chest": [
                            140,
                            143.9
                        ]
                    },
                    {
                        "name": "144S",
                        "chest": [
                            144,
                            150.9
                        ]
                    }
                ],
                "T": [
                    {
                        "name": "96T",
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "100T",
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "104T",
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "108T",
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "112T",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116T",
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "120T",
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "124T",
                        "chest": [
                            124,
                            127.9
                        ]
                    }
                ]
            }
        },
    "blazers_jackets":
        {
            "R": {
                "height": [
                    175,
                    189.9
                ]
            },
            "S": {
                "height": [
                    160,
                    174.9
                ]
            },
            "T": {
                "height": [
                    190,
                    204.9
                ]
            },
            "XT": {
                "height": [
                    205
                ]
            },
            "alternative": [
                170,
                199
            ],
            "size": {
                "R": [
                    {
                        "name": "88R",
                        "chest": [
                            88,
                            91.9
                        ]
                    },
                    {
                        "name": "92R",
                        "chest": [
                            92,
                            95.9
                        ]
                    },
                    {
                        "name": "96R",
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "100R",
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "104R",
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "108R",
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "112R",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116R",
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "120R",
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "124R",
                        "chest": [
                            124,
                            127.9
                        ]
                    },
                    {
                        "name": "128R",
                        "chest": [
                            128,
                            131.9
                        ]
                    },
                    {
                        "name": "132R",
                        "chest": [
                            132,
                            135.9
                        ]
                    },
                    {
                        "name": "136R",
                        "chest": [
                            136,
                            139.9
                        ]
                    },
                    {
                        "name": "140R",
                        "chest": [
                            140,
                            143.9
                        ]
                    },
                    {
                        "name": "144R",
                        "chest": [
                            144,
                            149.9
                        ]
                    },
                    {
                        "name": "152R",
                        "chest": [
                            152,
                            155.9
                        ]
                    },

                    {
                        "name": "156R",
                        "chest": [
                            156,
                            160.9
                        ]
                    }
                ],
                "S": [
                    {
                        "name": "88S",
                        "chest": [
                            88,
                            91.9
                        ]
                    },
                    {
                        "name": "92S",
                        "chest": [
                            92,
                            95.9
                        ]
                    },
                    {
                        "name": "96S",
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "100S",
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "104S",
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "108S",
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "112S",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116S",
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "120S",
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "124S",
                        "chest": [
                            124,
                            127.9
                        ]
                    },
                    {
                        "name": "128S",
                        "chest": [
                            128,
                            131.9
                        ]
                    },
                    {
                        "name": "132S",
                        "chest": [
                            132,
                            135.9
                        ]
                    },
                    {
                        "name": "136S",
                        "chest": [
                            136,
                            139.9
                        ]
                    },
                    {
                        "name": "140S",
                        "chest": [
                            140,
                            143.9
                        ]
                    },
                    {
                        "name": "144S",
                        "chest": [
                            144,
                            150.9
                        ]
                    }
                ],
                "T": [
                    {
                        "name": "96T",
                        "chest": [
                            96,
                            99.9
                        ]
                    },
                    {
                        "name": "100T",
                        "chest": [
                            100,
                            103.9
                        ]
                    },
                    {
                        "name": "104T",
                        "chest": [
                            104,
                            107.9
                        ]
                    },
                    {
                        "name": "108T",
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "112T",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116T",
                        "chest": [
                            116,
                            119.9
                        ]
                    },
                    {
                        "name": "120T",
                        "chest": [
                            120,
                            123.9
                        ]
                    },
                    {
                        "name": "124T",
                        "chest": [
                            124,
                            127.9
                        ]
                    }
                ],
                "XT": [
                    {
                        "name": "108XT",
                        "chest": [
                            108,
                            111.9
                        ]
                    },
                    {
                        "name": "112XT",
                        "chest": [
                            112,
                            115.9
                        ]
                    },
                    {
                        "name": "116XT",
                        "chest": [
                            116,
                            119.9
                        ]
                    }
                ]
            }
        },
    "tailored_trousers":
        {
            "R": {
                "height": [
                    175,
                    189.9
                ]
            },
            "XT": {
                "height": [
                    205
                ]
            },
            "size": {
                "R": [
                    {
                        "name": "76R",
                        "waist": [
                            74,
                            77.9
                        ]
                    },
                    {
                        "name": "80R",
                        "waist": [
                            78,
                            81.9
                        ]
                    },
                    {
                        "name": "84R",
                        "waist": [
                            82,
                            85.9
                        ]
                    },
                    {
                        "name": "88R",
                        "waist": [
                            86,
                            89.9
                        ]
                    },
                    {
                        "name": "92R",
                        "waist": [
                            90,
                            93.9
                        ]
                    },
                    {
                        "name": "96R",
                        "waist": [
                            94,
                            97.9
                        ]
                    },
                    {
                        "name": "100R",
                        "waist": [
                            98,
                            101.9
                        ]
                    },
                    {
                        "name": "104R",
                        "waist": [
                            102,
                            105.9
                        ]
                    },
                    {
                        "name": "108R",
                        "waist": [
                            106,
                            109.9
                        ]
                    },

                    {
                        "name": "112R",
                        "waist": [
                            110,
                            113.9
                        ]
                    },
                    {
                        "name": "116R",
                        "waist": [
                            114,
                            117.9
                        ]
                    },
                    {
                        "name": "120R",
                        "waist": [
                            118,
                            121.9
                        ]
                    },
                    {
                        "name": "124R",
                        "waist": [
                            122,
                            125.9
                        ]
                    },
                    {
                        "name": "128R",
                        "waist": [
                            126,
                            129.9
                        ]
                    },
                    {
                        "name": "132R",
                        "waist": [
                            130,
                            133.9
                        ]
                    },
                    {
                        "name": "136R",
                        "waist": [
                            134,
                            137.9
                        ]
                    },
                    {
                        "name": "140R",
                        "waist": [
                            138,
                            141.9
                        ]
                    },
                    {
                        "name": "144R",
                        "waist": [
                            142,
                            145.9
                        ]
                    },
                    {
                        "name": "148R",
                        "waist": [
                            146,
                            149.9
                        ]
                    },
                    {
                        "name": "152R",
                        "waist": [
                            150,
                            153.9
                        ]
                    }
                ],
                "XT": [
                    {
                        "name": "96XT",
                        "waist": [
                            94,
                            97.9
                        ]
                    },
                    {
                        "name": "100XT",
                        "waist": [
                            98,
                            101.9
                        ]
                    },
                    {
                        "name": "104XT",
                        "waist": [
                            102,
                            105.9
                        ]
                    }
                ]
            }
        }
};
var tab_alternative;
var tab_result;

Number.prototype.between = function (a, b) {
    var min = Math.min(a, b),
        max = Math.max(a, b);
    return this >= min && this <= max;
};

function getRadioVal(form, name) {
    var val;

    var radios = form.elements[name];


    for (var i = 0, len = radios.length; i < len; i++) {
        if (radios[i].checked) {
            val = radios[i].value;
            break;
        }
    }
    return val;
}

(function () {
    function track_select() {
        for (var i = 0, length1 = select.options.length; i < length1; i++) {
            if (select.options[i].selected) {
                if (select.options[i].value === 'suits') {
                    remove_all_show();
                    jacket_show();
                }
                else if (select.options[i].value === 'knitwear') {
                    remove_all_show();
                    kwitwear_show();
                }
                else if (select.options[i].value === 'Select') {
                    remove_all_show();
                }
                else if (select.options[i].value === 'jacket') {
                    remove_all_show();
                    jacket_show();
                }
                else if (select.options[i].value === 'tailored') {
                    remove_all_show();
                    tailored();
                }
                else if (select.options[i].value === 'casual_trouser') {
                    remove_all_show();
                    casual_trouser();
                }
                else if (select.options[i].value === 'shirts') {
                    remove_all_show();
                    shirts();
                    your_measurements();
                }
                else if (select.options[i].value === 'casual_shirt') {
                    remove_all_show();
                    casual_shirt();
                    your_measurements();
                }
                else {
                    return false;
                }
            }
        }
    }

    if (typeof document.forms.form_select_type !== "undefined") {
        var form = document.forms.form_select_type;
        var select = form.elements[0];
        form.addEventListener('change', track_select);
    }
})();

function remove_all_show() {
    document.getElementById('type_body_variant').classList.remove("show");
    var elems = document.querySelectorAll(".size__calc-input-fields-parent");
    [].forEach.call(elems, function (el) {
        el.classList.remove("show");
    });
}

function kwitwear_show() {
    var chest = document.getElementById("size__calc-in-chest");
    chest.className += " show";
    choose_show_init = 'kwitwear';
}

// function suits_show() {
//     var height = document.getElementById("size__calc-in-height");
//     height.className += " show";
//      var weight = document.getElementById("size__calc-in-waist");
//      weight.className += " show";
//     choose_show_init = 'suits';
// }

function jacket_show() {
    var height = document.getElementById("size__calc-in-height");
    height.className += " show";
    var chest = document.getElementById("size__calc-in-chest");
    chest.className += " show";
    choose_show_init = 'jacket';
}

function shirts() {
    var height = document.getElementById("size__calc-in-height");
    height.className += " show";
    choose_show_init = 'shirts';
}

function casual_trouser() {
    var weight = document.getElementById("size__calc-in-waist");
    weight.className += " show";
    choose_show_init = 'casual_trouser';
}

function casual_shirt() {
    var chest = document.getElementById("size__calc-in-chest");
    chest.className += " show";
    choose_show_init = 'casual_shirt';
}

function tailored() {
    var weight = document.getElementById("size__calc-in-waist");
//     var height = document.getElementById("size__calc-in-height");
    weight.className += " show";
//     height.className += " show";
    choose_show_init = 'tailored';
}

function your_measurements() {
    if (typeof document.forms.type_body_variant !== "undefined") {
        var form = document.forms.type_body_variant;
        form.addEventListener('change', track);
    }

    form.elements[0].classList.add('act');
    form.elements[0].checked = true;
    form.elements[1].classList.remove('act');

    chest_calc = 'chest';
    document.getElementById("type_body_variant").className += " show";
    document.getElementById("size__calc-in-chest").className += " show";
    var slider = jQuery('.calc__slider-change');


    function track() {

        var chest = document.getElementById("size__calc-in-chest");
        var neck = document.getElementById("size__calc-in-neck");
        chest.className += " show";

        var form_chest = getRadioVal(form, 'opt');
        if (form_chest === 'chest') {
            slider.slick('slickGoTo', 1);
            form.elements[0].classList.add('act');
            form.elements[1].classList.remove('act');
            chest.className += " show";
            neck.classList.remove("show");
            chest_calc = 'chest';
        } else if (form_chest === 'neck') {
            slider.slick('slickGoTo', 0);
            form.elements[0].classList.remove('act');
            form.elements[1].classList.add('act');
            neck.className += " show";
            chest.classList.remove("show");
            chest_calc = 'neck';
        }
    }



};

// JACKET
function jacket_calc() {
    var chest_f = Number(document.calcForm.chestform.value);
    var height_f = Number(document.calcForm.heightform.value);
    var height_R_first = calcTable.blazers_jackets.R.height[0];
    var height_T_first = calcTable.blazers_jackets.T.height[0];
    var height_S_first = calcTable.blazers_jackets.S.height[0];
    var height_R_second = calcTable.blazers_jackets.R.height[1];
    var height_T_second = calcTable.blazers_jackets.T.height[1];
    var height_S_second = calcTable.blazers_jackets.S.height[1];
    var height_XT_second = calcTable.blazers_jackets.XT.height[0];
    //error massage valid
    if (height_f < height_S_first) {
        validator = true;
        return false;
    } else if (height_f > 300) {
        validator = true;
        return false;
    } else if (calcTable.blazers_jackets.size.R[0].chest[0] > chest_f) {
        validator = true;
        return false;
    }
    else if (calcTable.blazers_jackets.size.R[calcTable.blazers_jackets.size.R.length - 1].chest[1] < chest_f) {
        validator = true;
        return false;
    }
    else {
        validator = false;
    }
    //error massage valid end

    // get height  (T OR R)
    if (height_f.between(height_R_first, height_R_second)) {
        var j = "R";
        var table_size = calcTable.blazers_jackets.size.R;
        if (height_f.between(175, 180)) {
            var j_alter = "S";
            var table_size_alter = calcTable.blazers_jackets.size.S;
        } else if (height_f.between(185.01, 189.9)) {
            var j_alter = "T";
            var table_size_alter = calcTable.blazers_jackets.size.T;
        }
    } else if (height_f.between(height_S_first, height_S_second)) {
        var j = "S";
        var table_size = calcTable.blazers_jackets.size.S;
        if (height_f.between(170, 175)) {
            var j_alter = "R";
            var table_size_alter = calcTable.blazers_jackets.size.R;
        }
    }
    else if (height_f.between(height_T_first, height_T_second)) {
        var j = "T";
        var table_size = calcTable.blazers_jackets.size.T;
        if (height_f.between(190, 195)) {
            var j_alter = "R";
            var table_size_alter = calcTable.blazers_jackets.size.R;
        }
    }
    else if (height_f >= height_XT_second) {
        var j = "XT";
        var table_size = calcTable.blazers_jackets.size.XT;
    }
    // get height  (T OR R) End

    if (table_size[0].chest[0] <= chest_f && table_size[table_size.length - 1].chest[1] >= chest_f) {

        for (var i = 0; i <= calcTable.blazers_jackets.size[j].length; i++) {
            var size_f = table_size[i];
            var chest_first = size_f.chest[0];
            var chest_second = size_f.chest[1];
            if (chest_f.between(chest_first, chest_second)) {
                tab_result = size_f.name;
                break;
            }
        }
        // Alternative
        if (table_size && table_size_alter) {
            if (table_size_alter[0].chest[0] <= chest_f && table_size_alter[table_size_alter.length - 1].chest[1] >= chest_f) {
                for (var k = 0; k <= calcTable.blazers_jackets.size[j_alter].length; k++) {
                    var size_f_a = table_size_alter[k];
                    var chest_first_a = size_f_a.chest[0];
                    var chest_second_a = size_f_a.chest[1];
                    if (chest_f.between(chest_first_a, chest_second_a)) {
                        tab_alternative = size_f_a.name;
                        break;
                    }
                }
            }
        }
    } else
        validator = true;
    return false;
    //  Alternative END
}


function shirts_casual() {
    var neck_f = Number(document.calcForm.neckform.value);
    var chest_f = Number(document.calcForm.chestform.value);
    var height_f = Number(document.calcForm.heightform.value);
    var height_R_first = calcTable.shirts_business.R.height[0];
    var height_T_first = calcTable.shirts_business.T.height[0];
    var height_R_second = calcTable.shirts_business.R.height[1];
    var height_T_second = calcTable.shirts_business.T.height[1];
    var height_alternative_first = calcTable.shirts_business.alternative[0];
    var height_alternative_second = calcTable.shirts_business.alternative[1];
    var last_neck = calcTable.shirts_business.size.R[calcTable.shirts_business.size.R.length - 1].neck[1];
    var last_chest = calcTable.shirts_business.size.R[calcTable.shirts_business.size.R.length - 1].chest[1];
    //error massage valid
    if (height_f < height_R_first) {
        validator = true;
        return false;
    } else if (height_f > height_T_second) {
        validator = true;
        return false;
    } else if (chest_calc === 'chest' && calcTable.shirts_business.size.R[0].chest[0] > chest_f) {
        validator = true;
        return false;
    }
    else if (chest_calc === 'neck' && calcTable.shirts_business.size.R[0].neck[0] > neck_f) {
        validator = true;
        return false;
    }
    else if (chest_calc === 'chest' && last_chest < chest_f) {
        validator = true;
        return false;
    }
    else if (chest_calc === 'neck' && last_neck < neck_f) {
        validator = true;
        return false;
    }
    else {
        validator = false;
    }
    //error massage valid end

    // get height  (T OR R)
    if (height_f.between(height_R_first, height_R_second)) {
        var j = "R";
        var table_size = calcTable.shirts_business.size.R;
        var j_alter = "T";
        var table_size_alter = calcTable.shirts_business.size.T;
    } else if (height_f.between(height_T_first,height_T_second)) {
        var j = "T";
        var table_size = calcTable.shirts_business.size.T;
        if (height_f.between(height_alternative_first, height_alternative_second)) {
            var j_alter = "R";
            var table_size_alter = calcTable.shirts_business.size.R;
        }
    }
    // get height  (T OR R) End

    for (var i = 0; i <= calcTable.shirts_business.size[j].length; i++) {
        var size_f = table_size[i];
        var chest_first = size_f.chest[0];
        var chest_second = size_f.chest[1];
        var neck_first = size_f.neck[0];
        var neck_second = size_f.neck[1];
        if (chest_calc === 'chest') {
            if (chest_f.between(chest_first, chest_second)) {
                tab_result = size_f.name;
                break;
            }
        } else if (chest_calc === 'neck') {
            if (neck_f.between(neck_first, neck_second)) {
                tab_result = size_f.name;
                break;
            }
        }
    }
    // Alternative
    if (height_f.between(height_alternative_first, height_alternative_second)) {
        for (var i = 0; i <= calcTable.shirts_business.size[j_alter].length; i++) {
            var size_f_a = table_size_alter[i];
            if (chest_calc === 'chest') {
                if (table_size_alter[0].chest[0] <= chest_f && last_chest >= chest_f) {
                    var chest_first_a = size_f_a.chest[0];
                    var chest_second_a = size_f_a.chest[1];
                    if (chest_f.between(chest_first_a, chest_second_a)) {
                        tab_alternative = size_f_a.name;
                        break;

                    }
                }
            }
            else if (chest_calc === 'neck') {
                if (table_size_alter[0].neck[0] <= chest_f && last_neck >= chest_f) {
                    var neck_first_a = size_f_a.neck[0];
                    var neck_second_a = size_f_a.neck[1];
                    if (neck_f.between(neck_first_a, neck_second_a)) {
                        tab_alternative = size_f_a.name;
                        break;
                    }
                }
            }
        }
    }
    //  Alternative END
}

/*
function suits_calc() {
    var neck_f = document.calcForm.neckform.value;
    var chest_f = document.calcForm.chestform.value;
    var height_f = document.calcForm.heightform.value;
    var height_R_first = calcTable.shirts_business.R.height[0];
    var height_T_first = calcTable.shirts_business.T.height[0];
    var height_R_second = calcTable.shirts_business.R.height[1];
    var height_T_second = calcTable.shirts_business.T.height[1];
    var height_alternative_first = calcTable.shirts_business.alternative[0];
    var height_alternative_second = calcTable.shirts_business.alternative[1];
    var last_neck = calcTable.shirts_business.size.R[calcTable.shirts_business.size.R.length - 1].neck[1];
    var last_chest = calcTable.shirts_business.size.R[calcTable.shirts_business.size.R.length - 1].chest[1];
    //error massage valid
    if (height_f < height_R_first) {
        validator = 'Very small height, try again please';
        return false;
    } else if (height_f > height_T_second) {
        validator = 'Very high height, try again please';
        return false;
    } else if (chest_calc === 'chest' && calcTable.shirts_business.size.R[0].chest[0] > chest_f) {
        validator = 'Very small chest, try again please';
        return false;
    }
    else if (chest_calc === 'neck' && calcTable.shirts_business.size.R[0].neck[0] > neck_f) {
        validator = 'Very small neck, try again please';
        return false;
    }
    else if (chest_calc === 'chest' && calcTable.shirts_business.size.R[calcTable.shirts_business.size.R.length - 1].chest[1] < chest_f) {
        validator = 'Very high chest, try again please';
        return false;
    }
    else if (chest_calc === 'neck' && calcTable.shirts_business.size.R[calcTable.shirts_business.size.R.length - 1].neck[1] < neck_f) {
        validator = 'Very high neck, try again please';
        return false;
    }
    else {
        validator = false;
    }
    //error massage valid end

    // get height  (T OR R)
    if (height_f >= height_R_first && height_f <= height_R_second) {
        var j = "R";
        var table_size = calcTable.shirts_business.size.R;
        var j_alter = "T";
        var table_size_alter = calcTable.shirts_business.size.T;
    } else if (height_f >= height_T_first && height_f <= height_T_second) {
        var j = "T";
        var table_size = calcTable.shirts_business.size.T;
        var j_alter = "R";
        var table_size_alter = calcTable.shirts_business.size.R;
    }
    // get height  (T OR R) End

    for (var i = 0; i <= calcTable.shirts_business.size[j].length; i++) {
        var size_f = table_size[i];
        var chest_first = size_f.chest[0];
        var chest_second = size_f.chest[1];
        var neck_first = size_f.neck[0];
        var neck_second = size_f.neck[1];
        if (chest_calc === 'chest') {
            if (chest_first >= chest_f && chest_f <= chest_second) {
                tab_result = size_f.name;
                break;
            }
        } else if (chest_calc === 'neck') {
            if (neck_first >= neck_f && neck_second >= neck_f) {
                tab_result = size_f.name;
                break;
            }
        }
    }
    // Alternative
    if (height_alternative_first >= height_f && height_f <= height_alternative_second) {
        for (var i = 0; i <= calcTable.shirts_business.size[j_alter].length; i++) {
            var size_f_a = table_size_alter[i];
            var chest_first_a = size_f_a.chest[0];
            var chest_second_a = size_f_a.chest[1];
            var neck_first_a = size_f_a.neck[0];
            var neck_second_a = size_f_a.neck[1];
            if (chest_calc === 'chest') {
                if (chest_first_a >= chest_f && chest_f <= chest_second_a) {
                    tab_alternative = size_f_a.name;
                    break;
                }
            } else if (chest_calc === 'neck') {
                if (neck_first_a >= neck_f && neck_second_a >= neck_f) {
                    tab_alternative = size_f_a.name;
                    break;
                }
            }
        }
    }
    //  Alternative END
}
*/

function casual_shirt_calc() {
    var neck_f = Number(document.calcForm.neckform.value);
    var chest_f = Number(document.calcForm.chestform.value);
    if (chest_calc === 'chest' && calcTable.shirts_casual.size[0].chest[0] > chest_f) {
        validator = true;
        return false;
    }
    else if (chest_calc === 'neck' && calcTable.shirts_casual.size[0].neck[0] > neck_f) {
        validator = true;
        return false;
    }
    else if (chest_calc === 'chest' && calcTable.shirts_casual.size[calcTable.shirts_casual.size.length - 1].chest[1] < chest_f) {
        validator = true;
        return false;
    }
    else if (chest_calc === 'neck' && calcTable.shirts_casual.size[calcTable.shirts_casual.size.length - 1].neck[1] < neck_f) {
        validator = true;
        return false;
    }
    else {
        validator = false;
    }

    //error massage valid end


    for (var i = 0; i <= calcTable.shirts_casual["size"].length; i++) {
        var size_f = calcTable.shirts_casual.size[i];
        var chest_first = size_f.chest[0];
        var chest_second = size_f.chest[1];
        var neck_first = size_f.neck[0];
        var neck_second = size_f.neck[1];
        if (chest_calc === 'chest') {
            if (chest_f.between(chest_first, chest_second)) {
                tab_result = size_f.name;
                break;
            }
        } else if (chest_calc === 'neck') {
            if (neck_f.between(neck_first, neck_second)) {
                tab_result = size_f.name;
                break;
            }
        }
    }
}

function casual_trouser_calc() {
    var chest_f = Number(document.calcForm.waistform.value);
    if (calcTable.casual_trousers.size[0].waist[0] > chest_f) {
        validator = true;
        return false;
    }
    else if (calcTable.casual_trousers.size[calcTable.casual_trousers.size.length - 1].waist[1] < chest_f) {
        validator = true;
        return false;
    }
    else {
        validator = false;
    }

    for (var i = 0; i <= calcTable.casual_trousers["size"].length; i++) {
        var size_f = calcTable.casual_trousers.size[i];
        var chest_first = size_f.waist[0];
        var chest_second = size_f.waist[1];
        if (chest_f.between(chest_first, chest_second)) {
            tab_result = size_f.name;
            break;
        }
    }
}

function tailored_calc() {
    var chest_f = Number(document.calcForm.waistform.value);

  	// Remove HEIGHT option as per client request - 03/04/19

//     var height_f = Number(document.calcForm.heightform.value);
//     var height_R_first = calcTable.tailored_trousers.R.height[0];
//     var height_R_second = calcTable.tailored_trousers.R.height[1];
//     var height_XT_first = calcTable.tailored_trousers.XT.height[0];
//     if (height_f < height_R_first) {
//         validator = true;
//         return false;
//     } else if (height_f > 250) {
//         validator = true;
//         return false;
//     } else if (calcTable.tailored_trousers.size.R[0].waist[0] > chest_f) {
//         validator = true;
//         return false;
//     }
//     else if (calcTable.tailored_trousers.size.R[calcTable.tailored_trousers.size.R.length - 1].waist[1] < chest_f) {
//         validator = true;
//         return false;
//     }
//     else {
//         validator = false;
//     }
//     //error massage valid end

//     if (height_f.between(height_R_first, height_R_second)) {
//         var j = "R";
//         var table_size = calcTable.tailored_trousers.size.R;
//     } else if (height_f >= height_XT_first) {
//         var j = "XT";
//         var table_size = calcTable.tailored_trousers.size.XT;
//     }
    // get height  (T OR R) End


    if (calcTable.tailored_trousers.size.R[0].waist[0] > chest_f) {
        validator = true;
        return false;
    }

  	if (calcTable.tailored_trousers.size.R[calcTable.tailored_trousers.size.R.length - 1].waist[1] < chest_f) {
        validator = true;
        return false;
    }

  	var table_size = calcTable.tailored_trousers.size.R;
  	var j = "R";


  // End remove HEIGHT option as per client request - 03/04/19

    for (var i = 0; i <= calcTable.tailored_trousers.size[j].length; i++) {
        var size_f = table_size[i];
        var chest_first = size_f.waist[0];
        var chest_second = size_f.waist[1];

        if (chest_f.between(chest_first, chest_second)) {
            tab_result = size_f.name;
            break;
        }
    }
}

function kwitwear() {
    var chest_f = Number(document.calcForm.chestform.value);
    if (calcTable.knitwear.size[0].chest[0] > chest_f) {
        validator = true;
        return false;
    }
    else if (calcTable.knitwear.size[calcTable.knitwear.size.length - 1].chest[1] < chest_f) {
        validator = true;
        return false;
    }
    else {
        validator = false;
    }

    for (var i = 0; i <= calcTable.knitwear["size"].length; i++) {
        var size_f = calcTable.knitwear.size[i];
        var chest_first = size_f.chest[0];
        var chest_second = size_f.chest[1];
        if (chest_f.between(chest_first, chest_second)) {
            tab_result = size_f.name;
            break;
        }
    }
}


function calculatesize() {

    switch (choose_show_init) {
        case 'kwitwear':
            kwitwear();
            break;
        case 'shirts':
            shirts_casual();
            break;
        case 'casual_shirt':
            casual_shirt_calc();
            break;
        case 'tailored':
            tailored_calc();
            break;
        case 'casual_trouser':
            casual_trouser_calc();
            break;
        case 'suits':
            jacket_calc();
            break;
        case 'jacket':
            jacket_calc();
            break;
    }
// finish result


    if (tab_result !== undefined) {
        document.querySelector('span.result_original').innerText = tab_result;
        document.querySelector('span.result_original_text').innerText = tab_result;
        change_block();
        insert_i_result();
    } else {
        validator = false;
    }
    if (tab_alternative !== undefined) {
        document.querySelector('span.result_alternative').innerText = tab_alternative;
        document.querySelector('span.result_alternative_text').innerText = tab_alternative;
        change_block_alternative();
        insert_i_result();
    } else {
        validator = false;
    }
    if (validator === false) {
        document.querySelector('div.calc__validator').style.display = "block";
    } else {
        document.querySelector('div.calc__validator').style.display = "none";

    }
}

function change_block() {
    var hint = document.querySelector('div.size__calc-form');
    var result = document.querySelector('div.calc__change-div');
    hint.classList.add('h-hide');
    result.classList.add('h-show');
}

function change_block_alternative() {
    var hint = document.querySelector('div.size__calc-description-block');
    var result = document.querySelector('div.calc__change-alternative');
    hint.classList.add('h-hide');
    result.classList.add('h-show');
}


//RESET
var btn_res = document.getElementById('calc_reset');

if (btn_res) {
  btn_res.addEventListener('click', function () {
      reset();
  });
}

function reset() {
    var hint = document.querySelector('div.size__calc-form');
    var result = document.querySelector('div.calc__change-div');
    document.querySelector('div.calc__validator').style.display = "none";
    hint.classList.remove('h-hide');
    tab_result = undefined;
    document.querySelector('div.calc__validator').style.display = "none";
    tab_alternative = undefined;
    result.classList.remove('h-show');
    document.querySelector('div.size__calc-description-block').classList.remove('h-hide');
    document.querySelector('div.calc__change-alternative').classList.remove('h-show');
    document.getElementById("calcForm").reset();
    document.querySelector('span.result_original').innerText = "";
    document.querySelector('span.result_alternative').innerText = "";
    document.querySelector('span.result_original_text').innerText = "";
    document.querySelector('span.result_alternative_text').innerText = "";
    // fix slider
    jQuery('.calc__slider-change').slick('setPosition');
    // Fix bug with info
    jQuery('.insert_value_calc-c').empty();
    jQuery('.insert_value_calc-n').empty();
    jQuery('.insert_value_calc-w').empty();
    jQuery('.insert_value_calc-h').empty();
}

//tabs

function opentabs(evt, tabs_count) {
    reset();
    var i, calc__tabcontent, tablinks;
    calc__tabcontent = document.getElementsByClassName("calc__tabcontent");
    for (i = 0; i < calc__tabcontent.length; i++) {
        calc__tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("size__calc-tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabs_count).style.display = "block";
    evt.currentTarget.className += " active";
    jQuery('.calc__slider-change').slick('setPosition');
}

function contains(selector, text) {
    var elements = document.querySelectorAll(selector);
    return Array.prototype.filter.call(elements, function (element) {
        return RegExp(text).test(element.textContent);
    });
}

function insert_i_result() {
    var chest_f = Number(document.calcForm.chestform.value);
    var neck_f = Number(document.calcForm.neckform.value);
    var waist_f = Number(document.calcForm.waistform.value);
    var height_f = Number(document.calcForm.heightform.value);

    if (chest_f !== 0) {
        jQuery('.insert_value_calc-c').text('chest:' + chest_f + 'cm');
    }
    if (neck_f !== 0) {
        jQuery('.insert_value_calc-n').text('neck:' + neck_f + 'cm');
    }
    if (waist_f !== 0) {
        jQuery('.insert_value_calc-w').text('waist:' + waist_f + 'cm');
    }
    if (height_f !== 0) {
        jQuery('.insert_value_calc-h').text('height:' + height_f + 'cm');
    }
    var chest_f, neck_f, waist_f, height_f = 0;
}

//open

var modal = document.getElementById('size__calc-popup');
var span = document.getElementsByClassName("size__calc-popup-close")[0];

function popup() {
    modal.style.display = "block";
    document.getElementById("size__calc-defaultOpen").click();
    jQuery('.calc__slider-change').slick('setPosition');
};
jQuery('.size__calc-popup-close').click(function () {
    modal.style.display = "none";
});
window.onclick = function (event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
};


jQuery(document).ready(function () {
    var slider = jQuery('.calc__slider-change');
    slider.on('init', function (event, slick) {
        jQuery('.calc__slider-count').append('<p><span id="current">1</span> of <span id="total">' + slick.slideCount + '</span></p>');
    });
    slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
    }).on({
        afterChange: function (event, slick, currentSlide, nextSlide) {
            var sl_img = jQuery('.size__calc-slider-img');
            var curr_img = jQuery('.size__calc-slider-description .slick-current div');
            if (curr_img.children('.calc__neck-slider').length > 0) {
                sl_img.attr('class', 'size__calc-slider-img');
                sl_img.addClass('neck');
            } else if (curr_img.children('.calc__chest-slider').length > 0) {
                sl_img.attr('class', 'size__calc-slider-img');
                sl_img.addClass('chest');
            } else if (curr_img.children('.calc__abdomen-slider').length > 0) {
                sl_img.attr('class', 'size__calc-slider-img');
                sl_img.addClass('abdomen');
            } else if (curr_img.children('.calc__waist-slider').length > 0) {
                sl_img.attr('class', 'size__calc-slider-img');
                sl_img.addClass('waist');
            } else if (curr_img.children('.calc__hip-slider').length > 0) {
                sl_img.attr('class', 'size__calc-slider-img');
                sl_img.addClass('hip');
            } else {
                sl_img.attr('class', 'size__calc-slider-img');
            }
        }
    });
    slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        jQuery('.calc__slider-count #current').html(currentSlide + 1);
    });

    jQuery('.calc__left').click(function () {
        slider.slick('slickPrev');
    });

    jQuery('.calc__right').click(function () {
        slider.slick('slickNext');
    });
    jQuery("input[name='neckform']").focus(function (e) {
        e.preventDefault();
        slider.slick('slickGoTo', 0);
    });

    jQuery("input[name='chestform']").focus(function (e) {
        e.preventDefault();
        slider.slick('slickGoTo', 1);
    });
    jQuery("input[name='waistform']").focus(function (e) {
        e.preventDefault();
        slider.slick('slickGoTo', 3);
    });
});

// move POP uP
var newPos = document.getElementById('shopify-section-sec');
if (newPos) {
	PageContainer.insertBefore(newPos, PageContainer.children[1]);
}

jQuery(document).ready(function () {
  let slider = jQuery('.testimonial-list-carousel');
  slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  });
  slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    jQuery('#testimonial-list-indicator').html(currentSlide + 1);
  });
  jQuery('#testimonial-prev').click(function () {
    slider.slick('slickPrev');
  });
  jQuery('#testimonial-next').click(function () {
    slider.slick('slickNext');
  });
});

//
// var productSingleContainer = document.getElementsByClassName('product-single__offer product-single__offer--child')[0];
// var innerScriptContainer = productSingleContainer.getElementsByTagName("script")[0];
// var innerJson = JSON.parse(innerScriptContainer.innerText);
// innerJson.tags;
// for (var i = 0; i <= innerJson.tags.length; i++) {
//
// }
//

//     var json_product = $('.product-single__offer script').html;
//     manifest = jQuery.parseJSON(json_product); //Converts it into JSON
//     alert( manifest);
// });
// jQuery(document).ready(function ($) {
//
//     $('.calc__size-select').click(function () {
//         $('#size__calc-popup').fadeOut("slow");
//         var resu_int = parseInt(tab_result);
//         var resu_text = tab_result.replace(/[^a-zA-Z]+/g, '');
//         var resu_text_with_number = tab_result;
//         var check_size = 'Size';
//         var check_fit = 'Fit';
//         if ($(this).hasClass('calc_alternative-butt')) {
//             var resu_int = parseInt(tab_alternative);
//             var resu_text = tab_alternative.replace(/[^a-zA-Z]+/g, '');
//             var resu_text_with_number = tab_alternative;
//         }
//         console.log(globalClass);
//         jQuery('.product-single__offer label').each(function () {
//             var f = ($(this).text().trim());
//             if (check_fit === f) {
//                 $(this).next('.single-option-selector').children().each(function () {
//                     if (resu_text === $(this).attr('value')) {
//                         var fit = $(this).prop('selected', true);
//                         fit.trigger({
//                             type: 'variantChange'
//                         });
//                         $(this).change();
//                     }
//                 });
//             }
//             if (check_size === f) {
//                 $(this).next('.single-option-selector').children().each(function () {
//                     if (resu_int === parseInt($(this).attr('value'))) {
//                         var fit = $(this).prop('selected', true);
//
//                         fit.trigger({
//                             type: 'variantChange'
//                         });
//                         $(this).change();
//                     }
//                     else if (resu_text_with_number === $(this).attr('value')) {
//                         var fit = $(this).prop('selected', true);
//
//                         fit.trigger({
//                             type: 'variantChange'
//                         });
//                         $(this).change();
//                     }
//                 });
//             }
//         });
//     });
jQuery(document).ready(function ($) {

    $('.calc__size-select').click(function () {
        $('#size__calc-popup').fadeOut("slow");
        var resu_int = parseInt(tab_result);
        var resu_text = tab_result.replace(/[^a-zA-Z]+/g, '');
        var resu_text_with_number = tab_result;
        if ($(this).hasClass('calc_alternative-butt')) {
            var resu_int = parseInt(tab_alternative);
            var resu_text = tab_alternative.replace(/[^a-zA-Z]+/g, '');
            var resu_text_with_number = tab_alternative;
        }

        globalClassForBlockProduct.find('option').each(function () {
                    if (resu_text === $(this).attr('value')) {
                        var fit = $(this).prop('selected', true);
                        fit.trigger({
                            type: 'variantChange'
                        });
                        $(this).change();
                    }
                    if (resu_int === parseInt($(this).attr('value'))) {
                        var fit = $(this).prop('selected', true);

                        fit.trigger({
                            type: 'variantChange'
                        });
                        $(this).change();
                    }
                    else if (resu_text_with_number === $(this).attr('value')) {
                        var fit = $(this).prop('selected', true);

                        fit.trigger({
                            type: 'variantChange'
                        });
                        $(this).change();
                    }

        });
    });

    $(".size__calc-button-popup").click(function () {
         globalClassForBlockProduct = $(this).parents(".product-single__offer");
        var get_html = $(this).parents(".product-single__offer");
        var v = get_html.find('script').html().trim();
        var getJson = $.parseJSON(v);
        var jacket_key = ['Blazers', 'Coats', 'Outerwear', 'waistcoat', 'Hire Jacket'];
        var suit = ['suit jacket', 'non separate suits'];
        var tailor = ['tailored trousers', 'trousers tailored'];
        var casual_trousers = ['Casual Trousers', 'Chinos'];
        var shirts_key = ['Shirts/Business','Shirts Business'];
        var casual_shirt_key = ['Shirts/Casual','Shirts Casual'];
        var knitwear = 'Knitwear';
        $.each(getJson.tags, function (i, key) {
            if ($.inArray(key, jacket_key) !== -1) {
                $('option[value="jacket"]').prop('selected', true);
                remove_all_show();
                jacket_show();


            } else if ($.inArray(key, suit) !== -1) {
                remove_all_show();
                $('option[value="suits"]').prop('selected', true);
                jacket_show();


            } else if ($.inArray(key, tailor) !== -1) {
                remove_all_show();
                $('option[value="tailored"]').prop('selected', true);
                tailored();


            } else if ($.inArray(key, casual_trousers) !== -1) {
                remove_all_show();
                $('option[value="casual_trouser"]').prop('selected', true);
                casual_trouser();


            } else if ($.inArray(key, shirts_key) !== -1 ) {
                remove_all_show();
                $('option[value="shirts"]').prop('selected', true);
                shirts();
                your_measurements();


            } else if ($.inArray(key, casual_shirt_key) !== -1 ) {
                $('option[value="casual_shirt"]').prop('selected', true);
                remove_all_show();
                casual_shirt();
                your_measurements();


            } else if (key === knitwear) {
                $('option[value="knitwear"]').prop('selected', true);
                remove_all_show();
                kwitwear_show();
            }
        })
    });
});


theme.PromoBanner = (function() {

  function PromoBanner(container) {

    var sectionId = container.dataset.sectionId;

    if (container.dataset.slideshow) {
      theme.slideshows[container] = new theme.Slideshow(container);
    }

  }

  return PromoBanner;

})();


/*================ Templates ================*/
// /**
//  * Customer Addresses Script
//  * ------------------------------------------------------------------------------
//  * A file that contains scripts highly couple code to the Customer Addresses
//  * template.
//  *
//  * @namespace customerAddresses
//  */

// theme.customerAddresses = (function() {
//   var $newAddressForm = $('#AddressNewForm');

//   if (!$newAddressForm.length) {
//     return;
//   }

//   // Initialize observers on address selectors, defined in shopify_common.js
//   if (Shopify) {
//     new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
//       hideElement: 'AddressProvinceContainerNew'
//     });
//   }

//   // Initialize each edit form's country/province selector
//   $('.address-country-option').each(function() {
//     var formId = $(this).data('form-id');
//     var countrySelector = 'AddressCountry_' + formId;
//     var provinceSelector = 'AddressProvince_' + formId;
//     var containerSelector = 'AddressProvinceContainer_' + formId;

//     new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
//       hideElement: containerSelector
//     });
//   });

//   // Toggle new/edit address forms
//   $('.address-new-toggle').on('click', function() {
//     $newAddressForm.toggleClass('hide');
//   });

//   $('.address-edit-toggle').on('click', function() {
//     var formId = $(this).data('form-id');
//     $('#EditAddress_' + formId).toggleClass('hide');
//   });

//   $('.address-delete').on('click', function() {
//     var $el = $(this);
//     var formId = $el.data('form-id');
//     var confirmMessage = $el.data('confirm-message');
//     if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
//       Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
//     }
//   });
// })();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.RecoverPasswordForm').toggleClass('hide');
    $('.CustomerLoginForm').toggleClass('hide');
    $('body').toggleClass('password-form-active');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

window.theme = window.theme || {};

theme.RegisterPage = (function() {
  var selectors = {
    registerPage: '.register-page',
  };

  if (!$(selectors.registerPage).length) {
    return;
  }

  var validateABN = function(abn) {
    var isValid = true;
    abn = abn.replace(/[^0-9]/g, '');
    isValid &= abn && /^\d{11}$/.test(abn);

    if(isValid){
      var weightedSum = 0;
      var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      for (var i = 0; i < weight.length; i++) {
        weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i];
      }
      isValid &= ((weightedSum % 89) === 0);
    }

    return isValid;
  };

  var abnField = document.getElementById('CustomerFormABN');
  if (abnField !== undefined && abnField !== null) {
    abnField.addEventListener('input', function (event) {
      if (abnField.validity.typeMismatch || validateABN(abnField.value) != true) {
        abnField.setCustomValidity('Please enter a valid ABN.');
      } else {
        abnField.setCustomValidity('');
      }
    });
  }

  if ($('#CustomerFormCustomerType').length) {
    updateRegisterFormFields($('#CustomerFormCustomerType').val());

    $('#CustomerFormCustomerType').on('change', function(){
      updateRegisterFormFields($(this).val());
    });
  }

  $('.form-element--product-interest label:last-child input').on('change', function() {
    $('.form-element--product-interest label input').not(this).prop('checked', this.checked);
  });

  $('.form-element--product-interest label:not(:last-child) input').on('change', function() {
    $('.form-element--product-interest label:last-child input').prop('checked', false);
  });

  function updateRegisterFormFields(selector) {
    var activeGroup = theme.utils.handleize(selector);
    var activeSelector = '.form-element--' + activeGroup;

    $('.form-element--toggles').not(activeSelector).hide();
    $('.form-element--toggles').not(activeSelector).removeClass('form-element--visible');
    $('.form-element--toggles').not(activeSelector).prop('disabled', true);

    $(activeSelector).show();
    $(activeSelector).addClass('form-element--visible');
    $(activeSelector).prop('disabled', false);

    $('input[name="tags"]').val(activeGroup);
  };

})();

$('#DetailEditAddress').click(function() {
  var formId = $(this).data('form-id');
  $('#EditAddress_' + formId).toggleClass('hide');
});

$('#DetailEditCustomer').click(function() {
  $('.customer__detail').addClass('detail__hide');
  $('.customer__detail--edit').removeClass('hide');
});

window.theme = window.theme || {};

theme.Password = (function() {
  var selectors = {
    passwordPage: '.password-page',
    loginModal: '#LoginModal',
    focusOnOpen: '#Password'
  };

  if (!$(selectors.passwordPage).length) {
    return;
  }

  initModal();

  function initModal() {

    var $loginModal = $(selectors.loginModal);

    if (!$loginModal.length) {
      return;
    }

    var passwordModal = new theme.Modals(selectors.loginModal, 'login-modal', {
      focusOnOpen: selectors.focusOnOpen
    });

    // Open modal if errors exist
    if ($loginModal.find('.errors').length) {
      passwordModal.open();
    }

  }
})();

theme.Return = (function() {
  var selectors = {
    findOrderForm: '#findOrder',
    findOrderInput: '#findOrder>input',
    iconClose: '<svg class="icon icon-close icon--full-color" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g stroke="#000" stroke-linecap="round"><path d="M335.18 15.674h-11.36c-.295 0-.524-.228-.492-.49l1.275-10.206c.028-.223.24-.391.492-.391h8.81c.252 0 .464.168.492.391l1.275 10.207c.033.26-.197.489-.492.489z"/><path d="M326.876 6.543V3.935a2.617 2.617 0 0 1 2.624-2.609 2.616 2.616 0 0 1 2.624 2.609v2.608"/></g><g stroke="#000" stroke-linecap="round"><path d="M14.434 2.406L2.406 14.434M14.434 14.434L2.406 2.406"/></g><path fill="#231F20" d="M116 28h104.49v-40H116z"/><path d="M132.032 2.468h2.166V4.01h.033c.417-1.043 1.54-1.766 2.648-1.766.16 0 .352.033.496.08v2.119a4.207 4.207 0 0 0-.817-.081c-1.669 0-2.248 1.204-2.248 2.664v3.739h-2.278V2.468zM139.51 7.17c.063 1.443.77 2.101 2.037 2.101.915 0 1.653-.561 1.797-1.075h2.006c-.643 1.958-2.006 2.792-3.883 2.792-2.615 0-4.236-1.797-4.236-4.364 0-2.488 1.716-4.381 4.236-4.381 2.823 0 4.187 2.375 4.026 4.927h-5.983zm3.705-1.445c-.208-1.154-.706-1.766-1.812-1.766-1.445 0-1.862 1.125-1.893 1.766h3.705zM146.103 2.468h2.15v1.124h.031c.595-.851 1.462-1.35 2.535-1.35 1.045 0 1.975.388 2.423 1.382.483-.722 1.348-1.381 2.504-1.381 1.766 0 3.033.818 3.033 2.968v5.553H156.5V6.062c0-1.106-.096-2.021-1.396-2.021-1.284 0-1.524 1.059-1.524 2.102v4.621H151.3V6.111c0-.964.064-2.07-1.38-2.07-.449 0-1.539.29-1.539 1.91v4.813h-2.28V2.468zM159.772-.692h2.278v4.171h.032c.563-.85 1.589-1.236 2.616-1.236 1.652 0 3.434 1.333 3.434 4.365 0 3.047-1.782 4.38-3.434 4.38-1.22 0-2.23-.37-2.728-1.283h-.032v1.06h-2.166V-.693zm4.139 4.652c-1.348 0-1.941 1.268-1.941 2.663 0 1.38.593 2.649 1.941 2.649s1.941-1.268 1.941-2.649c0-1.395-.593-2.663-1.941-2.663zM168.771 2.468h2.167V4.01h.033c.417-1.043 1.538-1.766 2.647-1.766.16 0 .352.033.496.08v2.119a4.194 4.194 0 0 0-.818-.081c-1.667 0-2.245 1.204-2.245 2.664v3.739h-2.28V2.468zM174.225 5.02c.13-2.135 2.039-2.777 3.9-2.777 1.654 0 3.642.369 3.642 2.36v4.315c0 .754.08 1.509.29 1.845h-2.31a3.356 3.356 0 0 1-.161-.802c-.723.754-1.781 1.027-2.791 1.027-1.574 0-2.825-.787-2.825-2.487 0-1.878 1.413-2.326 2.825-2.52 1.395-.207 2.694-.16 2.694-1.091 0-.978-.673-1.122-1.476-1.122-.866 0-1.428.352-1.508 1.252h-2.28zm5.264 1.685c-.386.335-1.188.352-1.892.48-.707.144-1.348.385-1.348 1.22 0 .85.659 1.06 1.395 1.06 1.781 0 1.845-1.413 1.845-1.91v-.85zM182.729 2.468h2.165v1.156h.05c.577-.931 1.571-1.381 2.536-1.381 2.422 0 3.032 1.365 3.032 3.418v5.103h-2.278V6.078c0-1.363-.401-2.037-1.461-2.037-1.236 0-1.766.69-1.766 2.374v4.349h-2.278V2.468zM197.362 9.705h-.033c-.529.899-1.46 1.284-2.519 1.284-2.503 0-3.722-2.15-3.722-4.445 0-2.23 1.236-4.301 3.674-4.301.98 0 1.942.418 2.472 1.236h-.016.032V-.692h2.278l-.001 11.455h-2.165V9.705zm-1.99-5.745c-1.493 0-2.005 1.284-2.005 2.648 0 1.3.592 2.664 2.004 2.664 1.51 0 1.958-1.317 1.958-2.68 0-1.348-.481-2.632-1.956-2.632zM203.49 2.468h1.668v1.525h-1.668v4.108c0 .77.191.962.963.962.24 0 .466-.016.705-.064v1.78c-.385.064-.883.08-1.332.08-1.395 0-2.614-.321-2.614-1.973V3.993h-1.38V2.468h1.38V-.018h2.278v2.486zM190.462 16.118v.147h-1.875v-2.76h1.856v.147h-1.685l-.001 1.106h1.585v.146h-1.585v1.214z" fill="#FEFEFE"/><path stroke="#FEFEFE" stroke-width=".141" d="M190.462 16.118v.147h-1.875v-2.76h1.856v.147h-1.685l-.001 1.106h1.585v.146h-1.585v1.214z"/><path d="M192.644 14.294c-.02-.47-.375-.707-.885-.707-.313 0-.758.132-.758.587 0 .445.472.519.939.614.473.097.944.217.944.766 0 .571-.549.776-.97.776-.645 0-1.171-.266-1.163-.977h.17c-.035.603.448.83.992.83.332 0 .8-.15.8-.63 0-.467-.471-.548-.944-.644-.466-.097-.938-.209-.938-.735 0-.529.49-.733.928-.733.576 0 1.028.247 1.055.853h-.17z" fill="#FEFEFE"/><path d="M192.644 14.294c-.02-.47-.375-.707-.885-.707-.313 0-.758.132-.758.587 0 .445.472.519.939.614.473.097.944.217.944.766 0 .571-.549.776-.97.776-.645 0-1.171-.266-1.163-.977h.17c-.035.603.448.83.992.83.332 0 .8-.15.8-.63 0-.467-.471-.548-.944-.644-.466-.097-.938-.209-.938-.735 0-.529.49-.733.928-.733.576 0 1.028.247 1.055.853h-.17z" stroke="#FEFEFE" stroke-width=".141"/><path fill="#FEFEFE" d="M193.075 13.653v-.147h2.114v.147h-.974v2.613h-.17v-2.613z"/><path stroke="#FEFEFE" stroke-width=".141" d="M193.075 13.653v-.147h2.114v.147h-.974v2.613h-.17v-2.613z"/><path d="M197.68 16.265h-.147v-2.38c-.19.2-.449.313-.715.34v-.128c.31-.046.571-.228.73-.497h.132v2.665z" fill="#FEFEFE"/><path d="M197.68 16.265h-.147v-2.38c-.19.2-.449.313-.715.34v-.128c.31-.046.571-.228.73-.497h.132v2.665z" stroke="#FEFEFE" stroke-width=".141"/><path d="M199.004 15.608a.657.657 0 0 0 .668.575c.734 0 .835-.88.835-1.356l-.008-.007a.795.795 0 0 1-.776.54c-.534 0-.901-.378-.901-.912 0-.525.38-.897.901-.897.41 0 .931.183.93 1.249 0 .656-.157 1.512-.98 1.512-.445 0-.765-.256-.816-.704h.147zm1.473-1.16a.754.754 0 1 0-1.508 0c0 .421.325.786.754.786.44 0 .753-.352.754-.786z" fill="#FEFEFE"/><path d="M199.004 15.608a.657.657 0 0 0 .668.575c.734 0 .835-.88.835-1.356l-.008-.007a.795.795 0 0 1-.776.54c-.534 0-.901-.378-.901-.912 0-.525.38-.897.901-.897.41 0 .931.183.93 1.249 0 .656-.157 1.512-.98 1.512-.445 0-.765-.256-.816-.704h.147zm1.473-1.16a.754.754 0 1 0-1.508 0c0 .421.325.786.754.786.44 0 .753-.352.754-.786z" stroke="#FEFEFE" stroke-width=".141"/><path d="M202.442 13.599v1.858h.447v.128h-.447v.68h-.147v-.68h-1.298v-.148l1.298-1.838h.147zm-.147.2h-.008l-1.144 1.658h1.152V13.8z" fill="#FEFEFE"/><path d="M202.442 13.599v1.858h.447v.128h-.447v.68h-.147v-.68h-1.298v-.148l1.298-1.838h.147zm-.147.2h-.008l-1.144 1.658h1.152V13.8z" stroke="#FEFEFE" stroke-width=".141"/><path d="M204.941 14.255c-.058-.344-.317-.575-.669-.575-.734 0-.834.862-.834 1.387l.007.007a.841.841 0 0 1 .796-.571c.526 0 .892.391.892.912a.87.87 0 0 1-.892.897c-.745 0-.95-.598-.95-1.248 0-.657.158-1.513.981-1.513.444 0 .766.256.816.704h-.147zm.047 1.16c0-.418-.314-.786-.747-.786-.44 0-.753.352-.753.786a.75.75 0 0 0 .753.769c.43 0 .747-.348.747-.77z" fill="#FEFEFE"/><path d="M204.941 14.255c-.058-.344-.317-.575-.669-.575-.734 0-.834.862-.834 1.387l.007.007a.841.841 0 0 1 .796-.571c.526 0 .892.391.892.912a.87.87 0 0 1-.892.897c-.745 0-.95-.598-.95-1.248 0-.657.158-1.513.981-1.513.444 0 .766.256.816.704h-.147zm.047 1.16c0-.418-.314-.786-.747-.786-.44 0-.753.352-.753.786a.75.75 0 0 0 .753.769c.43 0 .747-.348.747-.77z" stroke="#FEFEFE" stroke-width=".141"/></g></svg>'
  };
  var allProducts = [];
  var allOrders = [];

  if (window.location.href.includes('?return=')) {
    var locateNumb = window.location.href.split('?return=')[1];
    $('#orderNumber').val(locateNumb);
  }

  findOrder();

  function findOrder() {

    var $findOrderForm = $(selectors.findOrderForm);

    $findOrderForm.on('submit', function(event){
      event.preventDefault();
      $('body').addClass('loader');
      var act = $findOrderForm.attr('data-customer-id');
      var odr = $findOrderForm.attr('data-customer-orders');
      checkOrder(odr);
    });
  }

  var checkOrder = function(oderObj) {
    var myobj = JSON.parse(oderObj),
        $findOrderForm = $(selectors.findOrderForm),
        findOrderInput = parseInt($(selectors.findOrderInput).val(), 10);
    var ifKey = checkKey(myobj,findOrderInput);
    if (ifKey[0]) {
      buildOrders(ifKey[1]);
    } else {
      $('#findOrder').addClass('error');
      $('body').removeClass('loader');
    }
  }

  function checkKey(myobj, findOrderInput) {
    var res = [false, ''];
    myobj.orders.forEach(function(element) {
      for (var key in element) {
          if(key == 'order_number') {
            if (findOrderInput == element[key]) {
              res = [true, element];
            }
          }
      }
    });
    return res;
  }

  function buildOrders(order) {

    var customerName = order.name,
        invoiseDate,
        invoiseNumber,
        orderNumber = order.order_number,
        lineOrders = order.line_items,
        ordersTable = $('.order-product-list'),
        returnForm = $('.main-return-form');
         if (returnForm && order.order_id_hmac && order.order_id) {
           returnForm.attr("data-order_id_hmac", order.order_id_hmac);
           returnForm.attr("data-order_id", order.order_id);
         }
    var orderData = order.created_at.split(' ')[0].split('-');
    var orderInfo = '<div class="order-main-info_block"><h3>CUSTOMER NAME</h3><input name="customerName[name]" type="hidden" value="'+order.name+'"> <p>'+order.name+'</p></div><div class="order-main-info_block"><h3>INVOICE DATE</h3><input name="orderCreate[data]" type="hidden" value="'+order.created_at+'"><p>'+orderData[2]+' / '+orderData[1]+' / '+orderData[0]+'</p></div><div class="order-main-info_block"><h3>INVOICE NUMBER</h3><input name="orderNumber[invoice_number]" type="hidden" value="'+order.order_number+'"><p>'+order.order_number+'</p></div><div class="order-main-info_block"><h3>ORDER NUMBER</h3><input name="orderNumber[order_number]" type="hidden" value="'+order.order_number+'"><p>'+order.order_number+'</p></div>';
    $('.order-main-info').append(orderInfo);
    var productsPg1, productsPg2, productsPg3, productsPg4;

    $.when( $.ajax( "/products.json?limit=250&page=1" ), $.ajax( "/products.json?limit=250&page=2" ), $.ajax( "/products.json?limit=250&page=3" ), $.ajax( "/products.json?limit=250&page=4" ) ).done(function( pg1, pg2, pg3, pg4 ) {
      for (var i = 1; i <= 4; i++) {
        if (i == 1) {
          buildAllProducts(pg1[ 0 ]);
        } else if (i == 2) {
          buildAllProducts(pg2[ 0 ]);
        } else if (i == 3) {
          buildAllProducts(pg3[ 0 ]);
        } else if (i == 4) {
          buildAllProducts(pg4[ 0 ]);
        }
      }
      forLineOrders();
    });

    function buildAllProducts(pgProduct) {
      var arr = pgProduct.products;
      for (var i = 0; i < arr.length; i++) {
        allProducts.push(arr[i]);
      }
    }

    function forLineOrders() {
      allOrders = lineOrders;
      lineOrders.forEach(function(item, i, arr){
        var orderItem = '';
        var titleHandle = item.title.replace(/ /g, "-").toLowerCase();
        var qtyOptions = '', variantOptions = '';
        for (var qt = 1; qt <= item.quantity; qt++) {
          qtyOptions = qtyOptions + '<option value="'+qt+'">'+qt+'</option>';
        }
        allProducts.forEach(function(arrProduct){
          if (arrProduct.id == item.product_id) {
            arrProduct.variants.forEach(function(prodVar) {
              if (prodVar.available == false) {
                variantOptions = variantOptions + '<option value="'+prodVar.title+'" disabled="disabled">'+prodVar.title+'</option>'
              } else {variantOptions = variantOptions + '<option value="'+prodVar.title+'">'+prodVar.title+'</option>'}
            })
          }
        })

        orderItem = '<div class="order-product-list__item" id="'+i+'"> <div class="order-product-info"> <p class="title">product code</p> <div class="order-product-info__text"> <input id="prodSku'+i+'" name="productCode[product'+i+']" type="hidden" value="'+item.sku+'"> <p class="text-uppercase">'+item.sku+'</p> </div> </div> <div class="order-product-info"> <p class="title">DESCRIPTION</p> <div class="order-product-info__text"> <input id="prodTitle'+i+'" name="productTitle[product'+i+']" type="hidden" value="'+item.title+'"> <p>'+item.title+'</p> </div> </div> <div class="order-product-info"> <p class="title">SIZE</p> <div class="order-product-info__text"> <input id="prodSize'+i+'" name="productSize[product'+i+']" type="hidden" value="'+item.variant_title+'"> <p class="text-uppercase">'+item.variant_title+'</p> </div> </div> <div class="order-product-info"> <p class="title">QTY</p> <div class="order-product-info__text"> <p>'+item.quantity+'</p> </div> </div> <div class="order-product-info"> <p class="title">UNIT PRICE</p> <div class="order-product-info__text"> <p>'+Currency.formatMoney(Currency.convert(item.price, shop.currency, Currency.currentCurrency), Currency.currentFormat)+'</p> </div> </div> <div class="order-product-info"> <p class="title">SUBTOTAL</p> <div class="order-product-info__text"> <p>'+Currency.formatMoney(Currency.convert(item.price*item.quantity, shop.currency, Currency.currentCurrency), Currency.currentFormat)+'</p> </div> </div> <div class="order-product-info"> <p class="title">RETURN / EXCHANGE</p> <div class="order-product-info__text"><span class="btn btn--order-product-info-return btn--white">return / exchange item</span> <div class="return-order-form hidden">  </div> </div> </div></div>';
        ordersTable.prepend(orderItem);
      })
      $('.main-return-form').removeClass('hidden');
      $('#findOrder, .form-descriptiom, .section-title').addClass('hidden');
      $('body').removeClass('loader');
    }
  }

  function getFormItems(elem) {
    var i = elem.attr('id');
    var item = allOrders[i];
    var orderForm;
    var orderItem = '';

    var titleHandle = item.title.replace(/ /g, "-").toLowerCase();

    var qtyOptions = '', variantOptions = '';
    for (var qt = 1; qt <= item.quantity; qt++) {
      qtyOptions = qtyOptions + '<option value="'+qt+'">'+qt+'</option>';
    }
    allProducts.forEach(function(arrProduct){
      if (arrProduct.id == item.product_id) {
        arrProduct.variants.forEach(function(prodVar) {
          if (prodVar.available == false) {
            variantOptions = variantOptions + '<option value="'+prodVar.title+'" disabled="disabled">'+prodVar.title+'</option>'
          } else {variantOptions = variantOptions + '<option value="'+prodVar.title+'">'+prodVar.title+'</option>'}
        })
      }
    })

    var varOpt = '<p id="reason-select-size'+i+'">This product has no other sizes.</p>';

    if (variantOptions.length>1) {
      varOpt = '<select name="new-size[reason_size'+i+']" id="reason-select-size'+i+'"> <option value="" style="display:none">please select size</option> '+variantOptions+' </select>';
    }

    orderForm = '<div class="return-order-form__item"> <p>QTY</p> <div class="selector-wrap"><select name="qty[qty'+i+']" id="qtu">'+qtyOptions+'</select></div> </div> <div class="return-order-form__item"> <p>RETURN REASON</p> <div class="selector-wrap"><select name="reason[reason'+i+']" class="main-reason" id="reason'+i+'"> <option value="not-select" style="display:none">please select</option> <option value="too-large" data-res-val="#reason-size'+i+'">too large</option> <option value="too-small" data-res-val="#reason-size'+i+'">too small</option> <option value="colour-not-as-expected">colour not as expected</option> <option value="style-not-as-expected">style not as expected</option> <option value="ordered-multiple-sizes">ordered multiple sizes</option> <option value="other" data-res-val="#reason-other'+i+'">other</option> </select></div> </div> <div class="return-order-form__item second-reason hidden" id="reason-size'+i+'"> <p>SELECT NEW SIZE</p> <div class="selector-wrap">'+varOpt+'</div> </div> <div class="return-order-form__item second-reason hidden" id="reason-other'+i+'"> <p>OTHER REASON</p><textarea name="other-text[reason_other'+i+']" placeholder="please type your reason here…"></textarea> </div>'+ selectors.iconClose;

    return orderForm;
  }

  $(document).on('click', '.order-product-info__text .btn--order-product-info-return', function() {
    $(this).closest('.order-product-list__item').attr('returned','');
    var formItems = getFormItems($(this).closest('.order-product-list__item'));
    $(this).addClass('hidden');
    $(this).closest('.order-product-info__text').find('.return-order-form').removeClass('hidden').append(formItems);
  })
  $(document).on('click', '.order-product-info__text .icon-close', function() {
    $(this).closest('.order-product-list__item').removeAttr('returned');
    $(this).closest('.order-product-info__text').find('.btn').removeClass('hidden');
    $(this).closest('.order-product-info__text').find('.return-order-form').addClass('hidden').empty();
    checkBtn();
  })
  $(document).on('change', '.main-reason', function() {
    var reason = $(this).find('option:selected').attr('data-res-val');
    $(this).closest('.order-product-info__text').find('.second-reason').addClass('hidden');
    if ($(reason).length) {
      $(reason).removeClass('hidden');
    }
    checkBtn();
  })

  function checkBtn() {
    if ($('.return-order-form .main-reason').length > 0) {
      $('.return-order-form .main-reason').each(function() {
        if ($(this).val() == 'not-select') {
          $('#submit-return').prop( "disabled", true );
        } else {
          $('#submit-return').prop( "disabled", false );
        }
      })
    } else {
      $('#submit-return').prop( "disabled", true );
    }
  }
})();

(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = window.theme || {};


// Return template  => return page
//
// $('.addinfo_last_retrn_order').on('click',function (e) {
//   e.preventDefault();
//  let id = $(this).data('order-id');
//  let number = $(this).data('order-number');
//
//   var obj = {
//     id: id,
//     number: number,
//   };
//
//   var serialObj = JSON.stringify(obj);
//
//   localStorage.setItem("order_return", serialObj);
//
// });

theme.StoreLocator = (function() {

  var selectors = {
    storesDataContainer: 'script#store-locations',
    filtersDataContainer: 'script#store-location-filters',
    mapSkinDataContainer: 'script#store-locator-skin',
    mapContainer: '#Map-'
  };

  var defaults = {
    map: {
      zoom: 4,
      center: {
        lat: -27.4711221,
        lng: 145.8784178
      },
      minZoom: 3,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
    },
    rawDataType: 'globalObject',
    googlePlacesFields: [
      'url',
    ],
    enableSearch: false,
    activeStoreZoomLevel: 15,
    showStoreInfoWindow: true,
    showSearchMarker: false,
  };

  function StoreLocator(container) {

    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.mapContainer = document.querySelector(selectors.mapContainer + this.sectionId);

    this.options = _.defaults(defaults, {});

    if (!this.container) {
      return;
    }

    this.data = {
      parsedData: {},
      stores: [],
      groups: [],
      filters: [],
      tags: [],
      markerClusters: [],
      activeFilters: [],
      activeStore: null,
      activeGroup: null,
      storesInFilter: [],
      storesInView: [],
    };

    this.methods = {
      focusStore: this._focusStore.bind(this),
      zoomToFitMarkers: this._zoomToFitMarkers.bind(this),
      selectGroup: this._focusGroup.bind(this),
      changeFilter: this._changeFilter.bind(this),
      selectFilter: this._focusFilter.bind(this),
      clearFilter: this._clearFilters.bind(this),
      clearActiveStore: this._clearActiveStore.bind(this),
      findUser: this._findUser.bind(this),
    };

    this._prepareData();
    this._bindView();
    this._buildMap();

    if ("geolocation" in navigator) {
      this.data.geolocationEnabled = true;
    }

    this.data.is_ready = true;

  }

  StoreLocator.prototype = _.extend({}, StoreLocator.prototype, {

    _onMapLoadComplete: function() {

      var queryparams = theme.utils.getQueryParams();
      var queryparamChecks = [
        this._setActiveStoreFromQueryParam.bind(this),
        this._setActiveGroupFromQueryParam.bind(this),
        this._setActiveFilterFromQueryParam.bind(this)
      ];

      var i = queryparamChecks.length;
      while(i--) {
        if (queryparamChecks[i](queryparams)) {
          break;
        }
      }

    },

    _setActiveFilterFromQueryParam: function(queryparams) {

      var handle,
          filter;

      if (queryparams && queryparams.tag) {
        handle = queryparams.tag; // todo: tags
        filter = _.find(this.data.filters, { 'handle': handle });
      }

      if (!filter) {
        return false;
      }

      return this._setActiveFilter(filter, 'add');

    },

    _setActiveGroupFromQueryParam: function(queryparams) {

      var handle,
          group;

      if (queryparams && queryparams.group) {
        handle = queryparams.group;
        group = _.find(this.data.groups, { 'handle': handle });
      }

      if (!group) {
        return false;
      }

      return this._setActiveGroup(group);

    },

    _setActiveStoreFromQueryParam: function(queryparams) {

      var handle,
          store;

      if (queryparams && queryparams.store) {
        handle = queryparams.store;
        store = _.find(this.data.stores, { 'handle': handle });
      }

      if (!store) {
        return false;
      }

      return this._setActiveStore(store);

    },

    _focusFilter: function() {

      var id,
          filter,
          filterAction;

      id = event.currentTarget.dataset.filterId;
      filter = _.find(this.data.filters, {'id': id});

      if (!filter) {
        console.error(new Error('No filter found!'));
        return;
      }

      if (filter.active) {

        filterAction = 'remove';

      } else {

        if (this.options.allowMultipleFilters) {
          filterAction = 'add';
        } else {
          filterAction = 'replace';
        }

      }

      this._setActiveFilter(filter, filterAction);
    },

    _setActiveFilter: function(filter, action, updateMap) {

      var self = this;

      // action = 'add', 'remove', 'replace', 'reset'

      if (!action) {
        console.error('An action must be defined');
        console.error('action = add, remove, replace, reset');
        return;
      }

      this._setActiveStore(false, false);

      switch(action) {

        case 'replace':

          _.each(this.data.activeFilters, function(filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'remove':

          filter.active = false;

          var i = this.data.activeFilters.length;
          while(i--) {
            if (this.data.activeFilters[i] == filter) {
              this.data.activeFilters.splice(i, 1);
              break;
            }
          }
          break;

        case 'add':

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'reset':

          _.each(this.data.activeFilters, function(filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];
          break;

      }

      _.each(this.data.stores, function(store, i) {
        var storeInFilter = true;

        _.each(self.data.activeFilters, function(filter) {

          if (!store.tags || store.tags.indexOf(filter.tag) == -1) {
            storeInFilter = false;
          }

        });

        if (storeInFilter) {
          self._addStoreToFilter(store);
        } else {
          self._removeStoreFromFilter(store);
        }

      });

      if (self.data.activeFilters.length == 0) {
        this.data.storesAreFiltered = false;
      } else {
        this.data.storesAreFiltered = true;
      }

      this._getMarkersInView();

      this._setFiltersNoResultsMessage();

      _.each(this.data.markerClusters, function(markerCluster, i) {
        markerCluster.repaint();
      })

    },

    _setFiltersNoResultsMessage: function() {

      if (!this.data.activeGroup) {
        if (this.data.storesAreFiltered && this.data.storesInFilter.length == 0) {
          this.data.filterNoResults = true;
        } else {
          this.data.filterNoResults = false;
        }
      } else {
        if (this.data.storesAreFiltered && _.intersectionWith(this.data.storesInFilter, this.data.storesInActiveGroup,_.isEqual).length == 0) {
          this.data.filterNoResults = true;
        } else {
          this.data.filterNoResults = false;
        }
      }

    },

    _clearFilters: function() {
      this._setActiveFilter(false, 'reset');
    },

    _addStoreToFilter: function(store) {

      if (store.in_filter == true) {
        return;
      }

      store.in_filter = true;

      if (store.marker) {
        store.marker.setMap(this.map);
        store.markerCluster && store.markerCluster.addMarker(store.marker);
        store.markerCluster.redraw();
      }


      this.data.storesInFilter.push(store);

    },

    _removeStoreFromFilter: function(store) {

      if (store.in_filter == false) {
        return;
      }

      store.in_filter = false;

      if (store.marker) {
        store.markerCluster && store.markerCluster.removeMarker(store.marker);
        store.marker.setMap(null);
        store.markerCluster.redraw();
      }

      _.pull(this.data.storesInFilter, store);

    },

    _focusStore: function() {

      var id,
          store;
      id = event.currentTarget.dataset.storeId;
      store = _.find(this.data.stores, {'id': id});

      if (!store) {
        console.error(new Error('No store found!'));
        return;
      }

      // If a link is cliked, only follow the link if the store is active
      if (event.target && event.target.nodeName == 'A') {
        if (store.active) {
          return;
        } else {
          event.preventDefault();
        }
      }

      this._setActiveStore(store);

    },

    _clearActiveStore: function() {
      this._setActiveStore(false, false);
    },

    _setActiveStore: function(store, updateMap) {

      var self = this;

      var marker,
          markerPosition,
          activeStore,
          currentMapBounds,
          currentMapZoom,
          boundsContainsMarker;

      activeStore = this.data.activeStore;

      if (activeStore) {
        activeStore.active = false;

        if (activeStore.infoWindow) {
          activeStore.infoWindow.close();
        }

      }

      if (store == false || !store) {
        this.data.activeStore = null;
        return;
      }

      if (store && updateMap != false && store.marker) {

        marker = store.marker;

        markerPosition = marker.getPosition();
        currentMapBounds = this.map.getBounds();
        boundsContainsMarker = currentMapBounds ? currentMapBounds.contains(markerPosition) : false;
        currentMapZoom = this.map.getZoom();

        if (!boundsContainsMarker || currentMapZoom < this.options.activeStoreZoomLevel) {
          this.map.panTo(markerPosition);
          this.map.setZoom(this.options.activeStoreZoomLevel);
        }

      }

      if (store && store.group) {
        this._setActiveGroup(store.group, false);
      }

      this.data.activeStore = store;
      store.active = true;

      var awaitFetchStoreDetails = false;

      if (awaitFetchStoreDetails && store.place_id && !store.place && !store.is_loading) {
        this._fetchStoreDetails(store, function() {
          self._openStoreInfoWindow(store);
        });
      } else {
        self._openStoreInfoWindow(store);
      }

      return store;

    },

    _fetchStoreDetails: function(store, callback) {

      var request;

      store.is_loading = true;

      request = {
        placeId: store.place_id,
        fields: this.options.googlePlacesFields
      };

      function formatOpeningHours(periods) {
        // Formats opening hours provided by Google Places API

        var days,
            dayNames,
            dayIndex,
            dayTitle,
            daysString,
            openAmPm,
            openHours,
            openMinutes,
            openTime,
            closeAmPm,
            closeHours,
            closeMinutes,
            closeTime,
            timesString;

        days = [];
        dayNames = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'];

        _.each(periods, function(period) {

          dayIndex = period.open.day;
          dayTitle = dayNames[dayIndex];

          openAmPm = (period.open.hours < 12 ? 'am' : 'pm');
          openHours = (period.open.hours < 12 ? period.open.hours : period.open.hours - 12);
          openMinutes = (period.open.minutes ? ':' + period.open.minutes : '');
          openTime = openHours + openMinutes + openAmPm;

          closeAmPm = (period.close.hours < 12 ? 'am' : 'pm');
          closeHours = (period.close.hours < 12 ? period.close.hours : period.close.hours - 12);
          closeMinutes = (period.close.minutes ? ':' + period.close.minutes : '');
          closeTime = closeHours + closeMinutes + closeAmPm;

          timesString = openTime + ' - ' + closeTime;

          daysString = dayTitle;

          function TimePeriod(options) {
            _.extend(this, options);
          }

          days.push(new TimePeriod({
            startDay: dayTitle,
            endDay: dayTitle,
            daysString: daysString,
            timesString: timesString,
            open: openTime,
            close: closeTime,
          }));

        });

        _.each(days, function(day, i) {
          var nextDay;

          nextDay = days[i + 1];

          if (nextDay && day.timesString == nextDay.timesString) {
            nextDay.startDay = day.startDay;
            nextDay.daysString = nextDay.startDay + ' - ' + nextDay.endDay;
            day.toDelete = true;
          }

        });

        _.remove(days, {'toDelete': true});

        return days;

      }

      this.placesService.getDetails(request, function(place, status) {

        if (status === google.maps.places.PlacesServiceStatus.OK) {

          store.place = place;

          // store.open_now = place.opening_hours.open_now;
          // store.opening_hours = (place.opening_hours.periods ? formatOpeningHours(place.opening_hours.periods) : []);
          // store.int_phone = place.international_phone_number;
          // store.phone = (place.formatted_phone_number ? place.formatted_phone_number.replace(/\-/g, ' ') : false);
          // store.permanently_closed = place.permanently_closed;
          store.google_url = place.url;

          store.is_loading = false;

          if (callback && typeof callback == 'function') {
            callback();
          }

        } else {
          console.error(new Error('Error receiving data from Places service'));

          if (callback && typeof callback == 'function') {
            callback();
          }
        }

      });

    },

    _openStoreInfoWindow: function(store) {

      var self = this;

      var marker;

      if (!self.options.showStoreInfoWindow) {
        return;
      }

      if (!store.marker) {
        return;
      }

      marker = store.marker;

      if (!store.infoWindow) {
        store.infoWindowContent = document.createElement('div');
        store.infoWindowContent.innerHTML = theme.utils.getTemplate('store-location-info-popup');

        tinybind.bind(store.infoWindowContent, {
          store: store
        });

        store.infoWindow = new google.maps.InfoWindow({
          content: store.infoWindowContent
        });
      }

      store.infoWindow.open(self.map, store.marker);

    },

    _focusGroup: function() {

      var id,
          group;

      id = event.currentTarget.value;

      if (id == '' || id =='none') {
        this._setActiveGroup(false);
        return;
      }

      group = _.find(this.data.groups, {'id': id});

      if (!group) {
        console.error(new Error('No group found!'));
        return;
      }

      this._setActiveGroup(group);

    },
    _changeFilter: function(){
      var type;

      type = event.currentTarget.value;

      console.log(type);
    },
    _setActiveGroup: function(group, updateMap) {

      var self = this;

      var center,
          address,
          markerPosition,
          activeGroup;

      activeGroup = this.data.activeGroup;
      if (activeGroup) {
        activeGroup.active = false;
      }

      if (group == false) {
        this.data.activeGroup = null;
        this._zoomToFitMarkers();
        this._setActiveStore(false, false);
        return;
      }

      this.data.activeGroup = group;
      group.active = true;

      if (updateMap == false) {
        return;
      }

      this._setActiveStore(false, false);

      if (group.markers.length > 1) {

        bounds = new google.maps.LatLngBounds();

        _.each(group.markers, function(marker, i) {
          bounds.extend(marker.getPosition());
        });

        // Prevent zooming too close
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
           var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 8, bounds.getNorthEast().lng() + 8);
           var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 8, bounds.getNorthEast().lng() - 8);
           bounds.extend(extendPoint1);
           bounds.extend(extendPoint2);
        }

        self.map.fitBounds(bounds);

      } else if (group.markers.length == 1) {

        markerPosition = group.markers[0].getPosition();

        this.map.panTo(markerPosition);
        this.map.setZoom(14);

      }

      //  IF LOOKUP UP A REGION FROM MAPS API

      // if (region.geo) {
      //   console.info(this.data);
      //   this.map.fitBounds(region.geo.bounds);
      //   return;
      // }

      // this.geocoder.geocode({
      //   'address': region.title,
      //   'bounds': bounds
      // }, function(results, status) {

      //   if (status == 'OK') {
      //     center = results[0].geometry;
      //     region.geo = center;

      //     self.map.fitBounds(region.geo.bounds);
      //   } else {
      //     console.error(new Error('Geocode error: ' + status));
      //   }

      // });

      return group;

    },

    _prepareData: function() {

      var self = this;

      this._getData(processData);

      function processData() {
        self._prepareStoresData();
        self._prepareStoresTagsData();
        self._prepareGroupsData();
        self._prepareFiltersData();
      }

    },

    _getData: function(callback) {

      var dataContainer,
          rawData,
          parsedData,
          parseOptions,
          rawDataType;

      dataContainer = document.querySelector(selectors.storesDataContainer);

      rawDataType = this.options.rawDataType;

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;

      switch(rawDataType) {

        case 'globalObject':
        this.data.parsedData.data = theme.storeLocatorStoresData;
        callback();
        return;

        case 'json':

          this.data.parsedData.data = JSON.parse(rawData);
          callback();
          return;

        case 'csv':

          parseOptions = {
            header: true,
            dynamicTyping: true
          };

          this.data.parsedData = Papa.parse(rawData, parseOptions);

          if (this.data.parsedData.errors && this.data.parsedData.errors.length > 0) {
            console.error(new Error('There was an error parsing data'));
            console.error(data.parsedData.errors);
            return;
          }

          callback();
          return;

        default:

          this.data.parsedData.data = rawData;
          callback();
          return;

      }

    },

    _prepareStoresData: function() {

      var self = this;

      var locationMarkerSVG,
          googleMapsSearchURLPrefix;

      locationMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');
      googleMapsSearchURLPrefix = 'https://www.google.com/maps/search/';

      function Store(data) {

        _.extend(this, data);

        if (!this.title) {
          console.error(new Error('A title is required'));
          return
        }

        this.id = theme.utils.handleize(this.title + ' ' + this.street + ' ' + this.city);
        this.icon = locationMarkerSVG;
        this.google_url = googleMapsSearchURLPrefix + theme.utils.handleize(this.title).replace(/\-/g, '+')

        if (this.street && typeof this.street == 'string') {
          this.google_url = this.google_url + '+' + theme.utils.handleize(this.street).replace(/\-/g, '+');
        }

        // if (this.opening_hours) {
        //   this.opening_hours = _.map(this.opening_hours.split(/,/), function(period) {
        //     return _.map(period.replace(/:/, '#').split(/#/), _.trim);
        //   });
        // }
      }

      _.each(self.data.parsedData.data, function(data) {

        var store,
            locationData,
            existingArea;

        data = self._preformatStoreData(data);

        // if (!data.lat || !data.long) {
        //   return;
        // }

        // Build store data
        store = new Store(data);
        self.data.stores.push(store);

      });

      // Sort stores by title
      self.data.stores = _.orderBy(self.data.stores, ['title'], ['city'], ['street']);

    },

    _preformatStoreData: function(data) {
      data.lat = data.position_lat;
      data.long = data.position_long;
      data.tags = '';
      if (data.accepts_hires) {
        data.tags = data.tags ? data.tags + ',accepts-hires' : 'accepts-hires';
      }
      if (data.made_to_measure) {
        data.tags = data.tags ? data.tags + ',made-to-measure' : 'made-to-measure';
      }
      if (data.stockist) {
        data.tags = data.tags ? data.tags + ',stockist' : 'stockist';
      }
      if (data.click_and_collect) {
        data.tags = data.tags ? data.tags + ',click-and-collect' : 'click-and-collect';
      }
      data.street = data.address_street;
      data.city = data.address_city;
      data.state = data.address_state;
      data.country = data.address_country;
      data.province = data.address_island;
      data.phone = data.contact_phone;
      data.email = data.contact_email;
      data.group = data.country == 'nz' ? 'New Zealand' : 'Australia';
      data.internal_url = data.page_url ? '/pages/' + data.page_url : false;
      return data;
    },

    _prepareStoresTagsData: function() {

      var self = this;

      function Tag(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(this.data.stores, function(store, i) {
        var existingTag,
            tagString,
            tags;

        if (store.tags && typeof store.tags == 'string') {

          tags = store.tags.split(',');

          store.tags = [];

          _.each(tags, function(tagString) {

            tagString = theme.utils.handleize(tagString);

            existingTag = _.find(self.data.tags, {'title': tagString });

            if (!existingTag) {

              tag = new Tag({ title: tagString });
              self.data.tags.push(tag);


            } else {
              tag = existingTag;
            }

            store.tags.push(tag);

          });

        }

      });

    },

    _prepareGroupsData: function() {

      var self = this;

      function Group(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
        this.handle = this.id
      }

      _.each(this.data.stores, function(store, i) {
        var locationData,
            existingGroup;

        if (store.group && typeof store.group == 'string') {

          existingGroup = _.find(self.data.groups, {'title': store.group });

          if (!existingGroup) {
            locationData = {
              title: store.group
            };

            group = new Group(locationData);
            self.data.groups.push(group);
            group.stores = [];

          } else {
            group = existingGroup;
          }

          store.group = group;

          group.stores.push(store);

        }

      });

    },

    _prepareFiltersData: function() {

      var self = this;

      var dataContainer,
          rawData,
          jsonData;

      dataContainer = document.querySelector(selectors.filtersDataContainer);

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;
      jsonData = JSON.parse(rawData);

      function Filter(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
        this.handle = this.id;
      }

      _.each(jsonData, function(value) {
        var filter,
            tag;

        value.tag = _.find(self.data.tags, {'title': value.tag });

        if (value.tag) {
          value.tag.icon = value.icon;
        }

        filter = new Filter(value);
        self.data.filters.push(filter);

      });

    },

    _bindView: function() {

      tinybind.bind(this.container, {
        data: this.data,
        methods: this.methods
      });

    },

    _getMapStyles: function() {
      dataContainer = document.querySelector(selectors.mapSkinDataContainer);

      if (!dataContainer || !dataContainer.innerHTML) {
        return;
      }

      rawData = dataContainer.innerHTML;
      return JSON.parse(rawData);
    },

    _buildMap: function() {

      var self = this;

      var googleMapsAPIURL = 'https://maps.googleapis.com/maps/api/js?key=',
          googleMapsAPIKEY = shop.keys.googleMaps,
          googleMapsAdditionalLibraries  = '&libraries=places',
          options = this.options.map,
          mapSkin = this._getMapStyles();

      if(mapSkin) {
        options.styles = mapSkin;
      }

      if (!googleMapsAPIKEY) {
        return console.error(new Error('Google Maps API key is required. You can set this up as as Store metafield: '))
      }

      function initMap() {
        self.geocoder = new google.maps.Geocoder();
        self.map = new google.maps.Map(self.mapContainer, options);
        self.placesService = new google.maps.places.PlacesService(self.map);

        self._addMapMarkers();

        google.maps.event.addListenerOnce(self.map, 'idle', function() {
          self._onMapLoadComplete();
        });

        if (self.options.enableSearch) {
          self._prepareSearch();
        }
      }

      loadJS(googleMapsAPIURL + googleMapsAPIKEY + googleMapsAdditionalLibraries, initMap);

    },

    _addMapMarkers: function() {

      var self = this;

      _.each(this.data.stores, function(store, i) {
        var position,
            icon;

        if (!store.lat || !store.long) {
          return;
        }

        position = {
          'lat': parseFloat(store.lat),
          'lng': parseFloat(store.long)
        };

        icon = store.icon;

        if (store.lat && store.long) {

          store.marker = new google.maps.Marker({
            position: position,
            map: self.map,
            icon: {
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
              size: new google.maps.Size(28, 40),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(14, 40),
              scaledSize: new google.maps.Size(28, 40)
            },
            optimized: false
          });

          if (store.group) {
            store.group.markers = store.group.markers || [];
            store.group.markers.push(store.marker);
          }

          store.marker.addListener('click', function() {
            self._setActiveStore(store);
          });

        }
      });

      this._clusterMarkers();
      this._zoomToFitMarkers();
      this._bindMapListners();

    },

    _clusterMarkers: function() {
      var self = this;

      var clusterMarkerSVG = theme.utils.getTemplate('store-location-cluster-marker-icon');

      _.each(this.data.groups, function(group, i) {

        var clusterStyles = [
          {
            width: 28,
            height: 40,
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(clusterMarkerSVG),
            textSize: 0,
            iconAnchor: [50, 100],
            textColor: 'transparent'
          }
        ];

        group.markerCluster = new MarkerClusterer(self.map, group.markers, {
          gridSize: 30,
          styles: clusterStyles,
          zoomOnClick: true,
          maxZoom: (self.options.activeStoreZoomLevel - 1),
          minimumClusterSize: 3,
        });

        self.data.markerClusters.push(group.markerCluster);

        _.each(group.stores, function(store) {
          if (store.marker) {
            store.markerCluster = group.markerCluster;
          }
        });

      });

    },

    _zoomToFitMarkers: function() {

      var bounds = new google.maps.LatLngBounds();

      _.each(this.data.stores, function(store, i) {
        if (store.marker) {
        bounds.extend(store.marker.getPosition());
        }
      });

      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        console.info('Too close!');
        var extendPoint = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
        bounds.extend(extendPoint);
      }

      this.map.fitBounds(bounds);

    },

    _bindMapListners: function() {

      var self = this;

      this.map.addListener('bounds_changed', _.debounce(this._getMarkersInView.bind(self), 150));
      this.map.addListener('bounds_changed', function() {
        if (!self.data.mapMoveInProgress) {
          self.data.mapMoveInProgress = true;
        }
      });

    },

    _unbindMapListners: function() {

      var self = this;

      google.maps.event.clearListeners(this.map, 'bounds_changed');

    },

    _getMarkersInView: function() {

      this.data.mapMoveInProgress = false;

      var self = this;

      this.data.storesInView = [];
      this.data.storesInActiveGroup = [];

      // this.data.activeGroupTitle = 'none';

      var bounds = this.map.getBounds();

      _.each(this.data.stores, function(store, i) {
        var markerPosition,
            boundsContainsMarker;

        if (store.marker) {
          markerPosition = store.marker.getPosition();
          boundsContainsMarker = bounds.contains(markerPosition);

          if (boundsContainsMarker && (!self.data.storesAreFiltered || self.data.storesAreFiltered && store.in_filter)) {
            store.in_view = true;
            self.data.storesInView.push(store);
          } else {
            store.in_view = false;
          }
        }

        if (store.group == self.data.activeGroup) {
          store.in_active_group = true;
          self.data.storesInActiveGroup.push(store);
        } else {
           store.in_active_group = false;
        }

      });

      if (this.data.storesInView && this.data.storesInView.length == 1) {
        var store = this.data.storesInView[0];

        if (store != self.data.activeStore) {
          this._setActiveStore(store, false);
        }

      }

      this._setFiltersNoResultsMessage();

    },

    _findUser: function() {

      var self = this;

      this.data.geolocationLoading = true;

      function success(position) {
        var pos;

        pos = {
          lat: position.coords.latitude,
          long: position.coords.longitude
        };

        userLocation = new google.maps.LatLng(pos.lat, pos.long);

        self._updateUserMarker(userLocation);

        self._findClosestStore(userLocation);
        self.data.geolocationLoading = false;
      }

      function error() {

        self.data.geolocationLoading = false;
        self.data.geolocationEnabled = false;

        iziToast.error({
          title: 'We couldn\'t find your location',
          position: 'bottomCenter',
          theme: 'light',
        });

      }

      navigator.geolocation.getCurrentPosition(success, error);

    },

    _findClosestStore: function(latLng) {

      var self = this;

      var closestStore,
          bounds,
          userLocation,
          currentMapZoom;

      bounds = new google.maps.LatLngBounds();

      closestStore = getClosestStore(latLng);

      if (!closestStore) {
        iziToast.error({
          title: 'We couldn\'t find a store closest to you.',
          message: 'Try removing some filters and trying again',
          position: 'bottomCenter',
          theme: 'light',
        });
        return;
      }

      self._setActiveStore(closestStore, true);

      bounds.extend(closestStore.marker.getPosition());
      bounds.extend(latLng);

     // self.map.fitBounds(bounds);

      // currentMapZoom = this.map.getZoom();

      // if (currentMapZoom != this.options.activeStoreZoomLevel) {
      //   self.map.setZoom(this.options.activeStoreZoomLevel);
      // }

      function getClosestStore(latLng) {

        // https://stackoverflow.com/questions/4057665/google-maps-api-v3-find-nearest-markers
        var lat = latLng.lat();
        var long = latLng.lng();
        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = -1;

        var closestStore = null;

        function rad(x) {return x*Math.PI/180;}

        var stores = self.data.activeFilters.length ? _.filter(self.data.stores, { 'in_filter': true }) : self.data.stores;

        _.each(stores, function(store, i) {

            var mlat = store.lat;
            var mlng = store.long;

            if (!mlat || !mlng) {
              return;
            }

            var dLat  = rad(mlat - lat);
            var dLong = rad(mlng - long);
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c;
            distances[i] = d;

            if ( closest == -1 || d < distances[closest] ) {
                closest = i;
                closestStore = store;
            }

        });

        return closestStore;

      }

    },

    _updateUserMarker: function(latLng) {

      var self = this;

      var pos,
          icon,
          user,
          locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function User(data) {
        _.extend(this, data);
      }

      if (!this.data.user) {

        locationMarkerSVG = theme.utils.getTemplate('user-location-marker-icon');
        this.data.user = new User({
          icon: locationMarkerSVG
        });

      }

      user = this.data.user;

      user.latLng = latLng;

      if (!user.marker) {
        icon = user.icon;

        user.marker = new google.maps.Marker({
          position: user.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24)
          },

          optimized: false

        });

      } else {

        user.marker.setPosition(user.latLng);

      }

    },

    _prepareSearch: function() {

      this.data.searchEnabled = true;

      var self = this;

      var searchField;

      // If the search box breaks it is because we are
      // using TinyBind but searching for the input field
      // with an ID. Perhaps use a tinybind binder to
      // reference the input field.
      searchField = document.getElementById('store-locator-search')

      this.autocomplete = new google.maps.places.Autocomplete(searchField);

      // #todo: Autocomplete.setFields()

      this.autocomplete.addListener('place_changed', function() {

        var place;

        place = self.autocomplete.getPlace();

        if (!place.geometry) {

          iziToast.error({
            title: 'We couldn\'t find this location',
            position: 'bottomCenter',
            theme: 'light',
          });

          return;
        }

        self._findClosestStore(place.geometry.location);
        self._updateSearchMarker(place.geometry.location);

      });
    },

    _updateSearchMarker: function(latLng) {

      if (!this.options.showSearchMarker) {
        return;
      }

      var self = this;

      var pos,
          icon,
          locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function Search(data) {
        _.extend(this, data);
      }

      if (!this.data.search) {

        locationMarkerSVG = theme.utils.getTemplate('search-location-marker-icon');
        this.data.search = new Search({
          icon: locationMarkerSVG
        });

      }

      search = this.data.search;
      search.latLng = latLng;

      if (!search.marker) {

        icon = search.icon;

        search.marker = new google.maps.Marker({
          position: search.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24)
          },

          optimized: false

        });

      } else {

        search.marker.setPosition(search.latLng);

      }

    },


  });

  return StoreLocator;

})();


function reinitProductOptions(product) {
  $('.single-option--length').on('change', function() {
    var self = $(this);

    var size_wrapper = self.parent().parent().parent().parent().next().find('.size_option__wrapper');

    var length_value = self.val().split('/');
    var current_length_format = length_value[0] + ' ' + length_value[1];
    var current_length_selector = $('.current_option[name="length"]');
    current_length_selector.text(current_length_format);

    var available_sizes = [];
    var all_size_option = $('.single-option--length[data-length-available=true]').parent().parent().parent().parent().next().find(".single-option--size");
    all_size_option.removeAttr('checked');

    size_wrapper.css('display', 'none');

    let allOptions = [];
    let sizeOptions = $('.variants_container .single-option--size').toArray()
    for (var i = 0; i < sizeOptions.length; i++) {
      let element = sizeOptions[i]
      if(element.value.length >= 2){
        let itemLength = element.value.slice(-1).toLowerCase();
        if (element.value == 'xs' || element.value == 's'){
          itemLength = 'r'
        }
        allOptions.push({value: element.value, element: element, pantLength: itemLength})
      }
    }

    var self_length = self;
    var size_option_elem;
    if (self_length.attr("data-length-type") == "short") {
      //  size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
      size_option_elem = allOptions.filter((item)=> item.pantLength == 's' )

    } else if (self_length.attr("data-length-type") == "regular") {
      // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
      size_option_elem = allOptions.filter((item)=> item.pantLength == 'r');
    } else if (self_length.attr("data-length-type") == "tall") {
      // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
      size_option_elem = allOptions.filter((item)=> item.pantLength == 't');
    }

    $(size_option_elem).each(function() {
      var self_size_item = $(this.element);
      var size_wrapper = self_size_item.closest('.size_option__wrapper');
      size_wrapper.css('display', 'block');

      if (!self_size_item.attr('disabled')) {
        available_sizes.push(self_size_item);
      }
    });

    if(available_sizes.length>0){
      available_sizes[0].click();
    }
  });
  if($('.template-product').length > 0) {

    var variants_available__counter = 0;
    var child_products = false;
    var length_block = $('.length_options__block');
    var length_block_counter = 0;

    if(child_products) {
      child_products.forEach(function(item_product) {
        if (length_block.length > 0) {
          if (length_block_counter < length_block.length) {
            self_length_block = length_block[length_block_counter];

            if (item_product.handle.includes("jacket") || item_product.handle.includes("blazer") || item_product.handle.includes("suit") || item_product.tags.includes("length-option")) {

              var length_option_block__input = $(self_length_block).find('.single-option--length');
              if (length_option_block__input.length > 0) {
                length_option_block__input.each(function () {
                  var self_length = $(this);

                  var size_option_elem;
                  if (self_length.attr("data-length-type") == "short") {
                    size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
                  } else if (self_length.attr("data-length-type") == "regular") {
                    size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
                  } else if (self_length.attr("data-length-type") == "tall") {
                    size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
                  }

                  if (size_option_elem.length != 0) {
                    $(size_option_elem).each(function() {
                      var self_size = $(this);
                      var self_size_val = $(this).val();

                      for (let i = 0; i < item_product.variants.length; i++) {
                        const element = item_product.variants[i];
                        if (element.option1 == self_size_val) {
                          if (element.available) {
                            variants_available__counter++;
                          } else {
                            self_size.attr('disabled', 'true');
                          }
                        }
                      }
                    });
                  } else {
                    variants_available__counter = 0;
                  }

                  if (variants_available__counter == 0) {
                    self_length.attr('disabled', 'true');
                  } else {
                    self_length.attr('data-length-available', 'true');
                  }

                  variants_available__counter = 0;

                });

                var available_sizes = [];

                var available_length = $(self_length_block).find('.single-option--length[data-length-available=true]');
                var all_size_option = $('.single-option--length[data-length-available=true]').closest(self_length_block).parent().parent().parent().parent().next().find(".single-option--size");

                all_size_option.removeAttr('checked');

                var checked_length;

                available_length.each(function(){
                  var self_available_length = $(this);

                  if (self_available_length.attr('data-length-type') == 'short') {
                    checked_length = self_available_length;
                    checked_length.click();
                    return false;
                  }
                });

                if (checked_length === undefined) {
                  checked_length = $(available_length[0]);
                  checked_length.click();
                }

                var length_value = checked_length.val().split('/');
                var current_length_format = length_value[0] + ' ' + length_value[1];

                var current_length_selector = $('.current_option[name="length"]');
                current_length_selector.text(current_length_format);

                if (checked_length.attr('data-length-type') == "short") {
                  var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
                  size_option_elem.each(function() {
                    var self_size_item = $(this);
                    var size_wrapper = self_size_item.closest('.size_option__wrapper');
                    size_wrapper.css('display', 'block');

                    if (!self_size_item.attr('disabled')) {
                      available_sizes.push(self_size_item);
                    }
                  });
                } else if (checked_length.attr("data-length-type") == "regular") {
                  var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
                  size_option_elem.each(function() {
                    var self_size_item = $(this);
                    var size_wrapper = self_size_item.closest('.size_option__wrapper');
                    size_wrapper.css('display', 'block');

                    if (!self_size_item.attr('disabled')) {
                      available_sizes.push(self_size_item);
                    }
                  });
                } else if (checked_length.attr("data-length-type") == "tall") {
                  var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
                  size_option_elem.each(function() {
                    var self_size_item = $(this);
                    var size_wrapper = self_size_item.closest('.size_option__wrapper');
                    size_wrapper.css('display', 'block');

                    if (!self_size_item.attr('disabled')) {
                      available_sizes.push(self_size_item);
                    }
                  });
                }

                if(available_sizes.length>0){
                  available_sizes[0].click();
                }

                length_block_counter++;
              }
            }
          }
        } else {

          var option_size_elem = $(".single-option--size[data-product-id="+item_product.id+"]");

          option_size_elem.each(function() {
            var self_only_size__option = $(this);
            var size_option__value = self_only_size__option.val();
            var size_wrapper = self_only_size__option.closest('.size_option__wrapper');

            for (let i = 0; i < item_product.variants.length; i++) {
              const element = item_product.variants[i];
              if (element.option1 == size_option__value) {
                if (element.available) {
                  variants_available__counter++;
                  size_wrapper.css('display', 'block');
                } else {
                  self_only_size__option.attr('disabled', 'true');
                  size_wrapper.css('display', 'block');
                }
              }
            }
          });
        }
      });
    } else {

      if (product.handle.includes("jacket") || product.handle.includes("blazer") || product.handle.includes("suit") || product.tags.includes("length-option")) {

        if ($('.single-option--length').length) {
          $('.single-option--length').each(function () {
            var self_length = $(this);
            // Loops through sizing options

            let allOptions = [];
            let sizeOptions = $('.variants_container .single-option--size').toArray()
            for (var i = 0; i < sizeOptions.length; i++) {
              let element = sizeOptions[i]
              if(element.value.length >= 2){
                let itemLength = element.value.slice(-1).toLowerCase();
                if (element.value == 'xs' || element.value == 's'){
                  itemLength = 'r'
                }
                allOptions.push({value: element.value, element: element, pantLength: itemLength})
                // console.log("here all options: " , allOptions)
              }
            }

            var size_option_elem;
            if (self_length.attr("data-length-type") == "short") {
              //  size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
              size_option_elem = allOptions.filter((item)=> item.pantLength == 's' )

            } else if (self_length.attr("data-length-type") == "regular") {
              // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
              size_option_elem = allOptions.filter((item)=> item.pantLength == 'r');
            } else if (self_length.attr("data-length-type") == "tall") {
              // size_option_elem = self_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
              size_option_elem = allOptions.filter((item)=> item.pantLength == 't');
            }

            if (size_option_elem) {
              $(size_option_elem).each(function(i, ele) {
                var self_size = $(this);
                //  var self_size_val = $(this)[i].element.value;


                //Loops through Product Variants
                for (let i = 0; i < product.variants.length; i++) {
                  const element = product.variants[i];
                  if (element.available) {
                    variants_available__counter++;
                  } else {
                    self_size.attr('disabled', 'true');
                  }
                }
              });
            } else {
              variants_available__counter = 0;
            }

            if (variants_available__counter == 0) {
              self_length.attr('disabled', 'true');
            } else {
              self_length.attr('data-length-available', 'true');
            }

            variants_available__counter = 0;

          });

          var available_sizes = [];

          var available_length = $('.single-option--length[data-length-available=true]');
          var all_size_option = $('.single-option--length[data-length-available=true]').parent().parent().parent().parent().next().find(".single-option--size");

          all_size_option.removeAttr('checked');

          var checked_length;

          available_length.each(function(){
            var self_available_length = $(this);

            if (self_available_length.attr('data-length-type') == 'regular') {
              checked_length = self_available_length;
              checked_length.click();
              return false;
            }
          });

          if (checked_length === undefined) {
            checked_length = $(available_length[0]);
            checked_length.click();
          }

          var length_value = checked_length.val().split('/');
          var current_length_format = length_value[0] + ' ' + length_value[1];

          var current_length_selector = $('.current_option[name="length"]');
          current_length_selector.text(current_length_format);

          if (checked_length.attr("data-length-type") == 'short') {
            var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=S]");
            size_option_elem.each(function() {
              var self_size_item = $(this);
              var size_wrapper = self_size_item.closest('.size_option__wrapper');
              size_wrapper.css('display', 'block');

              if (!self_size_item.attr('disabled')) {
                available_sizes.push(self_size_item);
              }
            });
          } else if (checked_length.attr("data-length-type") == "regular") {
            var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=R]");
            size_option_elem.each(function() {
              var self_size_item = $(this);
              var size_wrapper = self_size_item.closest('.size_option__wrapper');
              size_wrapper.css('display', 'block');

              if (!self_size_item.attr('disabled')) {
                available_sizes.push(self_size_item);
              }
            });
          } else if (checked_length.attr("data-length-type") == "tall") {
            var size_option_elem = checked_length.parent().parent().parent().parent().next().find(".single-option--size[value*=T]");
            size_option_elem.each(function() {
              var self_size_item = $(this);
              var size_wrapper = self_size_item.closest('.size_option__wrapper');
              size_wrapper.css('display', 'block');

              if (!self_size_item.attr('disabled')) {
                available_sizes.push(self_size_item);
              }
            });
          }

          if(available_sizes.length>0){
            available_sizes[0].click();
          }
        }
      } else {

        var option_size_elem = $(".single-option--size[data-product-id="+product.id+"]");
        option_size_elem.each(function() {
          var self_only_size__option = $(this);
          var size_option__value = self_only_size__option.val();
          var size_wrapper = self_only_size__option.closest('.size_option__wrapper');

          for (let i = 0; i < product.variants.length; i++) {
            const element = product.variants[i];
            if (element.option1 == size_option__value) {
              if (element.available) {
                variants_available__counter++;
                size_wrapper.css('display', 'block');
              } else {
                self_only_size__option.attr('disabled', 'true');
                size_wrapper.css('display', 'block');
              }
            }
          }
        });
      }
    }
  }
}

function initPDPEventListeners() {
  $(document).on('click', '.klaviyo-trigger__link', function (e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    if (formId !== '') {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  });
  $('.check-store-availability__title').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });

  if($('.product-single__details')) {

    $(".tab-detail_header").first().addClass("active");
    $(".tab_content").first().show();

    $(document).on('click', '[data-tab]', function(event){
      event.preventDefault();

      var $this = $(this);
      var tabIndex = $this.attr("data-tab");

      $(".tab-detail_header").removeClass("active");
      $('[data-tab-content]').hide();
      $this.addClass("active");
      $('[data-tab-content ="'+ tabIndex +'"]').show();
    });
  }
  productInfoDrawer();
}

function productInfoDrawer() {
  var selectors = {
    openDrawer: '[data-product-info-drawer]',
    parent: '#PageContainer',
    insertAfter: '.shopify-section-group-header-group'
  };

  function init() {

    var $drawer,
        $drawerContent,
        $drawerBack,
        $parent,
        isOpen,
        backButtonTemplate;

    $drawer = $('<div id="productInfoDrawer" class="product-info-drawer"></div>');
    $drawerWrapper = $('<div class="product-info-drawer__wrapper"></div>');
    $drawerContent = $('<div class="product-info-drawer__content"></div>');
    $drawerBack = $('<button class="btn btn--large btn--text product-info-drawer__back"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-back" viewBox="0 0 26 20"><path d="M2.86 10l7.368 7.814a1 1 0 1 1-1.456 1.372l-8-8.485a1 1 0 0 1-.272-.686c0-.285.097-.53.272-.716l8-8.485a1 1 0 0 1 1.456 1.372L2.86 10z"></path><path d="M25 9c.552 0 1 .644 1 1s-.448 1-1 1H2a1 1 0 0 1 0-2h23z"></path></svg>Back to product</button>');
    $drawerOverlay = $('<button class="product-info-drawer__overlay"></button>');

    $drawer.append($drawerWrapper);
    $drawer.append($drawerOverlay);
    $drawerWrapper.append($drawerContent);
    $drawerWrapper.prepend($drawerBack);

    $parent = $(selectors.parent);
    $insertAfter = $(selectors.insertAfter);

    $drawer.insertBefore($insertAfter);

    function open() {
      $drawer.addClass('open');
      $parent.addClass('product-info-drawer-is-open');
      isOpen = true;
      $('html').css('overflow', 'hidden');
    }

    function close() {
      $drawer.removeClass('open');
      $parent.removeClass('product-info-drawer-is-open');
      isOpen = false;
      $('html').css('overflow', '');
    }

    $drawerBack.on('click', function() {
      close();
    });

    $drawerOverlay.on('click', function() {
      close();
    });

    $(selectors.openDrawer).on('click', function() {

      var template = $(this).data().productInfoDrawer;
      var content = theme.utils.getTemplate(template);
      var title = $(this).data().productInfoDrawerTitle;
      $drawerContent.attr('data-template', template);

      $drawerContent.html(content);

      if (title) {
        $drawerContent.prepend('<h2>' + title + '</h2>');
      }

      if (!isOpen) {
        open();
      }

    });

  }
  init();
}

function reinitializeProductSection(product) {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  setTimeout(()=> {
    reinitProductOptions(product);
  },500);
}

document.addEventListener('overdose:product-stitching-loaded', function() {
  grabToScrollTable('.size-guide-drawer__wrapper .table-responsive');
  grabToScrollTable('.size-guide-drawer__how-to-measure-carousel-wrapper');
  addSizeGuideSlider('.size-guide-drawer__how-to-measure-content');
  bindEventsSizeGuideDrawer();
  sizeGuideTabs();
  initPDPEventListeners();
});

document.addEventListener('overdose:child-product-stitching-loaded', function() {
  grabToScrollTable('.size-guide-drawer__wrapper .table-responsive');
  grabToScrollTable('.size-guide-drawer__how-to-measure-carousel-wrapper');
  addSizeGuideSlider('.size-guide-drawer__how-to-measure-content');
  bindEventsSizeGuideDrawer();
  sizeGuideTabs();
});

const ProductStitching = class extends HTMLElement {
  constructor() {
    super();
    this.preloadedSections = {};
    this.container = this.querySelector('.product-stitching__color-list');
    this.settings = this.getSettings('#swatches-settings');
    this.template = this.dataset.template || '';
    this.isBundleTemplate = theme.current.isBundleTemplate || false;
    if (this.template === 'product' && this.isBundleTemplate !== true) {
      this.initPopStateListener();
    }
    const hideIfEmpty = this.settings.hideIfEmpty;
    
    if (this.dataset.groupTag) {
      fetch(`/collections/${this.settings.allProductsCollection}/${encodeURIComponent(this.dataset.groupTag)}?view=data`)
          .then((response) => response.json())
          .then((responseJson) => {
            this.initSwatches(responseJson);
            this.attachColorSwatchEventListeners(responseJson);
            this.setCurrent();
            this.hideIfEmpty(hideIfEmpty);
          });
    } else {
      this.hideIfEmpty(hideIfEmpty);
    }
  }
  
  initPopStateListener() {
    window.addEventListener('popstate', (event) => this.handlePopState(event));
  }
  
  handlePopState(event) {
    if (event.state && event.state.path) {
      const url = event.state.path.replaceAll('/products/', '');
      this.updateSection(url);
    }
  }
  
  hideIfEmpty(hideIfEmpty) {
    if (!hideIfEmpty) return;
    
    const swatches = this.querySelectorAll('.product-stitching__color-list li');
    if (swatches.length > 0) return;
    
    this.classList.add("swatch-empty--hide");
  }
  
  getSettings(selector) {
    const settingsRawJson = document.querySelector(`${selector}`);
    if (!settingsRawJson) return {};
    return JSON.parse(settingsRawJson.innerHTML);
  }
  
  initSwatches(products) {
    let html = "";
    
    products.forEach(product => {
      // Fetch section only if sectionId is defined
      if (this.dataset.sectionId) {
        fetch(`/products/${product.handle}?sections=${this.dataset.sectionId}`)
            .then(response => {
              if (!response.ok) {
                throw new Error(`Error fetching section: ${response.statusText}`);
              }
              return response.json();
            })
            .then(data => {
              this.preloadedSections[product.handle] = data;
            })
            .catch(error => {
              console.error(`Request failed for ${product.handle}:`, error);
            });
      }
      
      const isAvailable = product.available || !this.settings.hideOptionsOutOfStock;
      if (isAvailable) {
        const swatchMedia = this.getSwatchMedia(product);
        const isActive = this.dataset.productHandle === product.handle;
        const liClass = isActive
            ? "current product-stitching__color-item--active product-stitching__color-item"
            : "product-stitching__color-item";
        
        html += `
        <li class="${liClass}">
          <a style="${swatchMedia}"
             data-handle="${product.handle}"
             href="${product.url}"
             data-href="/products/${product.handle}"
             data-product-id="${product.id}">
          </a>
        </li>
      `;
      }
    });
    
    if (html) {
      this.container.innerHTML = html;
    }
  }
  
  getSwatchMedia(product) {
    let swatchMedia = `background-image: url(${product.featured_image})`;
    switch (this.settings.swatchType) {
      case "hex_colour":
        const colourHex = product.color_hex;
        if (colourHex) swatchMedia = `background-color: ${colourHex}`;
        break;
      case "image_colour":
        const colourImage = product.color_image;
        if (colourImage) swatchMedia = `background-image: url(${colourImage})`;
        break;
      default:
        break;
    }
    return swatchMedia;
  }
  
  updateSection(url) {
    const sectionId = this.dataset.sectionId;
    const sectionContainer = document.querySelector(`#shopify-section-${sectionId}`);
    if (!sectionContainer) return;
    if (this.preloadedSections[url]) {
      this.replaceSection(sectionContainer, url, sectionId);
      this.runOnceAfterUpdate();
    } else {
      console.warn(`No preloaded section found for: ${url}. Fetching dynamically...`);
      fetch(`/products/${url}?sections=${sectionId}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            this.preloadedSections[url] = data;
            this.replaceSection(sectionContainer, url, sectionId);
            this.runOnceAfterUpdate();
          })
          .catch(error => {
            console.error('Failed to load section dynamically:', error);
          });
    }
  }
  
  replaceSection(sectionContainer, url, sectionId) {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = this.preloadedSections[url][`${sectionId}`];
    const newSection = tempContainer.querySelector(`#shopify-section-${sectionId}`);    
    
    const currentChildProductSection = this.closest('.product-single__offer');
    const currentProductHandle = this.dataset.productHandle;
    const childProduct = tempContainer.querySelector(`.product-single__offer[data-product-handle="${url}"]`);
    if (this.isBundleTemplate === true) {
      if (currentChildProductSection && childProduct) {
        childProduct.classList.add('product-single__offer--child', 'od-product-single__offer--child');
        const childProductInfo = childProduct.querySelector('.child-product-info');
        if (childProductInfo) {
          childProductInfo.style.removeProperty('display');
        }
        const productSinglePrice = childProduct.querySelector('.child-product-info ~ .product-single__price');
        if (productSinglePrice) {
          productSinglePrice.remove();
        }
        const exclusiveProductParent = childProduct.querySelector('.exclusive_product-parent');
        if (exclusiveProductParent) {
          exclusiveProductParent.remove();
        }
        const productStitching = childProduct.querySelector('product-stitching[data-is-bundle="false"]');
        if (productStitching) {
          productStitching.setAttribute('data-is-bundle', true);
        }
        const klaviyoTrigger = childProduct.querySelector('.klaviyo-trigger');
        if (klaviyoTrigger) {
          klaviyoTrigger.remove();
        }
        
        const productRawJson = childProduct.querySelector(`[data-offer-json]`);
        
        currentChildProductSection.replaceWith(childProduct);
        
        new Promise((resolve) => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              resolve();
            }, 0);
          });
        }).then(() => {
          if (productRawJson) {
            const productJson = JSON.parse(productRawJson.innerHTML);
            reinitializeProductSection(productJson);
          }
          document.dispatchEvent(new CustomEvent("overdose:child-product-stitching-loaded"));
        });
      }
    } else {
      if (newSection) {
        sectionContainer.replaceWith(newSection);
      } else {
        sectionContainer.innerHTML = this.preloadedSections[url][`${this.dataset.sectionId}`];
      }
      new Promise((resolve) => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            resolve();
          }, 0);
        });
      }).then(() => {
        const productJson = this.getSettings('[data-product-json]');
        reinitializeProductSection(productJson);
        document.dispatchEvent(new CustomEvent("overdose:product-stitching-loaded"));
      });
    }
  }
  
  runOnceAfterUpdate() {
    new Promise((resolve) => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          resolve();
        }, 0);
      });
    }).then(() => {
      this.attachColorSwatchEventListeners();
    });
  }
  
  attachColorSwatchEventListeners(products) {
    const self = this;
    const swatches = self.querySelectorAll('.product-stitching__color-list li');
    if (swatches.length > 0) {
      swatches.forEach(item => {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          const productHandle = this.querySelector('[data-handle]').getAttribute('data-handle');
          const productUrl = this.querySelector('[data-href]').getAttribute('data-href');
          const productId = this.querySelector('[data-product-id]').getAttribute('data-product-id');
          
          if (self.template === 'product') {
            if (self.isBundleTemplate !== true) {
              const urlParts = productUrl.split('?');
              const productPath = urlParts[0];
              history.pushState({path: productPath}, '', productPath);
            }
            self.updateSection(productHandle);
          } else {
            products.forEach((product, index) => {
              if (product.id.toString() === productId) {
                self.replaceImages(product, event);
              }
            });
          }
        });
      });
    }
    
  }
  
  _createImageElement(media, classes, sizes) {
    const previewImage = media["preview_image"], image = new Image(previewImage["width"], previewImage["height"]);
    image.className = classes;
    image.alt = media["alt"];
    image.sizes = sizes;
    image.src = previewImage["src"];
    image.srcset = generateSrcset(previewImage, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800]);
    return image;
  }
  
  async replaceImages(product, event) {
    const productCard = event.currentTarget.closest('.product-grid-item');
    if (productCard) {
      const primaryMediaElement = productCard.querySelector(".image-primary"), secondaryMediaElement = productCard.querySelector(".image-secondary");
      const newPrimaryMediaElement = this._createImageElement(product["featured_media"], primaryMediaElement.className, primaryMediaElement.sizes);
      if (primaryMediaElement.src !== newPrimaryMediaElement.src) {
        secondaryMediaElement ? secondaryMediaElement.replaceWith(this._createImageElement(product["media"][product["featured_media"]["position"]] || product["media"][1], secondaryMediaElement.className, secondaryMediaElement.sizes)) : null;
        await primaryMediaElement.animate({ opacity: [1, 0] }, { duration: 250, easing: "ease-in", fill: "forwards" }).finished;
        await new Promise((resolve) => newPrimaryMediaElement.complete ? resolve() : newPrimaryMediaElement.onload = () => resolve());
        primaryMediaElement.replaceWith(newPrimaryMediaElement);
        newPrimaryMediaElement.animate({ opacity: [0, 1] }, { duration: 250, easing: "ease-in" });
      }
    }
  }
  
  setCurrent() {
    const swatches = this.querySelectorAll('.product-stitching__color-list li');
    
    if (swatches.length > 0) {
      this.container.querySelector(`[data-handle="${this.dataset.productHandle}"]`)?.classList.add("selected");
    }
  }
};
if (!window.customElements.get("product-stitching")) {
  window.customElements.define("product-stitching", ProductStitching);
}

$(document).ready(function() {

  grabToScrollTable('.size-guide-drawer__wrapper .table-responsive');
  grabToScrollTable('.size-guide-drawer__how-to-measure-carousel-wrapper');
  addSizeGuideSlider('.size-guide-drawer__how-to-measure-content');
  bindEventsSizeGuideDrawer();
  sizeGuideTabs();
  
  // Object-fit polyfill initialise
  objectFitImages();

  // Hacky IE Lazysizes fix until we find a better solution or drop IE
  var ms_ie = !!window.navigator.userAgent.match(/MSIE|Trident/);
  if (ms_ie) {
    var lazyImageChecker = window.setInterval(function(){
      if(!$('img.lazyload').length) { window.clearInterval(lazyImageChecker);console.log(5); }
      $('img.lazyloading').each(function(){
        var imageSrc = $(this).attr('data-src');
        $(this).removeClass('lazyloading');
        $(this).get(0).src = imageSrc;
      });
    }, 3000);
  }

  var sections = new slate.Sections();
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  // sections.register('header-section', theme.HeaderSection);
  sections.register('new-header-section', theme.NewHeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('brand-values', theme.BrandValueSliders);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('featured-collections', theme.FeaturedCollections);
  sections.register('selected-collections-slider', theme.FeaturedCollections);
  sections.register('featured-product', theme.FeaturedProducts);
  sections.register('image-row', theme.ImageRows);
  sections.register('image-row-custom', theme.ImageRows);
  sections.register('hero-promo', theme.HeroPromo);
  sections.register('text-width-button', theme.HeroPromo);
  sections.register('content-slider', theme.ContentSliders);
  sections.register('latest-blog-posts', theme.LatestBlogPosts);
  sections.register('product-featured-points-editor', theme.ProductFeaturedPointsEditor);
  sections.register('cta-module', theme.CtaModule);
  sections.register('storelocator-filter', theme.StoreLocatorFilter);
  sections.register('article-features', theme.articleFeatures);
  sections.register('lookbook', theme.articleFeatures);
  sections.register('promo-form', theme.PromoForm);
  sections.register('store-locator', theme.StoreLocator);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  if ('NProgress' in window) {
    NProgress.configure({ showSpinner: false });
  }

  var promoBanner = document.querySelector('.promo-banner');
  if (promoBanner) {
    new theme.PromoBanner(promoBanner);
  }

  // $('.collection-filters a').click(function(e){
  //   e.preventDefault();
  //   var $this = $(this);
  //   $gridContainer = $('.collection-grid .row');

  //   $gridContainer.empty().addClass('loading');

  //   $.ajax({
  //     url: $this.attr('href') + '?view=json'
  //   }).done(function(data) {
  //     var products = JSON.parse(data);
  //     template = $('#collection_grid_tpl').html();
  //     for (var i = 0; i < products.length; i++) {
  //       var newProduct = template;
  //       product = products[i];

  //       newProduct = newProduct.replace(/\{url\}/g, product.url);
  //       newProduct = newProduct.replace(/\{title\}/g, product.title);
  //       newProduct = newProduct.replace(/\{price\}/g, product.price);
  //       newProduct = newProduct.replace(/\{image\}/g, product.featured_image);
  //       $gridContainer.append(newProduct);
  //     }
  //   });

  // });

  // #TODO Replace this with some nicer logic - Rivets, slick, etc.
  theme.RecentlyViewed.showRecentlyViewed( { howManyToShow:4 } );

  $(document).on('click', '.pagination a', function(e) {
    var $this = $(this);
    if (!$this.hasClass('pagination__view-all')) {
      var $paginationElem = $this.parents('.pagination');
      var targetContainer = $paginationElem.data('target-container');
      var targetContainerOffset = $paginationElem.data('offset') || 0;

      if (targetContainer) {
        e.preventDefault();
        var $parentElem = $(targetContainer).parent();
        var targetURL = $this.attr('href');
        var match = RegExp('[?&]page=([^&]*)').exec(targetURL);
        var targetPage = match && decodeURIComponent(match[1].replace(/\+/g, ' ')) || 1;

        $parentElem.addClass('ajax-loading');

        $('html, body').animate({ scrollTop: $(targetContainer).offset().top + targetContainerOffset }, 500 );
        // If page already exists
        if ($(targetContainer+'[data-page="'+targetPage+'"]').length) {
          $(targetContainer).not('[data-page="'+targetPage+'"]').fadeOut('slow');
          $(targetContainer+'[data-page="'+targetPage+'"]').fadeIn('slow');
          history.pushState({}, targetPage, targetURL);
          $parentElem.offset().top;
          $parentElem.removeClass('ajax-loading');
        } else {
          $.ajax({
            type: 'GET',
            dataType: 'html',
            url: targetURL + '&view=ajax',
            success: function(data) {
              $(targetContainer).not('[data-page="'+targetPage+'"]').fadeOut('slow');
              history.pushState({}, targetPage, targetURL);
              var appendData = $(data).find(targetContainer).prependTo($parentElem).hide();

              var $qtyInputs = $('input[type="number"]', appendData);
              $qtyInputs.each( function(){
                var $el = $(this);
                theme.QuantitySelectors.init($el);
              });

              appendData.fadeIn('slow');
              $parentElem.offset().top;
              $parentElem.removeClass('ajax-loading');
            }
          });
        }
      }
    }
  });

  theme.CurrencySelectors.init();

  // $('#MainContent').on('click.quickAddToCart', '.product-grid-item .btn-add-to-cart', function(evt){
  //   var $this = $(this);
  //   var $container = $('#product-grid-item-' + $this.data('product-id'));
  //   var qty = $('input[name="quantity"]', $container).val();
  //   var progressElementSelector = $('[data-progress-element]', $container).data('progress-element');
  //   var $progressElement = progressElementSelector ? $(progressElementSelector) : $(this);

  //   if (qty > 0) {
  //     var variantId = $('#variant-select-' + $this.data('product-id') + ' option:selected').val();

  //     CartJS.addItem(variantId, qty, {}, {
  //       "success": function(data, textStatus, jqXHR) {
  //         iziToast.success({
  //           title: 'Success!',
  //           message: 'Added to cart.',
  //           position: 'bottomCenter',
  //           theme: 'light',
  //           buttons: [
  //             ['<button>View</button>', function (instance, toast) {
  //               instance.hide(toast);
  //               theme.CartDrawer.open();
  //             }]
  //           ]
  //         });
  //       }
  //     });
  //   } else {
  //     $progressElement.removeClass('loading');
  //     $progressElement.addClass('error');
  //     window.setTimeout(function(){
  //       $progressElement.removeClass('error');
  //     }, 1500);
  //     evt.stopImmediatePropagation();
  //   }
  // });

  $('.product-grid-form__items select').on('change', function(){
    var $selectedOption = $(this).find('option:selected');
    var productId = $(this).parents('.product-grid-form').data('product-id');
    var variantPrice = Currency.formatMoney(Currency.convert($selectedOption.data('price'), shop.currency, Currency.currentCurrency), Currency.currentFormat);

    $('#product-grid-item-' + productId + ' span.money').html(variantPrice);
    $('#product-grid-item-' + productId + ' input[name="quantity"]').val(0);
    $('#product-grid-item-' + productId + ' .btn-add-to-cart').removeClass('active');
    // $(this).attr('data-currency-' + shop.currency, $(this).html());
  });

  $('.product-grid-form__items').on('update.qtySelector', 'input[name="quantity"]', function(evt){
  // $('.product-grid-form__items').on('click', '.js-qty-select button', function(){
  //   var productId = $(this).parents('.product-grid-form').data('product-id');
  //   var selectedVariantId = $('#variant-select-' + productId + ' option:selected').val();
  //   var variantQuantity = $(this).siblings('input[name="quantity"]').val();
  //   // CartJS.updateItemById({selectedVariantId, variantQuantity});
    var quantity = $(evt.target).val();
    var productId = $(this).parents('.product-grid-form').data('product-id');
    var $addButton = $('#product-grid-item-' + productId + ' .btn-add-to-cart');
    if (quantity > 0) {
      $addButton.addClass('active');
    } else {
      $addButton.removeClass('active');
    }
  });

  // var pacifierIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-pacifier" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><defs><style>.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px}</style></defs><title>pacifier</title><path d="M200.06 391.63a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z" fill="#faae3b"/><path d="M200.06 391.63c-.17.47-.41.92-.59 1.38.46.26.93.55 1.39.8A121.31 121.31 0 0 1 50 456a121.47 121.47 0 0 0 192.86-36.6 347.93 347.93 0 0 1-42.8-27.77z" fill="#f7991f"/><path d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z" fill="#7f2424"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7z" fill="#d73939"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-5.78 11.83-11.51 21.91-17.6 29.64 27.69 46.37 36 87.16 17.53 105.66a29.55 29.55 0 0 1-5.24 4.05c26.26 8.56 47.76 8 59.79-4.05 23.95-23.95 3.03-85.26-46.84-147.72zM214.23 197a209.6 209.6 0 0 1 22.05-12.21 71.18 71.18 0 0 0 12.42-7.64c-58.33-46.58-115.64-67.88-142.48-51 26.06 8.51 56.85 26.15 87.93 51 4.02 3.02 11.25 10.31 20.08 19.85z" fill="#be3434"/><path d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z" fill="#fcf1d1"/><path d="M454.83 45.17S410.2-3.45 353.31 15.71c28.41 9.25 47 29.46 47 29.46s76.5 70.08 0 146.59c-61.92 61.92-111.85 15.15-139.61 72-7.05 14.44-14 26.24-21.68 34.37 36.72 26.74 56.12 6.76 76.22-34.37 27.76-56.81 77.69-10 139.61-72 76.49-76.51-.02-146.59-.02-146.59z" fill="#f4ddaa"/><path class="cls-8" d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z"/><path class="cls-8" d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z"/><path class="cls-8" d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7zm-122.8 140.33a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z"/></svg>';
  // var dummyLinkTooltip = '<div id="dummy-link-tooltip" class="hidden">' + pacifierIcon + ' This is a dummy link.</div>';
  // $('body').append(dummyLinkTooltip);

  // tippy('a[href="#"]:not(.btn):not("#CartDrawer a")', {
  //   html: '#dummy-link-tooltip',
  //   size: 'small',
  //   animation: 'shift-toward',
  //   placement: 'right',
  //   trigger: 'mouseenter focus',
  // });

  // tippy('a[href="#"].btn', {
  //   html: '#dummy-link-tooltip',
  //   size: 'small',
  //   animation: 'shift-toward',
  //   placement: 'right',
  //   trigger: 'click',
  // });

  // Update 'last viewed of type' text to match last viewed object, e.g. breadcrumbs
  $('[data-last-viewed]').each(function(){
    var $this = $(this);
    var type = $this.data('last-viewed');
    var typeVar = 'lastViewed' + type.charAt(0).toUpperCase() + type.slice(1);
    var lastViewed = sessionStorage[typeVar];

    if (lastViewed !== undefined) {
      type += 's';
      var relatedObjects = $this.data('related-' + type);
      if (relatedObjects[lastViewed] !== undefined) {
        $this.text(relatedObjects[lastViewed].title);
      }
      if ($this[0].nodeName == "A") {
        $this.attr('href', '/' + type + '/' + lastViewed);
      }
    }
  });


  if (window.location.hostname == 'localhost') {
    document.documentElement.classList.add('localhost');
  }

  if (Shopify.designMode) {
    document.documentElement.classList.add('design-mode');
  }

  // Init scrollTo
  $('a[href^="#"]:not([href="#"]):not(.no-scroll)').click(function(e) {
    e.preventDefault();
    $(window).stop(true).scrollTo(this.hash, {
      duration: 700,
      interrupt: true,
      margin: true,
      offset: {left: 0, top: -1*($('.promo-banner').height() + $('[data-section-id="new-header"]').height())}
    });
  });

  try {
    theme.Wishlist.init();
  } catch(err) {
    console.error(err);
  }

});

function generateSrcset(imageObject, widths = []) {
  let src = imageObject["src"];
  if (!/^https:\/\//i.test(imageObject["src"])) {
    src = `https:${imageObject["src"]}`;
  }
  const imageUrl = new URL(src);
  return widths.filter((width) => width <= imageObject["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

function grabToScrollTable(selector) {
  const ele = document.querySelectorAll(selector);
  if (ele.length) {
    ele.forEach(element => {
      element.style.cursor = 'grab';
      
      let pos = {top: 0, left: 0, x: 0, y: 0};
      
      const mouseDownHandler = function (e) {
        element.style.cursor = 'grabbing';
        element.style.userSelect = 'none';
        
        pos = {
          left: element.scrollLeft,
          top: element.scrollTop,
          x: e.clientX,
          y: e.clientY,
        };
        
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
      };
      
      const mouseMoveHandler = function (e) {
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;
        
        element.scrollTop = pos.top - dy;
        element.scrollLeft = pos.left - dx;
      };
      
      const mouseUpHandler = function () {
        element.style.cursor = 'grab';
        element.style.removeProperty('user-select');
        
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };
      
      element.addEventListener('mousedown', mouseDownHandler);
    })
  }
}

function bindEventsSizeGuideDrawer() {
  const html = document.getElementsByTagName( 'html' )[0];
  const sizeGuideDrawerOpenTriggers = document.querySelectorAll(".size-guide-drawer__trigger-open");
  const sizeGuideDrawerCloseTriggers = document.querySelectorAll(".size-guide-drawer__trigger-close");
  sizeGuideDrawerOpenTriggers.forEach(sizeGuideDrawerOpenTrigger => {
    sizeGuideDrawerOpenTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      html.classList.add(`size-guide-drawer-is-open`);
      document.body.classList.add(`size-guide-drawer-is-open`);
      document.getElementById(`${event.currentTarget.dataset.sizeGuidePage}`)?.classList.add('active');
    });
  });
  sizeGuideDrawerCloseTriggers.forEach(sizeGuideDrawerCloseTrigger => {
    sizeGuideDrawerCloseTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      html.classList.remove('size-guide-drawer-is-open');
      document.body.classList.remove(`size-guide-drawer-is-open`);
      document.querySelectorAll('.size-guide-drawer').forEach((sizeGuideDrawer) => {
        sizeGuideDrawer.classList.remove('active');
      });
    });
  });
  const sizeGuideSwitchers = document.querySelectorAll(".size-guide-switcher .switcher");
  if (sizeGuideSwitchers.length) {
    sizeGuideSwitchers.forEach(sizeGuideSwitcher => {
      const checkbox = sizeGuideSwitcher.querySelector('input[type="checkbox"]');
      checkbox.addEventListener('change', function() {
        document.body.classList.toggle('switcher-in', this.checked);
      });
    });
  }
}

function sizeGuideTabs() {
  const sizeGuideDrawerTabTitles = document.querySelectorAll('.size-guide-drawer__tab-title');
  const sizeGuideDrawerTabContents = document.querySelectorAll('.size-guide-drawer__tab-content');
  if (sizeGuideDrawerTabTitles.length) {
    sizeGuideDrawerTabTitles.forEach(sizeGuideDrawerTabTitle => {
      sizeGuideDrawerTabTitle.addEventListener('click', function(e) {
        e.preventDefault();
        const sizeGuideTabs = e.currentTarget.closest('.size-guide-drawer__tabs')
        
        let targetId = e.currentTarget.getAttribute("href");
        let targetContent = sizeGuideTabs.querySelector(targetId);
        
        if (targetContent) {
          
          sizeGuideTabs.querySelectorAll('.size-guide-drawer__tab-title').forEach(function(title) {
            title.classList.remove("active");
          });
          
          sizeGuideTabs.querySelectorAll('.size-guide-drawer__tab-content').forEach(function(content) {
            content.classList.remove("active");
          });
          
          e.currentTarget.classList.add("active");
          targetContent.classList.add("active");
        }
      });
    });
  }
}

function addSizeGuideSlider(selector) {
  const wrappers = document.querySelectorAll(selector);
  wrappers.forEach(wrapper => {
    const slider = wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel');
    const itemQty = wrapper.querySelectorAll('.size-guide-drawer__how-to-measure-carousel-item').length;
    
    if (slider) {
      slider.setAttribute('data-items', itemQty);
      
      if (wrapper.querySelectorAll('.size-guide-drawer__how-to-measure-carousel-item').length > 2 && wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-left') === null) {
        wrapper.innerHTML += '<button type="button" class="btn size-guide-drawer__how-to-measure-carousel-left"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" class="btn size-guide-drawer__how-to-measure-carousel-right"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      }
      if (wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-left') !== null) {
        wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-left').addEventListener("click", function (e) {
          scrollToLeft();
        });
      }
      if (wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-right') !== null) {
        wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-right').addEventListener("click", function () {
          scrollToRight();
        });
      }
      
      function scrollToLeft() {
        const container = wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-wrapper');
        const collection = wrapper.querySelectorAll(".size-guide-drawer__how-to-measure-carousel-item");
        let lastLeft = 0;
        for (let i = 0; i < collection.length; i++) {
          if (collection[i].getBoundingClientRect().left - 50 < container.getBoundingClientRect().left) {
            lastLeft = collection[i].getBoundingClientRect().left - 50 - container.getBoundingClientRect().left + container.scrollLeft;
          }
        }
        
        wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-wrapper').scrollTo({
          left: lastLeft,
          behavior: "smooth"
        });
      }
      
      // Function to scroll to the right
      function scrollToRight() {
        const container = wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-wrapper');
        const collection = wrapper.querySelectorAll(".size-guide-drawer__how-to-measure-carousel-item");
        let lastLeft = 0;
        for (let i = 0; i < collection.length; i++) {
          if (collection[i].getBoundingClientRect().left - 1 - 50 < container.getBoundingClientRect().left) {
            lastLeft = collection[i + 1].getBoundingClientRect().left - 50 - container.getBoundingClientRect().left + container.scrollLeft;
          }
        }
        
        wrapper.querySelector('.size-guide-drawer__how-to-measure-carousel-wrapper').scrollTo({
          left: lastLeft,
          behavior: "smooth"
        });
      }
    }
  });
}

// mobile functional radio like selector
(function(){
  $(document).ready(function(){

    $(".custom_select__field, .current_option .arrow_icon").on('click', function(){

      $('.options_wrapper').not($(this).closest('.variants_container').find('.options_wrapper')).removeClass('active');
      $(this).closest('.variants_container').find('.options_wrapper').toggleClass('active');
    });

    $(".single-option--length, .single-option--size").on('click', function() {
      var self = $(this);

      self.closest('.options_wrapper').removeClass('active');
    });
  });
}());

// details tabs on product page
(function(){
  $(document).ready(function(){
    $('.check-store-availability__title').on('click', function(e) {
      event.preventDefault();
      $(this).toggleClass('active');
    });

    if($('product-single__details')) {

      $(".tab-detail_header").first().addClass("active");
      $(".tab_content").first().show();

      $('[data-tab]').on('click', function(){
        event.preventDefault();

        var $this = $(this);
        var tabIndex = $this.attr("data-tab");

        // $(".tab-detail_header").removeClass("active");
        // $('[data-tab-content]').hide();

        if($this.hasClass("active")) {
          console.log("casca");
          $this.removeClass("active");
          $('[data-tab-content ="'+ tabIndex +'"]').hide();
        } else {
          $(".tab-detail_header").removeClass("active");
          $('[data-tab-content]').hide();
          $this.addClass("active");
          $('[data-tab-content ="'+ tabIndex +'"]').show();
        }
      });
    }
  });
}());

// size guarantee logic
(function(){
  var size = document.querySelectorAll(".size_guarant");

  if(size) {
    size.forEach(function(item) {

      item.addEventListener("change", function() {

        let elem = this.parentElement.querySelector(".size_guarantee_option");

        if (this.checked == true) {
          elem.disabled = false;
        } else {
          elem.disabled = true;
        }
      });
    });
  }
}());

$(document).ready((e)=>{
  $('.mobile-menu-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    draggable: false,
    prevArrow: '.menu__prev',
    nextArrow: '.menu__next',
  });

})


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function delay(fn, ms) {
  let timer = 0
  return function(...args) {
    clearTimeout(timer)
    timer = setTimeout(fn.bind(this, ...args), ms || 0)
  }
}

// Instant search for header
$('#Search').on('keyup', delay(function (e) {
  var query = this.value;
  var old_url = window.location.href;
  console.log("here key up 2")

  // Set the cancel button to take the user back to their original url location
  $('[data-site-search-cancel]').attr('href', old_url);

  // Update our current page url, it needs to get updated for the Boost Search API call
  history.pushState(null, "Search", 'https://' + window.location.hostname +'/search?q=' + query);

  // Show our hidden html that had the boost elements
  $('#site-search-container').show();

  // Hide the main content that was on the site
  $('#MainContent').remove();


  // Reset the bcsf filter configs so that it doesn't do a search within a collection
  if(window.bcsffilter) {
    window.bcsffilter.collectionId = 0;
  }
  if(bcSfFilterMainConfig) {
    bcSfFilterMainConfig.general.collection_id = 0;
    bcSfFilterMainConfig.general.collection_id = 0
    bcSfFilterMainConfig.general.collection_handle = "";
  }

  // Init the Boost filter and search
  theme.ProductFilterAndSearch.init();

  // Hide the search modal in the header
  $('body').removeClass('search-modal-open');

  // Change the focus to the new collection search input that is now shown
  $('.collection__search input[type="search"]').val(query);
  $('.collection__search input[type="search"]').focus();
  $('.collection__search [data-site-search-delete]').show();

  // We hide the header search now to avoid conflict issues
  $('[data-search-modal]').hide();

}, 500));

$('.collection__search #Search').on('keyup', delay(function (e) {
  var query = this.value;
  if (e.key === 'Enter' || e.keyCode === 13) {
    console.log("here key ENTER")
    e.preventDefault();
  }else{
    if(query) {
      $('.collection__search [data-site-search-delete]').show();
      history.pushState(null, "Search", 'https://' + window.location.hostname +'/search?q=' + query);
      theme.ProductFilterAndSearch.init();
    }
  }



}, 500));
$(".header-sidebar__search-delete[data-site-search-delete]").click(function(event){
  if (event.screenX === 0) {

  }
  else {

    $('.collection__search #Search').val('');
    $('.collection__search #Search').focus();
    $('[data-site-search-delete]').hide();
  }

  return false; // Allows me to read the console before the form submits!
});



// $('.product-form__cart-submit').on('click', function(){
//   ajaxUpsell.slick({
//     accessibility: true,
//     arrows: true,
//     draggable: false,
//     nextArrow: '.ajax__next',
//     prevArrow: '.ajax__prev',
//     slidesToShow: 1,
//     slidesToScroll: 1
//   });
// });

// $('.cart__toggle').on('click', function(){
//   ajaxUpsell.slick({
//     accessibility: true,
//     arrows: true,
//     draggable: false,
//     nextArrow: '.ajax__next',
//     prevArrow: '.ajax__prev',
//     slidesToShow: 1,
//     slidesToScroll: 1
//   });
// });
